var Hs = Object.defineProperty, Gs = Object.defineProperties;
var Fs = Object.getOwnPropertyDescriptors;
var Ct = Object.getOwnPropertySymbols, js = Object.getPrototypeOf, ui = Object.prototype.hasOwnProperty, ci = Object.prototype.propertyIsEnumerable, Vs = Reflect.get;
var li = (e) => {
  throw TypeError(e);
};
var wr = (e, t, r) => t in e ? Hs(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, E = (e, t) => {
  for (var r in t || (t = {}))
    ui.call(t, r) && wr(e, r, t[r]);
  if (Ct)
    for (var r of Ct(t))
      ci.call(t, r) && wr(e, r, t[r]);
  return e;
}, x = (e, t) => Gs(e, Fs(t));
var Ar = (e, t) => {
  var r = {};
  for (var n in e)
    ui.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && Ct)
    for (var n of Ct(e))
      t.indexOf(n) < 0 && ci.call(e, n) && (r[n] = e[n]);
  return r;
};
var b = (e, t, r) => wr(e, typeof t != "symbol" ? t + "" : t, r), fi = (e, t, r) => t.has(e) || li("Cannot " + r);
var di = (e, t, r) => (fi(e, t, "read from private field"), r ? r.call(e) : t.get(e)), pi = (e, t, r) => t.has(e) ? li("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), hi = (e, t, r, n) => (fi(e, t, "write to private field"), n ? n.call(e, r) : t.set(e, r), r);
var Or = (e, t, r) => Vs(js(e), r, t);
var U = (e, t, r) => new Promise((n, i) => {
  var o = (c) => {
    try {
      u(r.next(c));
    } catch (s) {
      i(s);
    }
  }, a = (c) => {
    try {
      u(r.throw(c));
    } catch (s) {
      i(s);
    }
  }, u = (c) => c.done ? n(c.value) : Promise.resolve(c.value).then(o, a);
  u((r = r.apply(e, t)).next());
});
import { U as Do, W as $s, X as zs, Y as fn, s as Ye, Z as he, _ as ko, $ as Uo, a0 as Bo, a1 as ye, P as Xs, a2 as qs, a3 as Ho, x as Ws, a4 as Ks, a5 as Ys, a6 as Js, a7 as Zs, a8 as Qs, a9 as Xt, q as eu, aa as Rr, ab as Lr, ac as tu, ad as ru, c as nu, n as iu, o as ou, L as au, h as su, t as uu, ae as cu, E as lu, af as fu, ag as du, I as Pr, J as _i, ah as pu, ai as hu, K as _u, N as vu, O as yu, Q as gu, R as mu, T as Eu, aj as Tu, ak as Su, al as vi, am as bu, an as wu, ao as Au } from "./common-BjaGmQrE.js";
import { a as j, b as Ou, c as Ru, d as Lu, s as Pu, i as Go } from "./buffer-BjzLorpP.js";
import { g as yi, L as Nu } from "./LDObserve-DhF3vCDR.js";
const Fo = [
  "assert",
  "count",
  "countReset",
  "debug",
  "dir",
  "dirxml",
  "error",
  "group",
  "groupCollapsed",
  "groupEnd",
  "info",
  "log",
  "table",
  "time",
  "timeEnd",
  "timeLog",
  "trace",
  "warn"
];
var $ = /* @__PURE__ */ ((e) => (e.DeviceMemory = "DeviceMemory", e.ViewportHeight = "ViewportHeight", e.ViewportWidth = "ViewportWidth", e.ScreenHeight = "ScreenHeight", e.ScreenWidth = "ScreenWidth", e.ViewportArea = "ViewportArea", e))($ || {}), X = /* @__PURE__ */ ((e) => (e.Device = "Device", e.WebVital = "WebVital", e.Performance = "Performance", e.Frontend = "Frontend", e.Backend = "Backend", e))(X || {}), jo = { exports: {} }, Nr = { exports: {} }, gi;
function Cu() {
  return gi || (gi = 1, function(e, t) {
    (function(r, n) {
      e.exports = n();
    })(Do, function() {
      function r(p) {
        return !isNaN(parseFloat(p)) && isFinite(p);
      }
      function n(p) {
        return p.charAt(0).toUpperCase() + p.substring(1);
      }
      function i(p) {
        return function() {
          return this[p];
        };
      }
      var o = ["isConstructor", "isEval", "isNative", "isToplevel"], a = ["columnNumber", "lineNumber"], u = ["fileName", "functionName", "source"], c = ["args"], s = ["evalOrigin"], l = o.concat(a, u, c, s);
      function f(p) {
        if (p)
          for (var v = 0; v < l.length; v++)
            p[l[v]] !== void 0 && this["set" + n(l[v])](p[l[v]]);
      }
      f.prototype = {
        getArgs: function() {
          return this.args;
        },
        setArgs: function(p) {
          if (Object.prototype.toString.call(p) !== "[object Array]")
            throw new TypeError("Args must be an Array");
          this.args = p;
        },
        getEvalOrigin: function() {
          return this.evalOrigin;
        },
        setEvalOrigin: function(p) {
          if (p instanceof f)
            this.evalOrigin = p;
          else if (p instanceof Object)
            this.evalOrigin = new f(p);
          else
            throw new TypeError("Eval Origin must be an Object or StackFrame");
        },
        toString: function() {
          var p = this.getFileName() || "", v = this.getLineNumber() || "", y = this.getColumnNumber() || "", m = this.getFunctionName() || "";
          return this.getIsEval() ? p ? "[eval] (" + p + ":" + v + ":" + y + ")" : "[eval]:" + v + ":" + y : m ? m + " (" + p + ":" + v + ":" + y + ")" : p + ":" + v + ":" + y;
        }
      }, f.fromString = function(v) {
        var y = v.indexOf("("), m = v.lastIndexOf(")"), w = v.substring(0, y), A = v.substring(y + 1, m).split(","), R = v.substring(m + 1);
        if (R.indexOf("@") === 0)
          var C = /@(.+?)(?::(\d+))?(?::(\d+))?$/.exec(R, ""), I = C[1], P = C[2], V = C[3];
        return new f({
          functionName: w,
          args: A || void 0,
          fileName: I,
          lineNumber: P || void 0,
          columnNumber: V || void 0
        });
      };
      for (var d = 0; d < o.length; d++)
        f.prototype["get" + n(o[d])] = i(o[d]), f.prototype["set" + n(o[d])] = /* @__PURE__ */ function(p) {
          return function(v) {
            this[p] = !!v;
          };
        }(o[d]);
      for (var h = 0; h < a.length; h++)
        f.prototype["get" + n(a[h])] = i(a[h]), f.prototype["set" + n(a[h])] = /* @__PURE__ */ function(p) {
          return function(v) {
            if (!r(v))
              throw new TypeError(p + " must be a Number");
            this[p] = Number(v);
          };
        }(a[h]);
      for (var _ = 0; _ < u.length; _++)
        f.prototype["get" + n(u[_])] = i(u[_]), f.prototype["set" + n(u[_])] = /* @__PURE__ */ function(p) {
          return function(v) {
            this[p] = String(v);
          };
        }(u[_]);
      return f;
    });
  }(Nr)), Nr.exports;
}
(function(e, t) {
  (function(r, n) {
    e.exports = n(Cu());
  })(Do, function(n) {
    var i = /(^|@)\S+:\d+/, o = /^\s*at .*(\S+:\d+|\(native\))/m, a = /^(eval@)?(\[native code])?$/;
    return {
      /**
       * Given an Error object, extract the most information from it.
       *
       * @param {Error} error object
       * @return {Array} of StackFrames
       */
      parse: function(c) {
        if (typeof c.stacktrace != "undefined" || typeof c["opera#sourceloc"] != "undefined")
          return this.parseOpera(c);
        if (c.stack && c.stack.match(o))
          return this.parseV8OrIE(c);
        if (c.stack)
          return this.parseFFOrSafari(c);
        throw new Error("Cannot parse given Error object");
      },
      // Separate line and column numbers from a string of the form: (URI:Line:Column)
      extractLocation: function(c) {
        if (c.indexOf(":") === -1)
          return [c];
        var s = /(.+?)(?::(\d+))?(?::(\d+))?$/, l = s.exec(c.replace(/[()]/g, ""));
        return [l[1], l[2] || void 0, l[3] || void 0];
      },
      parseV8OrIE: function(c) {
        var s = c.stack.split(`
`).filter(function(l) {
          return !!l.match(o);
        }, this);
        return s.map(function(l) {
          l.indexOf("(eval ") > -1 && (l = l.replace(/eval code/g, "eval").replace(/(\(eval at [^()]*)|(\),.*$)/g, ""));
          var f = l.replace(/^\s+/, "").replace(/\(eval code/g, "("), d = f.match(/ (\((.+):(\d+):(\d+)\)$)/);
          f = d ? f.replace(d[0], "") : f;
          var h = f.split(/\s+/).slice(1), _ = this.extractLocation(d ? d[1] : h.pop()), p = h.join(" ") || void 0, v = ["eval", "<anonymous>"].indexOf(_[0]) > -1 ? void 0 : _[0];
          return new n({
            functionName: p,
            fileName: v,
            lineNumber: _[1],
            columnNumber: _[2],
            source: l
          });
        }, this);
      },
      parseFFOrSafari: function(c) {
        var s = c.stack.split(`
`).filter(function(l) {
          return !l.match(a);
        }, this);
        return s.map(function(l) {
          if (l.indexOf(" > eval") > -1 && (l = l.replace(/ line (\d+)(?: > eval line \d+)* > eval:\d+:\d+/g, ":$1")), l.indexOf("@") === -1 && l.indexOf(":") === -1)
            return new n({
              functionName: l
            });
          var f = /((.*".+"[^@]*)?[^@]*)(?:@)/, d = l.match(f), h = d && d[1] ? d[1] : void 0, _ = this.extractLocation(l.replace(f, ""));
          return new n({
            functionName: h,
            fileName: _[0],
            lineNumber: _[1],
            columnNumber: _[2],
            source: l
          });
        }, this);
      },
      parseOpera: function(c) {
        return !c.stacktrace || c.message.indexOf(`
`) > -1 && c.message.split(`
`).length > c.stacktrace.split(`
`).length ? this.parseOpera9(c) : c.stack ? this.parseOpera11(c) : this.parseOpera10(c);
      },
      parseOpera9: function(c) {
        for (var s = /Line (\d+).*script (?:in )?(\S+)/i, l = c.message.split(`
`), f = [], d = 2, h = l.length; d < h; d += 2) {
          var _ = s.exec(l[d]);
          _ && f.push(new n({
            fileName: _[2],
            lineNumber: _[1],
            source: l[d]
          }));
        }
        return f;
      },
      parseOpera10: function(c) {
        for (var s = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i, l = c.stacktrace.split(`
`), f = [], d = 0, h = l.length; d < h; d += 2) {
          var _ = s.exec(l[d]);
          _ && f.push(
            new n({
              functionName: _[3] || void 0,
              fileName: _[2],
              lineNumber: _[1],
              source: l[d]
            })
          );
        }
        return f;
      },
      // Opera 10.65+ Error.stack very similar to FF/Safari
      parseOpera11: function(c) {
        var s = c.stack.split(`
`).filter(function(l) {
          return !!l.match(i) && !l.match(/^Error created at/);
        }, this);
        return s.map(function(l) {
          var f = l.split("@"), d = this.extractLocation(f.pop()), h = f.shift() || "", _ = h.replace(/<anonymous function(: (\w+))?>/, "$2").replace(/\([^)]*\)/g, "") || void 0, p;
          h.match(/\(([^)]*)\)/) && (p = h.replace(/^[^(]+\(([^)]*)\)$/, "$1"));
          var v = p === void 0 || p === "[arguments not available]" ? void 0 : p.split(",");
          return new n({
            functionName: _,
            args: v,
            fileName: d[0],
            lineNumber: d[1],
            columnNumber: d[2],
            source: l
          });
        }, this);
      }
    };
  });
})(jo);
var Mu = jo.exports;
const mi = /* @__PURE__ */ $s(Mu);
function hr(e) {
  try {
    return mi.parse(e);
  } catch (t) {
    try {
      return mi.parse(new Error());
    } catch (r) {
      return j("warn", "Highlight Warning: failed to parse error", {
        originalError: t,
        secondaryError: r
      }), [];
    }
  }
}
const Ei = (e, t, r) => {
  const n = _r(
    t,
    e.headers,
    r
  );
  return x(E({}, e), {
    headers: n
  });
}, _r = (e, t, r) => {
  var i, o;
  const n = E({}, t);
  return r ? ((i = Object.keys(n)) == null || i.forEach((a) => {
    [...r].includes(a == null ? void 0 : a.toLowerCase()) || (n[a] = "[REDACTED]");
  }), n) : ((o = Object.keys(n)) == null || o.forEach((a) => {
    [...Iu, ...e].includes(
      a == null ? void 0 : a.toLowerCase()
    ) && (n[a] = "[REDACTED]");
  }), n);
}, Iu = [
  "authorization",
  "cookie",
  "proxy-authorization",
  "set-cookie",
  "token"
], xu = [
  "https://www.googleapis.com/identitytoolkit",
  "https://securetoken.googleapis.com",
  // Intake endpoints of other telemetry vendors. Their batched payloads are
  // large, frequent and never interesting as spans; on one POS deployment
  // they were 20% of all request spans and gigabytes of captured bodies.
  "browser-intake-datadoghq.com",
  "browser-intake-datadoghq.eu",
  "browser-intake-us3-datadoghq.com",
  "browser-intake-us5-datadoghq.com",
  "browser-intake-ap1-datadoghq.com",
  "browser-intake-ddog-gov.com",
  "r.lr-ingest.io",
  "r.lr-in-prod.com",
  "r.logrocket.io",
  "data.pendo.io",
  "ingest.sentry.io",
  "ingest.us.sentry.io",
  "ingest.de.sentry.io",
  "bam.nr-data.net",
  "bam-cell.nr-data.net",
  "rs.fullstory.com",
  "in.hotjar.com",
  "api2.amplitude.com",
  "api.mixpanel.com",
  "api.segment.io/v1",
  "google-analytics.com/g/collect",
  "analytics.google.com/g/collect"
], Du = [
  "awsaccesskeyid",
  "signature",
  "sig",
  "x-goog-signature",
  "access_token",
  "id_token",
  "token",
  "code",
  "refresh_token",
  "session_state"
], ku = [
  "access_token",
  "id_token",
  "token",
  "code",
  "refresh_token",
  "session_state"
], Uu = /(\/eval\/[0-9a-f]{24}\/|\/sdk\/evalx?\/[0-9a-f]{24}\/(?:contexts|users)\/)([A-Za-z0-9+_=%-]{8,})/g, Qt = (e) => typeof e != "string" || !e.includes("eval") ? e : e.replace(Uu, "$1REDACTED"), Vo = (e) => {
  var t, r;
  try {
    return new URL(e);
  } catch (n) {
    return new URL(e, (r = (t = globalThis.location) == null ? void 0 : t.origin) != null ? r : "http://example.com");
  }
}, Bu = (e) => {
  if (!e || e === "#") return "";
  const t = e.slice(1);
  if (!t.includes("=")) return e;
  const r = t.indexOf("?"), n = r >= 0 ? t.slice(r + 1) : t, i = new URLSearchParams(n);
  for (const o of i.keys())
    if (ku.includes(o.toLowerCase()))
      return "";
  return e;
}, dn = (e) => {
  try {
    const t = Vo(e);
    (t.username || t.password) && (t.username = "REDACTED", t.password = "REDACTED"), t.pathname = Qt(t.pathname);
    const r = t.searchParams;
    Du.forEach((i) => {
      for (const o of Array.from(r.keys()))
        o.toLowerCase() === i && r.set(o, "REDACTED");
    });
    const n = Bu(t.hash);
    if (t.hash = n, !e.includes("://") && !e.startsWith("//"))
      return t.pathname + t.search + n;
    if (e.startsWith("//")) {
      let i = "//";
      return (t.username || t.password) && (i += t.username + ":" + t.password + "@"), i += t.host + t.pathname + t.search + n, i;
    }
    return t.toString();
  } catch (t) {
    return e;
  }
}, Hu = /^\s*(?:(?:debug|info|warn|error|none):\s*)?\[LaunchDarkly\]/, Gu = (e) => {
  const t = e[0];
  return typeof t == "string" && Hu.test(t);
}, Kg = {
  level: [...Fo],
  logger: "console",
  stringifyOptions: {
    depthOfLimit: 10,
    numOfKeysLimit: 100,
    stringLengthLimit: 1e3
  }
};
function Fu(e, t) {
  const r = t.logger;
  if (!r)
    return () => {
    };
  let n;
  typeof r == "string" ? n = window[r] : n = r;
  const i = [];
  if (t.level.includes("error") && window) {
    const a = (u) => {
      const { message: c, error: s } = u;
      let l = [];
      s && (l = hr(s));
      const f = [
        fn(c, t.stringifyOptions)
      ];
      e({
        type: "Error",
        trace: l,
        time: Date.now(),
        value: f
      });
    };
    window.addEventListener("error", a), i.push(() => {
      window && window.removeEventListener("error", a);
    });
  }
  for (const a of t.level)
    i.push(o(n, a));
  return () => {
    i.forEach((a) => a());
  };
  function o(a, u) {
    return a[u] ? zs(a, u, (c) => (...s) => {
      if (c.apply(this, s), !Ou() && !(!t.recordLaunchDarklySdkLogs && Gu(s)))
        try {
          e(ju(u, t, ...s));
        } catch (l) {
          c("highlight logger error:", l, ...s);
        }
    }) : () => {
    };
  }
}
function ju(e, t, ...r) {
  const n = hr(new Error()), i = (t.serializeConsoleAttributes ? r.map(
    (o) => typeof o == "object" ? fn(o, t.stringifyOptions) : o
  ) : r.filter((o) => typeof o != "object").map((o) => `${o}`)).map((o) => typeof o == "string" ? Qt(o) : o);
  return {
    type: e,
    trace: n,
    value: i,
    attributes: Qt(
      fn(
        r.filter((o) => typeof o == "object").reduce((o, a) => E(E({}, o), a), {}),
        t.stringifyOptions
      )
    ),
    time: Date.now()
  };
}
const Vu = {
  start: 0,
  end: 3
}, $u = {
  start: 4,
  end: 5
}, Cr = {
  start: 6,
  end: 7
}, Mr = {
  start: 8,
  end: 8
}, zu = {
  start: 9,
  end: 9
}, Xu = {
  start: 10,
  end: 15
};
function qu() {
  if (crypto && crypto.getRandomValues) {
    const t = new Uint8Array(16);
    return crypto.getRandomValues(t), [...t.values()];
  }
  const e = [];
  for (let t = 0; t < 16; t += 1)
    e.push(Math.floor(Math.random() * 256));
  return e;
}
function je(e, t) {
  let r = "";
  for (let n = t.start; n <= t.end; n += 1)
    r += e[n].toString(16).padStart(2, "0");
  return r;
}
function Wu(e) {
  return e[Mr.start] = (e[Mr.start] | 128) & 191, e[Cr.start] = e[Cr.start] & 15 | 64, `${je(e, Vu)}-${je(e, $u)}-${je(e, Cr)}-${je(e, Mr)}${je(e, zu)}-${je(e, Xu)}`;
}
function Ku() {
  const e = qu();
  return Wu(e);
}
function pn() {
  return typeof crypto != "undefined" && typeof crypto.randomUUID == "function" ? crypto.randomUUID() : Ku();
}
function Ir(e, t, r, n) {
  var c, s, l, f;
  let i = n != null ? n : t, o = hr(i), a = {};
  if (t instanceof Error) {
    const d = t.cause;
    t = t.message, d && (a = { "exception.cause": d });
  }
  const u = Ju(o);
  e({
    error: i,
    event: Ye(t),
    type: "window.onerror",
    url: window.location.href,
    source: r != null ? r : "",
    lineNumber: (c = u[0]) != null && c.lineNumber ? (s = u[0]) == null ? void 0 : s.lineNumber : 0,
    columnNumber: (l = u[0]) != null && l.columnNumber ? (f = u[0]) == null ? void 0 : f.columnNumber : 0,
    stackTrace: u,
    timestamp: (/* @__PURE__ */ new Date()).toISOString(),
    payload: a ? Ye(a) : void 0,
    id: pn()
  });
}
const Yu = (e, { enablePromisePatch: t }) => {
  if (typeof window == "undefined") return () => {
  };
  const r = window.onerror;
  window.onerror = (a, u, c, s, l) => {
    Ir(e, a, u, l);
  };
  const n = window.onunhandledrejection;
  window.onunhandledrejection = (a) => {
    if (a.reason) {
      const u = a.promise;
      u.getStack ? Ir(
        e,
        a.reason,
        a.type,
        u.getStack()
      ) : Ir(e, a.reason, a.type);
    }
  };
  const i = window.Promise, o = class extends i {
    constructor(c) {
      super(c);
      b(this, "promiseCreationError");
      this.promiseCreationError = new Error();
    }
    getStack() {
      return this.promiseCreationError;
    }
    static shouldPatch() {
      const c = typeof window.Zone == "undefined";
      return t && c;
    }
  };
  return o.shouldPatch() && (window.Promise = o), () => {
    window.Promise = i, window.onunhandledrejection = n, window.onerror = r;
  };
}, Ju = (e) => {
  var r, n;
  if (e.length === 0)
    return e;
  const t = e[0];
  return (r = t.fileName) != null && r.includes("highlight.run") || (n = t.fileName) != null && n.includes("highlight.io") || t.functionName === "new highlightPromise" ? e.slice(1) : e;
}, Zu = [
  '["\\"Script error.\\""]',
  '"Script error."',
  '["\\"Load failed.\\""]',
  '"Load failed."',
  '["\\"Network request failed.\\""]',
  '"Network request failed."',
  '["\\"Document is not focused.\\""]',
  '"Document is not focused."',
  '["\\"Failed to fetch\\""]',
  '"Failed to fetch"',
  '[{"isTrusted":true}]',
  '{"isTrusted":true}',
  '["{}"]',
  '"{}"',
  '[""]',
  '""',
  '["\\"\\""]',
  '""'
], Qu = [
  "websocket error",
  '\\"ResizeObserver loop'
];
var ec = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {}, Re = "1.9.0", Ti = /^(\d+)\.(\d+)\.(\d+)(-(.+))?$/;
function tc(e) {
  var t = /* @__PURE__ */ new Set([e]), r = /* @__PURE__ */ new Set(), n = e.match(Ti);
  if (!n)
    return function() {
      return !1;
    };
  var i = {
    major: +n[1],
    minor: +n[2],
    patch: +n[3],
    prerelease: n[4]
  };
  if (i.prerelease != null)
    return function(c) {
      return c === e;
    };
  function o(u) {
    return r.add(u), !1;
  }
  function a(u) {
    return t.add(u), !0;
  }
  return function(c) {
    if (t.has(c))
      return !0;
    if (r.has(c))
      return !1;
    var s = c.match(Ti);
    if (!s)
      return o(c);
    var l = {
      major: +s[1],
      minor: +s[2],
      patch: +s[3],
      prerelease: s[4]
    };
    return l.prerelease != null || i.major !== l.major ? o(c) : i.major === 0 ? i.minor === l.minor && i.patch <= l.patch ? a(c) : o(c) : i.minor <= l.minor ? a(c) : o(c);
  };
}
var rc = tc(Re), nc = Re.split(".")[0], yt = Symbol.for("opentelemetry.js.api." + nc), gt = ec;
function At(e, t, r, n) {
  var i;
  n === void 0 && (n = !1);
  var o = gt[yt] = (i = gt[yt]) !== null && i !== void 0 ? i : {
    version: Re
  };
  if (!n && o[e]) {
    var a = new Error("@opentelemetry/api: Attempted duplicate registration of API: " + e);
    return r.error(a.stack || a.message), !1;
  }
  if (o.version !== Re) {
    var a = new Error("@opentelemetry/api: Registration of version v" + o.version + " for " + e + " does not match previously registered API v" + Re);
    return r.error(a.stack || a.message), !1;
  }
  return o[e] = t, r.debug("@opentelemetry/api: Registered a global for " + e + " v" + Re + "."), !0;
}
function Me(e) {
  var t, r, n = (t = gt[yt]) === null || t === void 0 ? void 0 : t.version;
  if (!(!n || !rc(n)))
    return (r = gt[yt]) === null || r === void 0 ? void 0 : r[e];
}
function Ot(e, t) {
  t.debug("@opentelemetry/api: Unregistering a global for " + e + " v" + Re + ".");
  var r = gt[yt];
  r && delete r[e];
}
var ic = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, oc = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, ac = (
  /** @class */
  function() {
    function e(t) {
      this._namespace = t.namespace || "DiagComponentLogger";
    }
    return e.prototype.debug = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      return at("debug", this._namespace, t);
    }, e.prototype.error = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      return at("error", this._namespace, t);
    }, e.prototype.info = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      return at("info", this._namespace, t);
    }, e.prototype.warn = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      return at("warn", this._namespace, t);
    }, e.prototype.verbose = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      return at("verbose", this._namespace, t);
    }, e;
  }()
);
function at(e, t, r) {
  var n = Me("diag");
  if (n)
    return r.unshift(t), n[e].apply(n, oc([], ic(r), !1));
}
var M;
(function(e) {
  e[e.NONE = 0] = "NONE", e[e.ERROR = 30] = "ERROR", e[e.WARN = 50] = "WARN", e[e.INFO = 60] = "INFO", e[e.DEBUG = 70] = "DEBUG", e[e.VERBOSE = 80] = "VERBOSE", e[e.ALL = 9999] = "ALL";
})(M || (M = {}));
function sc(e, t) {
  e < M.NONE ? e = M.NONE : e > M.ALL && (e = M.ALL), t = t || {};
  function r(n, i) {
    var o = t[n];
    return typeof o == "function" && e >= i ? o.bind(t) : function() {
    };
  }
  return {
    error: r("error", M.ERROR),
    warn: r("warn", M.WARN),
    info: r("info", M.INFO),
    debug: r("debug", M.DEBUG),
    verbose: r("verbose", M.VERBOSE)
  };
}
var uc = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, cc = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, lc = "diag", oe = (
  /** @class */
  function() {
    function e() {
      function t(i) {
        return function() {
          for (var o = [], a = 0; a < arguments.length; a++)
            o[a] = arguments[a];
          var u = Me("diag");
          if (u)
            return u[i].apply(u, cc([], uc(o), !1));
        };
      }
      var r = this, n = function(i, o) {
        var a, u, c;
        if (o === void 0 && (o = { logLevel: M.INFO }), i === r) {
          var s = new Error("Cannot use diag as the logger for itself. Please use a DiagLogger implementation like ConsoleDiagLogger or a custom implementation");
          return r.error((a = s.stack) !== null && a !== void 0 ? a : s.message), !1;
        }
        typeof o == "number" && (o = {
          logLevel: o
        });
        var l = Me("diag"), f = sc((u = o.logLevel) !== null && u !== void 0 ? u : M.INFO, i);
        if (l && !o.suppressOverrideMessage) {
          var d = (c = new Error().stack) !== null && c !== void 0 ? c : "<failed to generate stacktrace>";
          l.warn("Current logger will be overwritten from " + d), f.warn("Current logger will overwrite one already registered from " + d);
        }
        return At("diag", f, r, !0);
      };
      r.setLogger = n, r.disable = function() {
        Ot(lc, r);
      }, r.createComponentLogger = function(i) {
        return new ac(i);
      }, r.verbose = t("verbose"), r.debug = t("debug"), r.info = t("info"), r.warn = t("warn"), r.error = t("error");
    }
    return e.instance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e;
  }()
), fc = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, dc = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, pc = (
  /** @class */
  function() {
    function e(t) {
      this._entries = t ? new Map(t) : /* @__PURE__ */ new Map();
    }
    return e.prototype.getEntry = function(t) {
      var r = this._entries.get(t);
      if (r)
        return Object.assign({}, r);
    }, e.prototype.getAllEntries = function() {
      return Array.from(this._entries.entries()).map(function(t) {
        var r = fc(t, 2), n = r[0], i = r[1];
        return [n, i];
      });
    }, e.prototype.setEntry = function(t, r) {
      var n = new e(this._entries);
      return n._entries.set(t, r), n;
    }, e.prototype.removeEntry = function(t) {
      var r = new e(this._entries);
      return r._entries.delete(t), r;
    }, e.prototype.removeEntries = function() {
      for (var t, r, n = [], i = 0; i < arguments.length; i++)
        n[i] = arguments[i];
      var o = new e(this._entries);
      try {
        for (var a = dc(n), u = a.next(); !u.done; u = a.next()) {
          var c = u.value;
          o._entries.delete(c);
        }
      } catch (s) {
        t = { error: s };
      } finally {
        try {
          u && !u.done && (r = a.return) && r.call(a);
        } finally {
          if (t) throw t.error;
        }
      }
      return o;
    }, e.prototype.clear = function() {
      return new e();
    }, e;
  }()
), hc = Symbol("BaggageEntryMetadata"), _c = oe.instance();
function vc(e) {
  return e === void 0 && (e = {}), new pc(new Map(Object.entries(e)));
}
function yc(e) {
  return typeof e != "string" && (_c.error("Cannot create baggage metadata from unknown type: " + typeof e), e = ""), {
    __TYPE__: hc,
    toString: function() {
      return e;
    }
  };
}
function xn(e) {
  return Symbol.for(e);
}
var gc = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t) {
      var r = this;
      r._currentContext = t ? new Map(t) : /* @__PURE__ */ new Map(), r.getValue = function(n) {
        return r._currentContext.get(n);
      }, r.setValue = function(n, i) {
        var o = new e(r._currentContext);
        return o._currentContext.set(n, i), o;
      }, r.deleteValue = function(n) {
        var i = new e(r._currentContext);
        return i._currentContext.delete(n), i;
      };
    }
    return e;
  }()
), we = new gc(), ke = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), mc = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.createGauge = function(t, r) {
      return Lc;
    }, e.prototype.createHistogram = function(t, r) {
      return Pc;
    }, e.prototype.createCounter = function(t, r) {
      return Rc;
    }, e.prototype.createUpDownCounter = function(t, r) {
      return Nc;
    }, e.prototype.createObservableGauge = function(t, r) {
      return Mc;
    }, e.prototype.createObservableCounter = function(t, r) {
      return Cc;
    }, e.prototype.createObservableUpDownCounter = function(t, r) {
      return Ic;
    }, e.prototype.addBatchObservableCallback = function(t, r) {
    }, e.prototype.removeBatchObservableCallback = function(t) {
    }, e;
  }()
), vr = (
  /** @class */
  /* @__PURE__ */ function() {
    function e() {
    }
    return e;
  }()
), Ec = (
  /** @class */
  function(e) {
    ke(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.add = function(r, n) {
    }, t;
  }(vr)
), Tc = (
  /** @class */
  function(e) {
    ke(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.add = function(r, n) {
    }, t;
  }(vr)
), Sc = (
  /** @class */
  function(e) {
    ke(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.record = function(r, n) {
    }, t;
  }(vr)
), bc = (
  /** @class */
  function(e) {
    ke(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.record = function(r, n) {
    }, t;
  }(vr)
), Dn = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.addCallback = function(t) {
    }, e.prototype.removeCallback = function(t) {
    }, e;
  }()
), wc = (
  /** @class */
  function(e) {
    ke(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(Dn)
), Ac = (
  /** @class */
  function(e) {
    ke(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(Dn)
), Oc = (
  /** @class */
  function(e) {
    ke(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(Dn)
), $o = new mc(), Rc = new Ec(), Lc = new Sc(), Pc = new bc(), Nc = new Tc(), Cc = new wc(), Mc = new Ac(), Ic = new Oc();
function xc() {
  return $o;
}
var ge;
(function(e) {
  e[e.INT = 0] = "INT", e[e.DOUBLE = 1] = "DOUBLE";
})(ge || (ge = {}));
var Dc = {
  get: function(e, t) {
    if (e != null)
      return e[t];
  },
  keys: function(e) {
    return e == null ? [] : Object.keys(e);
  }
}, kc = {
  set: function(e, t, r) {
    e != null && (e[t] = r);
  }
}, Uc = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Bc = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Hc = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.active = function() {
      return we;
    }, e.prototype.with = function(t, r, n) {
      for (var i = [], o = 3; o < arguments.length; o++)
        i[o - 3] = arguments[o];
      return r.call.apply(r, Bc([n], Uc(i), !1));
    }, e.prototype.bind = function(t, r) {
      return r;
    }, e.prototype.enable = function() {
      return this;
    }, e.prototype.disable = function() {
      return this;
    }, e;
  }()
), Gc = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Fc = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, xr = "context", jc = new Hc(), yr = (
  /** @class */
  function() {
    function e() {
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalContextManager = function(t) {
      return At(xr, t, oe.instance());
    }, e.prototype.active = function() {
      return this._getContextManager().active();
    }, e.prototype.with = function(t, r, n) {
      for (var i, o = [], a = 3; a < arguments.length; a++)
        o[a - 3] = arguments[a];
      return (i = this._getContextManager()).with.apply(i, Fc([t, r, n], Gc(o), !1));
    }, e.prototype.bind = function(t, r) {
      return this._getContextManager().bind(t, r);
    }, e.prototype._getContextManager = function() {
      return Me(xr) || jc;
    }, e.prototype.disable = function() {
      this._getContextManager().disable(), Ot(xr, oe.instance());
    }, e;
  }()
), le;
(function(e) {
  e[e.NONE = 0] = "NONE", e[e.SAMPLED = 1] = "SAMPLED";
})(le || (le = {}));
var zo = "0000000000000000", Xo = "00000000000000000000000000000000", qo = {
  traceId: Xo,
  spanId: zo,
  traceFlags: le.NONE
}, dt = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = qo), this._spanContext = t;
    }
    return e.prototype.spanContext = function() {
      return this._spanContext;
    }, e.prototype.setAttribute = function(t, r) {
      return this;
    }, e.prototype.setAttributes = function(t) {
      return this;
    }, e.prototype.addEvent = function(t, r) {
      return this;
    }, e.prototype.addLink = function(t) {
      return this;
    }, e.prototype.addLinks = function(t) {
      return this;
    }, e.prototype.setStatus = function(t) {
      return this;
    }, e.prototype.updateName = function(t) {
      return this;
    }, e.prototype.end = function(t) {
    }, e.prototype.isRecording = function() {
      return !1;
    }, e.prototype.recordException = function(t, r) {
    }, e;
  }()
), kn = xn("OpenTelemetry Context Key SPAN");
function Un(e) {
  return e.getValue(kn) || void 0;
}
function Vc() {
  return Un(yr.getInstance().active());
}
function Bn(e, t) {
  return e.setValue(kn, t);
}
function $c(e) {
  return e.deleteValue(kn);
}
function zc(e, t) {
  return Bn(e, new dt(t));
}
function Wo(e) {
  var t;
  return (t = Un(e)) === null || t === void 0 ? void 0 : t.spanContext();
}
var Xc = /^([0-9a-f]{32})$/i, qc = /^[0-9a-f]{16}$/i;
function Ko(e) {
  return Xc.test(e) && e !== Xo;
}
function Wc(e) {
  return qc.test(e) && e !== zo;
}
function gr(e) {
  return Ko(e.traceId) && Wc(e.spanId);
}
function Kc(e) {
  return new dt(e);
}
var Dr = yr.getInstance(), Yo = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.startSpan = function(t, r, n) {
      n === void 0 && (n = Dr.active());
      var i = !!(r != null && r.root);
      if (i)
        return new dt();
      var o = n && Wo(n);
      return Yc(o) && gr(o) ? new dt(o) : new dt();
    }, e.prototype.startActiveSpan = function(t, r, n, i) {
      var o, a, u;
      if (!(arguments.length < 2)) {
        arguments.length === 2 ? u = r : arguments.length === 3 ? (o = r, u = n) : (o = r, a = n, u = i);
        var c = a != null ? a : Dr.active(), s = this.startSpan(t, o, c), l = Bn(c, s);
        return Dr.with(l, u, void 0, s);
      }
    }, e;
  }()
);
function Yc(e) {
  return typeof e == "object" && typeof e.spanId == "string" && typeof e.traceId == "string" && typeof e.traceFlags == "number";
}
var Jc = new Yo(), Zc = (
  /** @class */
  function() {
    function e(t, r, n, i) {
      this._provider = t, this.name = r, this.version = n, this.options = i;
    }
    return e.prototype.startSpan = function(t, r, n) {
      return this._getTracer().startSpan(t, r, n);
    }, e.prototype.startActiveSpan = function(t, r, n, i) {
      var o = this._getTracer();
      return Reflect.apply(o.startActiveSpan, o, arguments);
    }, e.prototype._getTracer = function() {
      if (this._delegate)
        return this._delegate;
      var t = this._provider.getDelegateTracer(this.name, this.version, this.options);
      return t ? (this._delegate = t, this._delegate) : Jc;
    }, e;
  }()
), Qc = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getTracer = function(t, r, n) {
      return new Yo();
    }, e;
  }()
), el = new Qc(), Si = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getTracer = function(t, r, n) {
      var i;
      return (i = this.getDelegateTracer(t, r, n)) !== null && i !== void 0 ? i : new Zc(this, t, r, n);
    }, e.prototype.getDelegate = function() {
      var t;
      return (t = this._delegate) !== null && t !== void 0 ? t : el;
    }, e.prototype.setDelegate = function(t) {
      this._delegate = t;
    }, e.prototype.getDelegateTracer = function(t, r, n) {
      var i;
      return (i = this._delegate) === null || i === void 0 ? void 0 : i.getTracer(t, r, n);
    }, e;
  }()
), er;
(function(e) {
  e[e.NOT_RECORD = 0] = "NOT_RECORD", e[e.RECORD = 1] = "RECORD", e[e.RECORD_AND_SAMPLED = 2] = "RECORD_AND_SAMPLED";
})(er || (er = {}));
var mt;
(function(e) {
  e[e.INTERNAL = 0] = "INTERNAL", e[e.SERVER = 1] = "SERVER", e[e.CLIENT = 2] = "CLIENT", e[e.PRODUCER = 3] = "PRODUCER", e[e.CONSUMER = 4] = "CONSUMER";
})(mt || (mt = {}));
var tr;
(function(e) {
  e[e.UNSET = 0] = "UNSET", e[e.OK = 1] = "OK", e[e.ERROR = 2] = "ERROR";
})(tr || (tr = {}));
var O = yr.getInstance(), g = oe.instance(), tl = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getMeter = function(t, r, n) {
      return $o;
    }, e;
  }()
), rl = new tl(), kr = "metrics", nl = (
  /** @class */
  function() {
    function e() {
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalMeterProvider = function(t) {
      return At(kr, t, oe.instance());
    }, e.prototype.getMeterProvider = function() {
      return Me(kr) || rl;
    }, e.prototype.getMeter = function(t, r, n) {
      return this.getMeterProvider().getMeter(t, r, n);
    }, e.prototype.disable = function() {
      Ot(kr, oe.instance());
    }, e;
  }()
), Hn = nl.getInstance(), il = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.inject = function(t, r) {
    }, e.prototype.extract = function(t, r) {
      return t;
    }, e.prototype.fields = function() {
      return [];
    }, e;
  }()
), Gn = xn("OpenTelemetry Baggage Key");
function Jo(e) {
  return e.getValue(Gn) || void 0;
}
function ol() {
  return Jo(yr.getInstance().active());
}
function al(e, t) {
  return e.setValue(Gn, t);
}
function sl(e) {
  return e.deleteValue(Gn);
}
var Ur = "propagation", ul = new il(), cl = (
  /** @class */
  function() {
    function e() {
      this.createBaggage = vc, this.getBaggage = Jo, this.getActiveBaggage = ol, this.setBaggage = al, this.deleteBaggage = sl;
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalPropagator = function(t) {
      return At(Ur, t, oe.instance());
    }, e.prototype.inject = function(t, r, n) {
      return n === void 0 && (n = kc), this._getGlobalPropagator().inject(t, r, n);
    }, e.prototype.extract = function(t, r, n) {
      return n === void 0 && (n = Dc), this._getGlobalPropagator().extract(t, r, n);
    }, e.prototype.fields = function() {
      return this._getGlobalPropagator().fields();
    }, e.prototype.disable = function() {
      Ot(Ur, oe.instance());
    }, e.prototype._getGlobalPropagator = function() {
      return Me(Ur) || ul;
    }, e;
  }()
), q = cl.getInstance(), Br = "trace", ll = (
  /** @class */
  function() {
    function e() {
      this._proxyTracerProvider = new Si(), this.wrapSpanContext = Kc, this.isSpanContextValid = gr, this.deleteSpan = $c, this.getSpan = Un, this.getActiveSpan = Vc, this.getSpanContext = Wo, this.setSpan = Bn, this.setSpanContext = zc;
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalTracerProvider = function(t) {
      var r = At(Br, this._proxyTracerProvider, oe.instance());
      return r && this._proxyTracerProvider.setDelegate(t), r;
    }, e.prototype.getTracerProvider = function() {
      return Me(Br) || this._proxyTracerProvider;
    }, e.prototype.getTracer = function(t, r) {
      return this.getTracerProvider().getTracer(t, r);
    }, e.prototype.disable = function() {
      Ot(Br, oe.instance()), this._proxyTracerProvider = new Si();
    }, e;
  }()
), L = ll.getInstance(), Zo = xn("OpenTelemetry SDK Context Key SUPPRESS_TRACING");
function Qo(e) {
  return e.setValue(Zo, !0);
}
function Fn(e) {
  return e.getValue(Zo) === !0;
}
var fl = "=", hn = ";", _n = ",", Hr = "baggage", dl = 180, pl = 4096, hl = 8192, _l = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function vl(e) {
  return e.reduce(function(t, r) {
    var n = "" + t + (t !== "" ? _n : "") + r;
    return n.length > hl ? t : n;
  }, "");
}
function yl(e) {
  return e.getAllEntries().map(function(t) {
    var r = _l(t, 2), n = r[0], i = r[1], o = encodeURIComponent(n) + "=" + encodeURIComponent(i.value);
    return i.metadata !== void 0 && (o += hn + i.metadata.toString()), o;
  });
}
function gl(e) {
  var t = e.split(hn);
  if (!(t.length <= 0)) {
    var r = t.shift();
    if (r) {
      var n = r.indexOf(fl);
      if (!(n <= 0)) {
        var i = decodeURIComponent(r.substring(0, n).trim()), o = decodeURIComponent(r.substring(n + 1).trim()), a;
        return t.length > 0 && (a = yc(t.join(hn))), { key: i, value: o, metadata: a };
      }
    }
  }
}
var ea = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.inject = function(t, r, n) {
      var i = q.getBaggage(t);
      if (!(!i || Fn(t))) {
        var o = yl(i).filter(function(u) {
          return u.length <= pl;
        }).slice(0, dl), a = vl(o);
        a.length > 0 && n.set(r, Hr, a);
      }
    }, e.prototype.extract = function(t, r, n) {
      var i = n.get(r, Hr), o = Array.isArray(i) ? i.join(_n) : i;
      if (!o)
        return t;
      var a = {};
      if (o.length === 0)
        return t;
      var u = o.split(_n);
      return u.forEach(function(c) {
        var s = gl(c);
        if (s) {
          var l = { value: s.value };
          s.metadata && (l.metadata = s.metadata), a[s.key] = l;
        }
      }), Object.entries(a).length === 0 ? t : q.setBaggage(t, q.createBaggage(a));
    }, e.prototype.fields = function() {
      return [Hr];
    }, e;
  }()
), ta = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, ml = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function qt(e) {
  var t, r, n = {};
  if (typeof e != "object" || e == null)
    return n;
  try {
    for (var i = ta(Object.entries(e)), o = i.next(); !o.done; o = i.next()) {
      var a = ml(o.value, 2), u = a[0], c = a[1];
      if (!El(u)) {
        g.warn("Invalid attribute key: " + u);
        continue;
      }
      if (!ra(c)) {
        g.warn("Invalid attribute value set for key: " + u);
        continue;
      }
      Array.isArray(c) ? n[u] = c.slice() : n[u] = c;
    }
  } catch (s) {
    t = { error: s };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return n;
}
function El(e) {
  return typeof e == "string" && e.length > 0;
}
function ra(e) {
  return e == null ? !0 : Array.isArray(e) ? Tl(e) : na(e);
}
function Tl(e) {
  var t, r, n;
  try {
    for (var i = ta(e), o = i.next(); !o.done; o = i.next()) {
      var a = o.value;
      if (a != null) {
        if (!n) {
          if (na(a)) {
            n = typeof a;
            continue;
          }
          return !1;
        }
        if (typeof a !== n)
          return !1;
      }
    }
  } catch (u) {
    t = { error: u };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return !0;
}
function na(e) {
  switch (typeof e) {
    case "number":
    case "boolean":
    case "string":
      return !0;
  }
  return !1;
}
function Sl() {
  return function(e) {
    g.error(bl(e));
  };
}
function bl(e) {
  return typeof e == "string" ? e : JSON.stringify(wl(e));
}
function wl(e) {
  for (var t = {}, r = e; r !== null; )
    Object.getOwnPropertyNames(r).forEach(function(n) {
      if (!t[n]) {
        var i = r[n];
        i && (t[n] = String(i));
      }
    }), r = Object.getPrototypeOf(r);
  return t;
}
var Al = Sl();
function me(e) {
  try {
    Al(e);
  } catch (t) {
  }
}
var te;
(function(e) {
  e.AlwaysOff = "always_off", e.AlwaysOn = "always_on", e.ParentBasedAlwaysOff = "parentbased_always_off", e.ParentBasedAlwaysOn = "parentbased_always_on", e.ParentBasedTraceIdRatio = "parentbased_traceidratio", e.TraceIdRatio = "traceidratio";
})(te || (te = {}));
var Ol = ",", Rl = ["OTEL_SDK_DISABLED"];
function Ll(e) {
  return Rl.indexOf(e) > -1;
}
var Pl = [
  "OTEL_BSP_EXPORT_TIMEOUT",
  "OTEL_BSP_MAX_EXPORT_BATCH_SIZE",
  "OTEL_BSP_MAX_QUEUE_SIZE",
  "OTEL_BSP_SCHEDULE_DELAY",
  "OTEL_BLRP_EXPORT_TIMEOUT",
  "OTEL_BLRP_MAX_EXPORT_BATCH_SIZE",
  "OTEL_BLRP_MAX_QUEUE_SIZE",
  "OTEL_BLRP_SCHEDULE_DELAY",
  "OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_SPAN_EVENT_COUNT_LIMIT",
  "OTEL_SPAN_LINK_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT",
  "OTEL_EXPORTER_OTLP_TIMEOUT",
  "OTEL_EXPORTER_OTLP_TRACES_TIMEOUT",
  "OTEL_EXPORTER_OTLP_METRICS_TIMEOUT",
  "OTEL_EXPORTER_OTLP_LOGS_TIMEOUT",
  "OTEL_EXPORTER_JAEGER_AGENT_PORT"
];
function Nl(e) {
  return Pl.indexOf(e) > -1;
}
var Cl = [
  "OTEL_NO_PATCH_MODULES",
  "OTEL_PROPAGATORS",
  "OTEL_SEMCONV_STABILITY_OPT_IN"
];
function Ml(e) {
  return Cl.indexOf(e) > -1;
}
var Wt = 1 / 0, Kt = 128, Il = 128, xl = 128, ia = {
  OTEL_SDK_DISABLED: !1,
  CONTAINER_NAME: "",
  ECS_CONTAINER_METADATA_URI_V4: "",
  ECS_CONTAINER_METADATA_URI: "",
  HOSTNAME: "",
  KUBERNETES_SERVICE_HOST: "",
  NAMESPACE: "",
  OTEL_BSP_EXPORT_TIMEOUT: 3e4,
  OTEL_BSP_MAX_EXPORT_BATCH_SIZE: 512,
  OTEL_BSP_MAX_QUEUE_SIZE: 2048,
  OTEL_BSP_SCHEDULE_DELAY: 5e3,
  OTEL_BLRP_EXPORT_TIMEOUT: 3e4,
  OTEL_BLRP_MAX_EXPORT_BATCH_SIZE: 512,
  OTEL_BLRP_MAX_QUEUE_SIZE: 2048,
  OTEL_BLRP_SCHEDULE_DELAY: 5e3,
  OTEL_EXPORTER_JAEGER_AGENT_HOST: "",
  OTEL_EXPORTER_JAEGER_AGENT_PORT: 6832,
  OTEL_EXPORTER_JAEGER_ENDPOINT: "",
  OTEL_EXPORTER_JAEGER_PASSWORD: "",
  OTEL_EXPORTER_JAEGER_USER: "",
  OTEL_EXPORTER_OTLP_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_TRACES_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_METRICS_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_LOGS_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_HEADERS: "",
  OTEL_EXPORTER_OTLP_TRACES_HEADERS: "",
  OTEL_EXPORTER_OTLP_METRICS_HEADERS: "",
  OTEL_EXPORTER_OTLP_LOGS_HEADERS: "",
  OTEL_EXPORTER_OTLP_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_TRACES_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_METRICS_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_LOGS_TIMEOUT: 1e4,
  OTEL_EXPORTER_ZIPKIN_ENDPOINT: "http://localhost:9411/api/v2/spans",
  OTEL_LOG_LEVEL: M.INFO,
  OTEL_NO_PATCH_MODULES: [],
  OTEL_PROPAGATORS: ["tracecontext", "baggage"],
  OTEL_RESOURCE_ATTRIBUTES: "",
  OTEL_SERVICE_NAME: "",
  OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT: Wt,
  OTEL_ATTRIBUTE_COUNT_LIMIT: Kt,
  OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT: Wt,
  OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT: Kt,
  OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT: Wt,
  OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT: Kt,
  OTEL_SPAN_EVENT_COUNT_LIMIT: 128,
  OTEL_SPAN_LINK_COUNT_LIMIT: 128,
  OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT: Il,
  OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT: xl,
  OTEL_TRACES_EXPORTER: "",
  OTEL_TRACES_SAMPLER: te.ParentBasedAlwaysOn,
  OTEL_TRACES_SAMPLER_ARG: "",
  OTEL_LOGS_EXPORTER: "",
  OTEL_EXPORTER_OTLP_INSECURE: "",
  OTEL_EXPORTER_OTLP_TRACES_INSECURE: "",
  OTEL_EXPORTER_OTLP_METRICS_INSECURE: "",
  OTEL_EXPORTER_OTLP_LOGS_INSECURE: "",
  OTEL_EXPORTER_OTLP_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_TRACES_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_METRICS_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_LOGS_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_TRACES_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_METRICS_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_LOGS_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_TRACES_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_METRICS_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_LOGS_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_TRACES_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_METRICS_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_LOGS_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_TRACES_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_METRICS_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_LOGS_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE: "cumulative",
  OTEL_SEMCONV_STABILITY_OPT_IN: []
};
function Dl(e, t, r) {
  if (typeof r[e] != "undefined") {
    var n = String(r[e]);
    t[e] = n.toLowerCase() === "true";
  }
}
function kl(e, t, r, n, i) {
  if (n === void 0 && (n = -1 / 0), i === void 0 && (i = 1 / 0), typeof r[e] != "undefined") {
    var o = Number(r[e]);
    isNaN(o) || (o < n ? t[e] = n : o > i ? t[e] = i : t[e] = o);
  }
}
function Ul(e, t, r, n) {
  n === void 0 && (n = Ol);
  var i = r[e];
  typeof i == "string" && (t[e] = i.split(n).map(function(o) {
    return o.trim();
  }));
}
var Bl = {
  ALL: M.ALL,
  VERBOSE: M.VERBOSE,
  DEBUG: M.DEBUG,
  INFO: M.INFO,
  WARN: M.WARN,
  ERROR: M.ERROR,
  NONE: M.NONE
};
function Hl(e, t, r) {
  var n = r[e];
  if (typeof n == "string") {
    var i = Bl[n.toUpperCase()];
    i != null && (t[e] = i);
  }
}
function oa(e) {
  var t = {};
  for (var r in ia) {
    var n = r;
    switch (n) {
      case "OTEL_LOG_LEVEL":
        Hl(n, t, e);
        break;
      default:
        if (Ll(n))
          Dl(n, t, e);
        else if (Nl(n))
          kl(n, t, e);
        else if (Ml(n))
          Ul(n, t, e);
        else {
          var i = e[n];
          typeof i != "undefined" && i !== null && (t[n] = String(i));
        }
    }
  }
  return t;
}
var pt = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {};
function Je() {
  var e = oa(pt);
  return Object.assign({}, ia, e);
}
function Gl() {
  return oa(pt);
}
function bi(e) {
  return e >= 48 && e <= 57 ? e - 48 : e >= 97 && e <= 102 ? e - 87 : e - 55;
}
function jn(e) {
  for (var t = new Uint8Array(e.length / 2), r = 0, n = 0; n < e.length; n += 2) {
    var i = bi(e.charCodeAt(n)), o = bi(e.charCodeAt(n + 1));
    t[r++] = i << 4 | o;
  }
  return t;
}
var K = performance, Fl = "1.30.1", jl = "process.runtime.name", Vl = "telemetry.sdk.name", $l = "telemetry.sdk.language", zl = "telemetry.sdk.version", Xl = jl, ql = Vl, Wl = $l, Kl = zl, Yl = "webjs", Jl = Yl, Ve, Gr = (Ve = {}, Ve[ql] = "opentelemetry", Ve[Xl] = "browser", Ve[Wl] = Jl, Ve[Kl] = Fl, Ve), Zl = 9, Ql = 6, ef = Math.pow(10, Ql), rr = Math.pow(10, Zl);
function W(e) {
  var t = e / 1e3, r = Math.trunc(t), n = Math.round(e % 1e3 * ef);
  return [r, n];
}
function Vn() {
  var e = K.timeOrigin;
  if (typeof e != "number") {
    var t = K;
    e = t.timing && t.timing.fetchStart;
  }
  return e;
}
function Ie(e) {
  var t = W(Vn()), r = W(typeof e == "number" ? e : K.now());
  return aa(t, r);
}
function ht(e) {
  if ($n(e))
    return e;
  if (typeof e == "number")
    return e < Vn() ? Ie(e) : W(e);
  if (e instanceof Date)
    return W(e.getTime());
  throw TypeError("Invalid input type");
}
function tf(e, t) {
  var r = t[0] - e[0], n = t[1] - e[1];
  return n < 0 && (r -= 1, n += rr), [r, n];
}
function ce(e) {
  return e[0] * rr + e[1];
}
function Mt(e) {
  return e[0] * 1e6 + e[1] / 1e3;
}
function $n(e) {
  return Array.isArray(e) && e.length === 2 && typeof e[0] == "number" && typeof e[1] == "number";
}
function wi(e) {
  return $n(e) || typeof e == "number" || e instanceof Date;
}
function aa(e, t) {
  var r = [e[0] + t[0], e[1] + t[1]];
  return r[1] >= rr && (r[1] -= rr, r[0] += 1), r;
}
var N;
(function(e) {
  e[e.SUCCESS = 0] = "SUCCESS", e[e.FAILED = 1] = "FAILED";
})(N || (N = {}));
var rf = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, sa = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = {});
      var r;
      this._propagators = (r = t.propagators) !== null && r !== void 0 ? r : [], this._fields = Array.from(new Set(this._propagators.map(function(n) {
        return typeof n.fields == "function" ? n.fields() : [];
      }).reduce(function(n, i) {
        return n.concat(i);
      }, [])));
    }
    return e.prototype.inject = function(t, r, n) {
      var i, o;
      try {
        for (var a = rf(this._propagators), u = a.next(); !u.done; u = a.next()) {
          var c = u.value;
          try {
            c.inject(t, r, n);
          } catch (s) {
            g.warn("Failed to inject with " + c.constructor.name + ". Err: " + s.message);
          }
        }
      } catch (s) {
        i = { error: s };
      } finally {
        try {
          u && !u.done && (o = a.return) && o.call(a);
        } finally {
          if (i) throw i.error;
        }
      }
    }, e.prototype.extract = function(t, r, n) {
      return this._propagators.reduce(function(i, o) {
        try {
          return o.extract(i, r, n);
        } catch (a) {
          g.warn("Failed to extract with " + o.constructor.name + ". Err: " + a.message);
        }
        return i;
      }, t);
    }, e.prototype.fields = function() {
      return this._fields.slice();
    }, e;
  }()
), vn = "[_0-9a-z-*/]", nf = "[a-z]" + vn + "{0,255}", of = "[a-z0-9]" + vn + "{0,240}@[a-z]" + vn + "{0,13}", af = new RegExp("^(?:" + nf + "|" + of + ")$"), sf = /^[ -~]{0,255}[!-~]$/, uf = /,|=/;
function cf(e) {
  return af.test(e);
}
function lf(e) {
  return sf.test(e) && !uf.test(e);
}
var Ai = 32, ff = 512, Oi = ",", Ri = "=", df = (
  /** @class */
  function() {
    function e(t) {
      this._internalState = /* @__PURE__ */ new Map(), t && this._parse(t);
    }
    return e.prototype.set = function(t, r) {
      var n = this._clone();
      return n._internalState.has(t) && n._internalState.delete(t), n._internalState.set(t, r), n;
    }, e.prototype.unset = function(t) {
      var r = this._clone();
      return r._internalState.delete(t), r;
    }, e.prototype.get = function(t) {
      return this._internalState.get(t);
    }, e.prototype.serialize = function() {
      var t = this;
      return this._keys().reduce(function(r, n) {
        return r.push(n + Ri + t.get(n)), r;
      }, []).join(Oi);
    }, e.prototype._parse = function(t) {
      t.length > ff || (this._internalState = t.split(Oi).reverse().reduce(function(r, n) {
        var i = n.trim(), o = i.indexOf(Ri);
        if (o !== -1) {
          var a = i.slice(0, o), u = i.slice(o + 1, n.length);
          cf(a) && lf(u) && r.set(a, u);
        }
        return r;
      }, /* @__PURE__ */ new Map()), this._internalState.size > Ai && (this._internalState = new Map(Array.from(this._internalState.entries()).reverse().slice(0, Ai))));
    }, e.prototype._keys = function() {
      return Array.from(this._internalState.keys()).reverse();
    }, e.prototype._clone = function() {
      var t = new e();
      return t._internalState = new Map(this._internalState), t;
    }, e;
  }()
), Yt = "traceparent", Fr = "tracestate", pf = "00", hf = "(?!ff)[\\da-f]{2}", _f = "(?![0]{32})[\\da-f]{32}", vf = "(?![0]{16})[\\da-f]{16}", yf = "[\\da-f]{2}", gf = new RegExp("^\\s?(" + hf + ")-(" + _f + ")-(" + vf + ")-(" + yf + ")(-.*)?\\s?$");
function mf(e) {
  var t = gf.exec(e);
  return !t || t[1] === "00" && t[5] ? null : {
    traceId: t[2],
    spanId: t[3],
    traceFlags: parseInt(t[4], 16)
  };
}
var ua = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.inject = function(t, r, n) {
      var i = L.getSpanContext(t);
      if (!(!i || Fn(t) || !gr(i))) {
        var o = pf + "-" + i.traceId + "-" + i.spanId + "-0" + Number(i.traceFlags || le.NONE).toString(16);
        n.set(r, Yt, o), i.traceState && n.set(r, Fr, i.traceState.serialize());
      }
    }, e.prototype.extract = function(t, r, n) {
      var i = n.get(r, Yt);
      if (!i)
        return t;
      var o = Array.isArray(i) ? i[0] : i;
      if (typeof o != "string")
        return t;
      var a = mf(o);
      if (!a)
        return t;
      a.isRemote = !0;
      var u = n.get(r, Fr);
      if (u) {
        var c = Array.isArray(u) ? u.join(",") : u;
        a.traceState = new df(typeof c == "string" ? c : void 0);
      }
      return L.setSpanContext(t, a);
    }, e.prototype.fields = function() {
      return [Yt, Fr];
    }, e;
  }()
), Ef = "[object Object]", Tf = "[object Null]", Sf = "[object Undefined]", bf = Function.prototype, ca = bf.toString, wf = ca.call(Object), Af = Of(Object.getPrototypeOf, Object), la = Object.prototype, fa = la.hasOwnProperty, Ae = Symbol ? Symbol.toStringTag : void 0, da = la.toString;
function Of(e, t) {
  return function(r) {
    return e(t(r));
  };
}
function Li(e) {
  if (!Rf(e) || Lf(e) !== Ef)
    return !1;
  var t = Af(e);
  if (t === null)
    return !0;
  var r = fa.call(t, "constructor") && t.constructor;
  return typeof r == "function" && r instanceof r && ca.call(r) === wf;
}
function Rf(e) {
  return e != null && typeof e == "object";
}
function Lf(e) {
  return e == null ? e === void 0 ? Sf : Tf : Ae && Ae in Object(e) ? Pf(e) : Nf(e);
}
function Pf(e) {
  var t = fa.call(e, Ae), r = e[Ae], n = !1;
  try {
    e[Ae] = void 0, n = !0;
  } catch (o) {
  }
  var i = da.call(e);
  return n && (t ? e[Ae] = r : delete e[Ae]), i;
}
function Nf(e) {
  return da.call(e);
}
var Cf = 20;
function pa() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  for (var r = e.shift(), n = /* @__PURE__ */ new WeakMap(); e.length > 0; )
    r = ha(r, e.shift(), 0, n);
  return r;
}
function jr(e) {
  return nr(e) ? e.slice() : e;
}
function ha(e, t, r, n) {
  r === void 0 && (r = 0);
  var i;
  if (!(r > Cf)) {
    if (r++, Jt(e) || Jt(t) || _a(t))
      i = jr(t);
    else if (nr(e)) {
      if (i = e.slice(), nr(t))
        for (var o = 0, a = t.length; o < a; o++)
          i.push(jr(t[o]));
      else if (st(t))
        for (var u = Object.keys(t), o = 0, a = u.length; o < a; o++) {
          var c = u[o];
          i[c] = jr(t[c]);
        }
    } else if (st(e))
      if (st(t)) {
        if (!Mf(e, t))
          return t;
        i = Object.assign({}, e);
        for (var u = Object.keys(t), o = 0, a = u.length; o < a; o++) {
          var c = u[o], s = t[c];
          if (Jt(s))
            typeof s == "undefined" ? delete i[c] : i[c] = s;
          else {
            var l = i[c], f = s;
            if (Pi(e, c, n) || Pi(t, c, n))
              delete i[c];
            else {
              if (st(l) && st(f)) {
                var d = n.get(l) || [], h = n.get(f) || [];
                d.push({ obj: e, key: c }), h.push({ obj: t, key: c }), n.set(l, d), n.set(f, h);
              }
              i[c] = ha(i[c], s, r, n);
            }
          }
        }
      } else
        i = t;
    return i;
  }
}
function Pi(e, t, r) {
  for (var n = r.get(e[t]) || [], i = 0, o = n.length; i < o; i++) {
    var a = n[i];
    if (a.key === t && a.obj === e)
      return !0;
  }
  return !1;
}
function nr(e) {
  return Array.isArray(e);
}
function _a(e) {
  return typeof e == "function";
}
function st(e) {
  return !Jt(e) && !nr(e) && !_a(e) && typeof e == "object";
}
function Jt(e) {
  return typeof e == "string" || typeof e == "number" || typeof e == "boolean" || typeof e == "undefined" || e instanceof Date || e instanceof RegExp || e === null;
}
function Mf(e, t) {
  return !(!Li(e) || !Li(t));
}
var If = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function va(e, t) {
  return typeof t == "string" ? e === t : !!e.match(t);
}
function ya(e, t) {
  var r, n;
  if (!t)
    return !1;
  try {
    for (var i = If(t), o = i.next(); !o.done; o = i.next()) {
      var a = o.value;
      if (va(e, a))
        return !0;
    }
  } catch (u) {
    r = { error: u };
  } finally {
    try {
      o && !o.done && (n = i.return) && n.call(i);
    } finally {
      if (r) throw r.error;
    }
  }
  return !1;
}
var xf = (
  /** @class */
  function() {
    function e() {
      var t = this;
      this._promise = new Promise(function(r, n) {
        t._resolve = r, t._reject = n;
      });
    }
    return Object.defineProperty(e.prototype, "promise", {
      get: function() {
        return this._promise;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.resolve = function(t) {
      this._resolve(t);
    }, e.prototype.reject = function(t) {
      this._reject(t);
    }, e;
  }()
), Df = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, kf = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Uf = (
  /** @class */
  function() {
    function e(t, r) {
      this._callback = t, this._that = r, this._isCalled = !1, this._deferred = new xf();
    }
    return Object.defineProperty(e.prototype, "isCalled", {
      get: function() {
        return this._isCalled;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "promise", {
      get: function() {
        return this._deferred.promise;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.call = function() {
      for (var t, r = this, n = [], i = 0; i < arguments.length; i++)
        n[i] = arguments[i];
      if (!this._isCalled) {
        this._isCalled = !0;
        try {
          Promise.resolve((t = this._callback).call.apply(t, kf([this._that], Df(n), !1))).then(function(o) {
            return r._deferred.resolve(o);
          }, function(o) {
            return r._deferred.reject(o);
          });
        } catch (o) {
          this._deferred.reject(o);
        }
      }
      return this._deferred.promise;
    }, e;
  }()
);
function Bf(e, t) {
  return new Promise(function(r) {
    O.with(Qo(O.active()), function() {
      e.export(t, function(n) {
        r(n);
      });
    });
  });
}
var Hf = {
  _export: Bf
}, ga = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.emit = function(t) {
    }, e;
  }()
), Gf = new ga(), Ff = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getLogger = function(t, r, n) {
      return new ga();
    }, e;
  }()
), ma = new Ff(), jf = (
  /** @class */
  function() {
    function e(t, r, n, i) {
      this._provider = t, this.name = r, this.version = n, this.options = i;
    }
    return e.prototype.emit = function(t) {
      this._getLogger().emit(t);
    }, e.prototype._getLogger = function() {
      if (this._delegate)
        return this._delegate;
      var t = this._provider.getDelegateLogger(this.name, this.version, this.options);
      return t ? (this._delegate = t, this._delegate) : Gf;
    }, e;
  }()
), Ni = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getLogger = function(t, r, n) {
      var i;
      return (i = this.getDelegateLogger(t, r, n)) !== null && i !== void 0 ? i : new jf(this, t, r, n);
    }, e.prototype.getDelegate = function() {
      var t;
      return (t = this._delegate) !== null && t !== void 0 ? t : ma;
    }, e.prototype.setDelegate = function(t) {
      this._delegate = t;
    }, e.prototype.getDelegateLogger = function(t, r, n) {
      var i;
      return (i = this._delegate) === null || i === void 0 ? void 0 : i.getLogger(t, r, n);
    }, e;
  }()
), Vf = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {}, It = Symbol.for("io.opentelemetry.js.api.logs"), ut = Vf;
function $f(e, t, r) {
  return function(n) {
    return n === e ? t : r;
  };
}
var Ci = 1, zf = (
  /** @class */
  function() {
    function e() {
      this._proxyLoggerProvider = new Ni();
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalLoggerProvider = function(t) {
      return ut[It] ? this.getLoggerProvider() : (ut[It] = $f(Ci, t, ma), this._proxyLoggerProvider.setDelegate(t), t);
    }, e.prototype.getLoggerProvider = function() {
      var t, r;
      return (r = (t = ut[It]) === null || t === void 0 ? void 0 : t.call(ut, Ci)) !== null && r !== void 0 ? r : this._proxyLoggerProvider;
    }, e.prototype.getLogger = function(t, r, n) {
      return this.getLoggerProvider().getLogger(t, r, n);
    }, e.prototype.disable = function() {
      delete ut[It], this._proxyLoggerProvider = new Ni();
    }, e;
  }()
), Ea = zf.getInstance();
function Xf(e, t, r, n) {
  for (var i = 0, o = e.length; i < o; i++) {
    var a = e[i];
    t && a.setTracerProvider(t), r && a.setMeterProvider(r), n && a.setLoggerProvider && a.setLoggerProvider(n), a.getConfig().enabled || a.enable();
  }
}
function qf(e) {
  e.forEach(function(t) {
    return t.disable();
  });
}
function Wf(e) {
  var t, r, n = e.tracerProvider || L.getTracerProvider(), i = e.meterProvider || Hn.getMeterProvider(), o = e.loggerProvider || Ea.getLoggerProvider(), a = (r = (t = e.instrumentations) === null || t === void 0 ? void 0 : t.flat()) !== null && r !== void 0 ? r : [];
  return Xf(a, n, i, o), function() {
    qf(a);
  };
}
function yn(e) {
  return typeof e == "function";
}
var G = console.error.bind(console);
function ct(e, t, r) {
  var n = !!e[t] && e.propertyIsEnumerable(t);
  Object.defineProperty(e, t, {
    configurable: !0,
    enumerable: n,
    writable: !0,
    value: r
  });
}
function Rt(e) {
  e && e.logger && (yn(e.logger) ? G = e.logger : G("new logger isn't a function, not replacing"));
}
function Ta(e, t, r) {
  if (!e || !e[t]) {
    G("no original function " + t + " to wrap");
    return;
  }
  if (!r) {
    G("no wrapper function"), G(new Error().stack);
    return;
  }
  if (!yn(e[t]) || !yn(r)) {
    G("original object and wrapper must be functions");
    return;
  }
  var n = e[t], i = r(n, t);
  return ct(i, "__original", n), ct(i, "__unwrap", function() {
    e[t] === i && ct(e, t, n);
  }), ct(i, "__wrapped", !0), ct(e, t, i), i;
}
function Kf(e, t, r) {
  if (e)
    Array.isArray(e) || (e = [e]);
  else {
    G("must provide one or more modules to patch"), G(new Error().stack);
    return;
  }
  if (!(t && Array.isArray(t))) {
    G("must provide one or more functions to wrap on modules");
    return;
  }
  e.forEach(function(n) {
    t.forEach(function(i) {
      Ta(n, i, r);
    });
  });
}
function Sa(e, t) {
  if (!e || !e[t]) {
    G("no function to unwrap."), G(new Error().stack);
    return;
  }
  if (!e[t].__unwrap)
    G("no original to unwrap to -- has " + t + " already been unwrapped?");
  else
    return e[t].__unwrap();
}
function Yf(e, t) {
  if (e)
    Array.isArray(e) || (e = [e]);
  else {
    G("must provide one or more modules to patch"), G(new Error().stack);
    return;
  }
  if (!(t && Array.isArray(t))) {
    G("must provide one or more functions to unwrap on modules");
    return;
  }
  e.forEach(function(r) {
    t.forEach(function(n) {
      Sa(r, n);
    });
  });
}
Rt.wrap = Ta;
Rt.massWrap = Kf;
Rt.unwrap = Sa;
Rt.massUnwrap = Yf;
var xt = Rt, gn = function() {
  return gn = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, gn.apply(this, arguments);
}, Jf = (
  /** @class */
  function() {
    function e(t, r, n) {
      this.instrumentationName = t, this.instrumentationVersion = r, this._config = {}, this._wrap = xt.wrap, this._unwrap = xt.unwrap, this._massWrap = xt.massWrap, this._massUnwrap = xt.massUnwrap, this.setConfig(n), this._diag = g.createComponentLogger({
        namespace: t
      }), this._tracer = L.getTracer(t, r), this._meter = Hn.getMeter(t, r), this._logger = Ea.getLogger(t, r), this._updateMetricInstruments();
    }
    return Object.defineProperty(e.prototype, "meter", {
      /* Returns meter */
      get: function() {
        return this._meter;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.setMeterProvider = function(t) {
      this._meter = t.getMeter(this.instrumentationName, this.instrumentationVersion), this._updateMetricInstruments();
    }, Object.defineProperty(e.prototype, "logger", {
      /* Returns logger */
      get: function() {
        return this._logger;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.setLoggerProvider = function(t) {
      this._logger = t.getLogger(this.instrumentationName, this.instrumentationVersion);
    }, e.prototype.getModuleDefinitions = function() {
      var t, r = (t = this.init()) !== null && t !== void 0 ? t : [];
      return Array.isArray(r) ? r : [r];
    }, e.prototype._updateMetricInstruments = function() {
    }, e.prototype.getConfig = function() {
      return this._config;
    }, e.prototype.setConfig = function(t) {
      this._config = gn({ enabled: !0 }, t);
    }, e.prototype.setTracerProvider = function(t) {
      this._tracer = t.getTracer(this.instrumentationName, this.instrumentationVersion);
    }, Object.defineProperty(e.prototype, "tracer", {
      /* Returns tracer */
      get: function() {
        return this._tracer;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._runSpanCustomizationHook = function(t, r, n, i) {
      if (t)
        try {
          t(n, i);
        } catch (o) {
          this._diag.error("Error running span customization hook due to exception in handler", { triggerName: r }, o);
        }
    }, e;
  }()
), Zf = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Lt = (
  /** @class */
  function(e) {
    Zf(t, e);
    function t(r, n, i) {
      var o = e.call(this, r, n, i) || this;
      return o._config.enabled && o.enable(), o;
    }
    return t;
  }(Jf)
);
function ir(e, t, r) {
  var n, i;
  try {
    i = e();
  } catch (o) {
    n = o;
  } finally {
    return t(n, i), i;
  }
}
function D(e) {
  return typeof e == "function" && typeof e.__original == "function" && typeof e.__unwrap == "function" && e.__wrapped === !0;
}
var Qf = "exception.type", ed = "exception.message", td = "exception.stacktrace", Vr = Qf, $r = ed, rd = td, nd = "exception", mn = function() {
  return mn = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, mn.apply(this, arguments);
}, id = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Mi = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, od = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, ad = (
  /** @class */
  function() {
    function e(t, r, n, i, o, a, u, c, s, l) {
      u === void 0 && (u = []), this.attributes = {}, this.links = [], this.events = [], this._droppedAttributesCount = 0, this._droppedEventsCount = 0, this._droppedLinksCount = 0, this.status = {
        code: tr.UNSET
      }, this.endTime = [0, 0], this._ended = !1, this._duration = [-1, -1], this.name = n, this._spanContext = i, this.parentSpanId = a, this.kind = o, this.links = u;
      var f = Date.now();
      this._performanceStartTime = K.now(), this._performanceOffset = f - (this._performanceStartTime + Vn()), this._startTimeProvided = c != null, this.startTime = this._getTime(c != null ? c : f), this.resource = t.resource, this.instrumentationLibrary = t.instrumentationLibrary, this._spanLimits = t.getSpanLimits(), this._attributeValueLengthLimit = this._spanLimits.attributeValueLengthLimit || 0, l != null && this.setAttributes(l), this._spanProcessor = t.getActiveSpanProcessor(), this._spanProcessor.onStart(this, r);
    }
    return e.prototype.spanContext = function() {
      return this._spanContext;
    }, e.prototype.setAttribute = function(t, r) {
      return r == null || this._isSpanEnded() ? this : t.length === 0 ? (g.warn("Invalid attribute key: " + t), this) : ra(r) ? Object.keys(this.attributes).length >= this._spanLimits.attributeCountLimit && !Object.prototype.hasOwnProperty.call(this.attributes, t) ? (this._droppedAttributesCount++, this) : (this.attributes[t] = this._truncateToSize(r), this) : (g.warn("Invalid attribute value set for key: " + t), this);
    }, e.prototype.setAttributes = function(t) {
      var r, n;
      try {
        for (var i = id(Object.entries(t)), o = i.next(); !o.done; o = i.next()) {
          var a = Mi(o.value, 2), u = a[0], c = a[1];
          this.setAttribute(u, c);
        }
      } catch (s) {
        r = { error: s };
      } finally {
        try {
          o && !o.done && (n = i.return) && n.call(i);
        } finally {
          if (r) throw r.error;
        }
      }
      return this;
    }, e.prototype.addEvent = function(t, r, n) {
      if (this._isSpanEnded())
        return this;
      if (this._spanLimits.eventCountLimit === 0)
        return g.warn("No events allowed."), this._droppedEventsCount++, this;
      this.events.length >= this._spanLimits.eventCountLimit && (this._droppedEventsCount === 0 && g.debug("Dropping extra events."), this.events.shift(), this._droppedEventsCount++), wi(r) && (wi(n) || (n = r), r = void 0);
      var i = qt(r);
      return this.events.push({
        name: t,
        attributes: i,
        time: this._getTime(n),
        droppedAttributesCount: 0
      }), this;
    }, e.prototype.addLink = function(t) {
      return this.links.push(t), this;
    }, e.prototype.addLinks = function(t) {
      var r;
      return (r = this.links).push.apply(r, od([], Mi(t), !1)), this;
    }, e.prototype.setStatus = function(t) {
      return this._isSpanEnded() ? this : (this.status = mn({}, t), this.status.message != null && typeof t.message != "string" && (g.warn("Dropping invalid status.message of type '" + typeof t.message + "', expected 'string'"), delete this.status.message), this);
    }, e.prototype.updateName = function(t) {
      return this._isSpanEnded() ? this : (this.name = t, this);
    }, e.prototype.end = function(t) {
      if (this._isSpanEnded()) {
        g.error(this.name + " " + this._spanContext.traceId + "-" + this._spanContext.spanId + " - You can only call end() on a span once.");
        return;
      }
      this._ended = !0, this.endTime = this._getTime(t), this._duration = tf(this.startTime, this.endTime), this._duration[0] < 0 && (g.warn("Inconsistent start and end time, startTime > endTime. Setting span duration to 0ms.", this.startTime, this.endTime), this.endTime = this.startTime.slice(), this._duration = [0, 0]), this._droppedEventsCount > 0 && g.warn("Dropped " + this._droppedEventsCount + " events because eventCountLimit reached"), this._spanProcessor.onEnd(this);
    }, e.prototype._getTime = function(t) {
      if (typeof t == "number" && t <= K.now())
        return Ie(t + this._performanceOffset);
      if (typeof t == "number")
        return W(t);
      if (t instanceof Date)
        return W(t.getTime());
      if ($n(t))
        return t;
      if (this._startTimeProvided)
        return W(Date.now());
      var r = K.now() - this._performanceStartTime;
      return aa(this.startTime, W(r));
    }, e.prototype.isRecording = function() {
      return this._ended === !1;
    }, e.prototype.recordException = function(t, r) {
      var n = {};
      typeof t == "string" ? n[$r] = t : t && (t.code ? n[Vr] = t.code.toString() : t.name && (n[Vr] = t.name), t.message && (n[$r] = t.message), t.stack && (n[rd] = t.stack)), n[Vr] || n[$r] ? this.addEvent(nd, n, r) : g.warn("Failed to record an exception " + t);
    }, Object.defineProperty(e.prototype, "duration", {
      get: function() {
        return this._duration;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "ended", {
      get: function() {
        return this._ended;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "droppedAttributesCount", {
      get: function() {
        return this._droppedAttributesCount;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "droppedEventsCount", {
      get: function() {
        return this._droppedEventsCount;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "droppedLinksCount", {
      get: function() {
        return this._droppedLinksCount;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._isSpanEnded = function() {
      return this._ended && g.warn("Can not execute the operation on ended Span {traceId: " + this._spanContext.traceId + ", spanId: " + this._spanContext.spanId + "}"), this._ended;
    }, e.prototype._truncateToLimitUtil = function(t, r) {
      return t.length <= r ? t : t.substring(0, r);
    }, e.prototype._truncateToSize = function(t) {
      var r = this, n = this._attributeValueLengthLimit;
      return n <= 0 ? (g.warn("Attribute value limit must be positive, got " + n), t) : typeof t == "string" ? this._truncateToLimitUtil(t, n) : Array.isArray(t) ? t.map(function(i) {
        return typeof i == "string" ? r._truncateToLimitUtil(i, n) : i;
      }) : t;
    }, e;
  }()
), Ze;
(function(e) {
  e[e.NOT_RECORD = 0] = "NOT_RECORD", e[e.RECORD = 1] = "RECORD", e[e.RECORD_AND_SAMPLED = 2] = "RECORD_AND_SAMPLED";
})(Ze || (Ze = {}));
var or = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.shouldSample = function() {
      return {
        decision: Ze.NOT_RECORD
      };
    }, e.prototype.toString = function() {
      return "AlwaysOffSampler";
    }, e;
  }()
), We = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.shouldSample = function() {
      return {
        decision: Ze.RECORD_AND_SAMPLED
      };
    }, e.prototype.toString = function() {
      return "AlwaysOnSampler";
    }, e;
  }()
), zr = (
  /** @class */
  function() {
    function e(t) {
      var r, n, i, o;
      this._root = t.root, this._root || (me(new Error("ParentBasedSampler must have a root sampler configured")), this._root = new We()), this._remoteParentSampled = (r = t.remoteParentSampled) !== null && r !== void 0 ? r : new We(), this._remoteParentNotSampled = (n = t.remoteParentNotSampled) !== null && n !== void 0 ? n : new or(), this._localParentSampled = (i = t.localParentSampled) !== null && i !== void 0 ? i : new We(), this._localParentNotSampled = (o = t.localParentNotSampled) !== null && o !== void 0 ? o : new or();
    }
    return e.prototype.shouldSample = function(t, r, n, i, o, a) {
      var u = L.getSpanContext(t);
      return !u || !gr(u) ? this._root.shouldSample(t, r, n, i, o, a) : u.isRemote ? u.traceFlags & le.SAMPLED ? this._remoteParentSampled.shouldSample(t, r, n, i, o, a) : this._remoteParentNotSampled.shouldSample(t, r, n, i, o, a) : u.traceFlags & le.SAMPLED ? this._localParentSampled.shouldSample(t, r, n, i, o, a) : this._localParentNotSampled.shouldSample(t, r, n, i, o, a);
    }, e.prototype.toString = function() {
      return "ParentBased{root=" + this._root.toString() + ", remoteParentSampled=" + this._remoteParentSampled.toString() + ", remoteParentNotSampled=" + this._remoteParentNotSampled.toString() + ", localParentSampled=" + this._localParentSampled.toString() + ", localParentNotSampled=" + this._localParentNotSampled.toString() + "}";
    }, e;
  }()
), Ii = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = 0), this._ratio = t, this._ratio = this._normalize(t), this._upperBound = Math.floor(this._ratio * 4294967295);
    }
    return e.prototype.shouldSample = function(t, r) {
      return {
        decision: Ko(r) && this._accumulate(r) < this._upperBound ? Ze.RECORD_AND_SAMPLED : Ze.NOT_RECORD
      };
    }, e.prototype.toString = function() {
      return "TraceIdRatioBased{" + this._ratio + "}";
    }, e.prototype._normalize = function(t) {
      return typeof t != "number" || isNaN(t) ? 0 : t >= 1 ? 1 : t <= 0 ? 0 : t;
    }, e.prototype._accumulate = function(t) {
      for (var r = 0, n = 0; n < t.length / 8; n++) {
        var i = n * 8, o = parseInt(t.slice(i, i + 8), 16);
        r = (r ^ o) >>> 0;
      }
      return r;
    }, e;
  }()
), sd = te.AlwaysOn, $e = 1;
function ba() {
  var e = Je();
  return {
    sampler: wa(e),
    forceFlushTimeoutMillis: 3e4,
    generalLimits: {
      attributeValueLengthLimit: e.OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT,
      attributeCountLimit: e.OTEL_ATTRIBUTE_COUNT_LIMIT
    },
    spanLimits: {
      attributeValueLengthLimit: e.OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT,
      attributeCountLimit: e.OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT,
      linkCountLimit: e.OTEL_SPAN_LINK_COUNT_LIMIT,
      eventCountLimit: e.OTEL_SPAN_EVENT_COUNT_LIMIT,
      attributePerEventCountLimit: e.OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT,
      attributePerLinkCountLimit: e.OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT
    },
    mergeResourceWithDefaults: !0
  };
}
function wa(e) {
  switch (e === void 0 && (e = Je()), e.OTEL_TRACES_SAMPLER) {
    case te.AlwaysOn:
      return new We();
    case te.AlwaysOff:
      return new or();
    case te.ParentBasedAlwaysOn:
      return new zr({
        root: new We()
      });
    case te.ParentBasedAlwaysOff:
      return new zr({
        root: new or()
      });
    case te.TraceIdRatio:
      return new Ii(xi(e));
    case te.ParentBasedTraceIdRatio:
      return new zr({
        root: new Ii(xi(e))
      });
    default:
      return g.error('OTEL_TRACES_SAMPLER value "' + e.OTEL_TRACES_SAMPLER + " invalid, defaulting to " + sd + '".'), new We();
  }
}
function xi(e) {
  if (e.OTEL_TRACES_SAMPLER_ARG === void 0 || e.OTEL_TRACES_SAMPLER_ARG === "")
    return g.error("OTEL_TRACES_SAMPLER_ARG is blank, defaulting to " + $e + "."), $e;
  var t = Number(e.OTEL_TRACES_SAMPLER_ARG);
  return isNaN(t) ? (g.error("OTEL_TRACES_SAMPLER_ARG=" + e.OTEL_TRACES_SAMPLER_ARG + " was given, but it is invalid, defaulting to " + $e + "."), $e) : t < 0 || t > 1 ? (g.error("OTEL_TRACES_SAMPLER_ARG=" + e.OTEL_TRACES_SAMPLER_ARG + " was given, but it is out of range ([0..1]), defaulting to " + $e + "."), $e) : t;
}
function ud(e) {
  var t = {
    sampler: wa()
  }, r = ba(), n = Object.assign({}, r, t, e);
  return n.generalLimits = Object.assign({}, r.generalLimits, e.generalLimits || {}), n.spanLimits = Object.assign({}, r.spanLimits, e.spanLimits || {}), n;
}
function cd(e) {
  var t, r, n, i, o, a, u, c, s, l, f, d, h = Object.assign({}, e.spanLimits), _ = Gl();
  return h.attributeCountLimit = (a = (o = (i = (r = (t = e.spanLimits) === null || t === void 0 ? void 0 : t.attributeCountLimit) !== null && r !== void 0 ? r : (n = e.generalLimits) === null || n === void 0 ? void 0 : n.attributeCountLimit) !== null && i !== void 0 ? i : _.OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT) !== null && o !== void 0 ? o : _.OTEL_ATTRIBUTE_COUNT_LIMIT) !== null && a !== void 0 ? a : Kt, h.attributeValueLengthLimit = (d = (f = (l = (c = (u = e.spanLimits) === null || u === void 0 ? void 0 : u.attributeValueLengthLimit) !== null && c !== void 0 ? c : (s = e.generalLimits) === null || s === void 0 ? void 0 : s.attributeValueLengthLimit) !== null && l !== void 0 ? l : _.OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT) !== null && f !== void 0 ? f : _.OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT) !== null && d !== void 0 ? d : Wt, Object.assign({}, e, { spanLimits: h });
}
var ld = (
  /** @class */
  function() {
    function e(t, r) {
      this._exporter = t, this._isExporting = !1, this._finishedSpans = [], this._droppedSpansCount = 0;
      var n = Je();
      this._maxExportBatchSize = typeof (r == null ? void 0 : r.maxExportBatchSize) == "number" ? r.maxExportBatchSize : n.OTEL_BSP_MAX_EXPORT_BATCH_SIZE, this._maxQueueSize = typeof (r == null ? void 0 : r.maxQueueSize) == "number" ? r.maxQueueSize : n.OTEL_BSP_MAX_QUEUE_SIZE, this._scheduledDelayMillis = typeof (r == null ? void 0 : r.scheduledDelayMillis) == "number" ? r.scheduledDelayMillis : n.OTEL_BSP_SCHEDULE_DELAY, this._exportTimeoutMillis = typeof (r == null ? void 0 : r.exportTimeoutMillis) == "number" ? r.exportTimeoutMillis : n.OTEL_BSP_EXPORT_TIMEOUT, this._shutdownOnce = new Uf(this._shutdown, this), this._maxExportBatchSize > this._maxQueueSize && (g.warn("BatchSpanProcessor: maxExportBatchSize must be smaller or equal to maxQueueSize, setting maxExportBatchSize to match maxQueueSize"), this._maxExportBatchSize = this._maxQueueSize);
    }
    return e.prototype.forceFlush = function() {
      return this._shutdownOnce.isCalled ? this._shutdownOnce.promise : this._flushAll();
    }, e.prototype.onStart = function(t, r) {
    }, e.prototype.onEnd = function(t) {
      this._shutdownOnce.isCalled || (t.spanContext().traceFlags & le.SAMPLED) !== 0 && this._addToBuffer(t);
    }, e.prototype.shutdown = function() {
      return this._shutdownOnce.call();
    }, e.prototype._shutdown = function() {
      var t = this;
      return Promise.resolve().then(function() {
        return t.onShutdown();
      }).then(function() {
        return t._flushAll();
      }).then(function() {
        return t._exporter.shutdown();
      });
    }, e.prototype._addToBuffer = function(t) {
      if (this._finishedSpans.length >= this._maxQueueSize) {
        this._droppedSpansCount === 0 && g.debug("maxQueueSize reached, dropping spans"), this._droppedSpansCount++;
        return;
      }
      this._droppedSpansCount > 0 && (g.warn("Dropped " + this._droppedSpansCount + " spans because maxQueueSize reached"), this._droppedSpansCount = 0), this._finishedSpans.push(t), this._maybeStartTimer();
    }, e.prototype._flushAll = function() {
      var t = this;
      return new Promise(function(r, n) {
        for (var i = [], o = Math.ceil(t._finishedSpans.length / t._maxExportBatchSize), a = 0, u = o; a < u; a++)
          i.push(t._flushOneBatch());
        Promise.all(i).then(function() {
          r();
        }).catch(n);
      });
    }, e.prototype._flushOneBatch = function() {
      var t = this;
      return this._clearTimer(), this._finishedSpans.length === 0 ? Promise.resolve() : new Promise(function(r, n) {
        var i = setTimeout(function() {
          n(new Error("Timeout"));
        }, t._exportTimeoutMillis);
        O.with(Qo(O.active()), function() {
          var o;
          t._finishedSpans.length <= t._maxExportBatchSize ? (o = t._finishedSpans, t._finishedSpans = []) : o = t._finishedSpans.splice(0, t._maxExportBatchSize);
          for (var a = function() {
            return t._exporter.export(o, function(f) {
              var d;
              clearTimeout(i), f.code === N.SUCCESS ? r() : n((d = f.error) !== null && d !== void 0 ? d : new Error("BatchSpanProcessor: span export failed"));
            });
          }, u = null, c = 0, s = o.length; c < s; c++) {
            var l = o[c];
            l.resource.asyncAttributesPending && l.resource.waitForAsyncAttributes && (u != null || (u = []), u.push(l.resource.waitForAsyncAttributes()));
          }
          u === null ? a() : Promise.all(u).then(a, function(f) {
            me(f), n(f);
          });
        });
      });
    }, e.prototype._maybeStartTimer = function() {
      var t = this;
      if (!this._isExporting) {
        var r = function() {
          t._isExporting = !0, t._flushOneBatch().finally(function() {
            t._isExporting = !1, t._finishedSpans.length > 0 && (t._clearTimer(), t._maybeStartTimer());
          }).catch(function(n) {
            t._isExporting = !1, me(n);
          });
        };
        if (this._finishedSpans.length >= this._maxExportBatchSize)
          return r();
        this._timer === void 0 && (this._timer = setTimeout(function() {
          return r();
        }, this._scheduledDelayMillis));
      }
    }, e.prototype._clearTimer = function() {
      this._timer !== void 0 && (clearTimeout(this._timer), this._timer = void 0);
    }, e;
  }()
), fd = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Aa = (
  /** @class */
  function(e) {
    fd(t, e);
    function t(r, n) {
      var i = e.call(this, r, n) || this;
      return i.onInit(n), i;
    }
    return t.prototype.onInit = function(r) {
      var n = this;
      (r == null ? void 0 : r.disableAutoFlushOnDocumentHide) !== !0 && typeof document != "undefined" && (this._visibilityChangeListener = function() {
        document.visibilityState === "hidden" && n.forceFlush().catch(function(i) {
          me(i);
        });
      }, this._pageHideListener = function() {
        n.forceFlush().catch(function(i) {
          me(i);
        });
      }, document.addEventListener("visibilitychange", this._visibilityChangeListener), document.addEventListener("pagehide", this._pageHideListener));
    }, t.prototype.onShutdown = function() {
      typeof document != "undefined" && (this._visibilityChangeListener && document.removeEventListener("visibilitychange", this._visibilityChangeListener), this._pageHideListener && document.removeEventListener("pagehide", this._pageHideListener));
    }, t;
  }(ld)
), dd = 8, pd = 16, hd = (
  /** @class */
  /* @__PURE__ */ function() {
    function e() {
      this.generateTraceId = Di(pd), this.generateSpanId = Di(dd);
    }
    return e;
  }()
), Dt = Array(32);
function Di(e) {
  return function() {
    for (var r = 0; r < e * 2; r++)
      Dt[r] = Math.floor(Math.random() * 16) + 48, Dt[r] >= 58 && (Dt[r] += 39);
    return String.fromCharCode.apply(null, Dt.slice(0, e * 2));
  };
}
var _d = (
  /** @class */
  function() {
    function e(t, r, n) {
      this._tracerProvider = n;
      var i = ud(r);
      this._sampler = i.sampler, this._generalLimits = i.generalLimits, this._spanLimits = i.spanLimits, this._idGenerator = r.idGenerator || new hd(), this.resource = n.resource, this.instrumentationLibrary = t;
    }
    return e.prototype.startSpan = function(t, r, n) {
      var i, o, a;
      r === void 0 && (r = {}), n === void 0 && (n = O.active()), r.root && (n = L.deleteSpan(n));
      var u = L.getSpan(n);
      if (Fn(n)) {
        g.debug("Instrumentation suppressed, returning Noop Span");
        var c = L.wrapSpanContext(qo);
        return c;
      }
      var s = u == null ? void 0 : u.spanContext(), l = this._idGenerator.generateSpanId(), f, d, h;
      !s || !L.isSpanContextValid(s) ? f = this._idGenerator.generateTraceId() : (f = s.traceId, d = s.traceState, h = s.spanId);
      var _ = (i = r.kind) !== null && i !== void 0 ? i : mt.INTERNAL, p = ((o = r.links) !== null && o !== void 0 ? o : []).map(function(C) {
        return {
          context: C.context,
          attributes: qt(C.attributes)
        };
      }), v = qt(r.attributes), y = this._sampler.shouldSample(n, f, t, _, v, p);
      d = (a = y.traceState) !== null && a !== void 0 ? a : d;
      var m = y.decision === er.RECORD_AND_SAMPLED ? le.SAMPLED : le.NONE, w = { traceId: f, spanId: l, traceFlags: m, traceState: d };
      if (y.decision === er.NOT_RECORD) {
        g.debug("Recording is off, propagating context in a non-recording span");
        var c = L.wrapSpanContext(w);
        return c;
      }
      var A = qt(Object.assign(v, y.attributes)), R = new ad(this, n, t, w, _, h, p, r.startTime, void 0, A);
      return R;
    }, e.prototype.startActiveSpan = function(t, r, n, i) {
      var o, a, u;
      if (!(arguments.length < 2)) {
        arguments.length === 2 ? u = r : arguments.length === 3 ? (o = r, u = n) : (o = r, a = n, u = i);
        var c = a != null ? a : O.active(), s = this.startSpan(t, o, c), l = L.setSpan(c, s);
        return O.with(l, u, void 0, s);
      }
    }, e.prototype.getGeneralLimits = function() {
      return this._generalLimits;
    }, e.prototype.getSpanLimits = function() {
      return this._spanLimits;
    }, e.prototype.getActiveSpanProcessor = function() {
      return this._tracerProvider.getActiveSpanProcessor();
    }, e;
  }()
), vd = "service.name", yd = "telemetry.sdk.name", gd = "telemetry.sdk.language", md = "telemetry.sdk.version", Ed = vd, ki = yd, Ui = gd, Bi = md;
function Td() {
  return "unknown_service";
}
var _e = function() {
  return _e = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, _e.apply(this, arguments);
}, Sd = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, bd = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, wd = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Et = (
  /** @class */
  function() {
    function e(t, r) {
      var n = this, i;
      this._attributes = t, this.asyncAttributesPending = r != null, this._syncAttributes = (i = this._attributes) !== null && i !== void 0 ? i : {}, this._asyncAttributesPromise = r == null ? void 0 : r.then(function(o) {
        return n._attributes = Object.assign({}, n._attributes, o), n.asyncAttributesPending = !1, o;
      }, function(o) {
        return g.debug("a resource's async attributes promise rejected: %s", o), n.asyncAttributesPending = !1, {};
      });
    }
    return e.empty = function() {
      return e.EMPTY;
    }, e.default = function() {
      var t;
      return new e((t = {}, t[Ed] = Td(), t[Ui] = Gr[Ui], t[ki] = Gr[ki], t[Bi] = Gr[Bi], t));
    }, Object.defineProperty(e.prototype, "attributes", {
      get: function() {
        var t;
        return this.asyncAttributesPending && g.error("Accessing resource attributes before async attributes settled"), (t = this._attributes) !== null && t !== void 0 ? t : {};
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.waitForAsyncAttributes = function() {
      return Sd(this, void 0, void 0, function() {
        return bd(this, function(t) {
          switch (t.label) {
            case 0:
              return this.asyncAttributesPending ? [4, this._asyncAttributesPromise] : [3, 2];
            case 1:
              t.sent(), t.label = 2;
            case 2:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.merge = function(t) {
      var r = this, n;
      if (!t)
        return this;
      var i = _e(_e({}, this._syncAttributes), (n = t._syncAttributes) !== null && n !== void 0 ? n : t.attributes);
      if (!this._asyncAttributesPromise && !t._asyncAttributesPromise)
        return new e(i);
      var o = Promise.all([
        this._asyncAttributesPromise,
        t._asyncAttributesPromise
      ]).then(function(a) {
        var u, c = wd(a, 2), s = c[0], l = c[1];
        return _e(_e(_e(_e({}, r._syncAttributes), s), (u = t._syncAttributes) !== null && u !== void 0 ? u : t.attributes), l);
      });
      return new e(i, o);
    }, e.EMPTY = new e({}), e;
  }()
), kt = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Hi = (
  /** @class */
  function() {
    function e(t) {
      this._spanProcessors = t;
    }
    return e.prototype.forceFlush = function() {
      var t, r, n = [];
      try {
        for (var i = kt(this._spanProcessors), o = i.next(); !o.done; o = i.next()) {
          var a = o.value;
          n.push(a.forceFlush());
        }
      } catch (u) {
        t = { error: u };
      } finally {
        try {
          o && !o.done && (r = i.return) && r.call(i);
        } finally {
          if (t) throw t.error;
        }
      }
      return new Promise(function(u) {
        Promise.all(n).then(function() {
          u();
        }).catch(function(c) {
          me(c || new Error("MultiSpanProcessor: forceFlush failed")), u();
        });
      });
    }, e.prototype.onStart = function(t, r) {
      var n, i;
      try {
        for (var o = kt(this._spanProcessors), a = o.next(); !a.done; a = o.next()) {
          var u = a.value;
          u.onStart(t, r);
        }
      } catch (c) {
        n = { error: c };
      } finally {
        try {
          a && !a.done && (i = o.return) && i.call(o);
        } finally {
          if (n) throw n.error;
        }
      }
    }, e.prototype.onEnd = function(t) {
      var r, n;
      try {
        for (var i = kt(this._spanProcessors), o = i.next(); !o.done; o = i.next()) {
          var a = o.value;
          a.onEnd(t);
        }
      } catch (u) {
        r = { error: u };
      } finally {
        try {
          o && !o.done && (n = i.return) && n.call(i);
        } finally {
          if (r) throw r.error;
        }
      }
    }, e.prototype.shutdown = function() {
      var t, r, n = [];
      try {
        for (var i = kt(this._spanProcessors), o = i.next(); !o.done; o = i.next()) {
          var a = o.value;
          n.push(a.shutdown());
        }
      } catch (u) {
        t = { error: u };
      } finally {
        try {
          o && !o.done && (r = i.return) && r.call(i);
        } finally {
          if (t) throw t.error;
        }
      }
      return new Promise(function(u, c) {
        Promise.all(n).then(function() {
          u();
        }, c);
      });
    }, e;
  }()
), Ad = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.onStart = function(t, r) {
    }, e.prototype.onEnd = function(t) {
    }, e.prototype.shutdown = function() {
      return Promise.resolve();
    }, e.prototype.forceFlush = function() {
      return Promise.resolve();
    }, e;
  }()
), Od = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Rd = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Oe;
(function(e) {
  e[e.resolved = 0] = "resolved", e[e.timeout = 1] = "timeout", e[e.error = 2] = "error", e[e.unresolved = 3] = "unresolved";
})(Oe || (Oe = {}));
var Ld = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = {});
      var r, n;
      this._registeredSpanProcessors = [], this._tracers = /* @__PURE__ */ new Map();
      var i = pa({}, ba(), cd(t));
      if (this.resource = (r = i.resource) !== null && r !== void 0 ? r : Et.empty(), i.mergeResourceWithDefaults && (this.resource = Et.default().merge(this.resource)), this._config = Object.assign({}, i, {
        resource: this.resource
      }), !((n = t.spanProcessors) === null || n === void 0) && n.length)
        this._registeredSpanProcessors = Rd([], Od(t.spanProcessors), !1), this.activeSpanProcessor = new Hi(this._registeredSpanProcessors);
      else {
        var o = this._buildExporterFromEnv();
        if (o !== void 0) {
          var a = new Aa(o);
          this.activeSpanProcessor = a;
        } else
          this.activeSpanProcessor = new Ad();
      }
    }
    return e.prototype.getTracer = function(t, r, n) {
      var i = t + "@" + (r || "") + ":" + ((n == null ? void 0 : n.schemaUrl) || "");
      return this._tracers.has(i) || this._tracers.set(i, new _d({ name: t, version: r, schemaUrl: n == null ? void 0 : n.schemaUrl }, this._config, this)), this._tracers.get(i);
    }, e.prototype.addSpanProcessor = function(t) {
      this._registeredSpanProcessors.length === 0 && this.activeSpanProcessor.shutdown().catch(function(r) {
        return g.error("Error while trying to shutdown current span processor", r);
      }), this._registeredSpanProcessors.push(t), this.activeSpanProcessor = new Hi(this._registeredSpanProcessors);
    }, e.prototype.getActiveSpanProcessor = function() {
      return this.activeSpanProcessor;
    }, e.prototype.register = function(t) {
      t === void 0 && (t = {}), L.setGlobalTracerProvider(this), t.propagator === void 0 && (t.propagator = this._buildPropagatorFromEnv()), t.contextManager && O.setGlobalContextManager(t.contextManager), t.propagator && q.setGlobalPropagator(t.propagator);
    }, e.prototype.forceFlush = function() {
      var t = this._config.forceFlushTimeoutMillis, r = this._registeredSpanProcessors.map(function(n) {
        return new Promise(function(i) {
          var o, a = setTimeout(function() {
            i(new Error("Span processor did not completed within timeout period of " + t + " ms")), o = Oe.timeout;
          }, t);
          n.forceFlush().then(function() {
            clearTimeout(a), o !== Oe.timeout && (o = Oe.resolved, i(o));
          }).catch(function(u) {
            clearTimeout(a), o = Oe.error, i(u);
          });
        });
      });
      return new Promise(function(n, i) {
        Promise.all(r).then(function(o) {
          var a = o.filter(function(u) {
            return u !== Oe.resolved;
          });
          a.length > 0 ? i(a) : n();
        }).catch(function(o) {
          return i([o]);
        });
      });
    }, e.prototype.shutdown = function() {
      return this.activeSpanProcessor.shutdown();
    }, e.prototype._getPropagator = function(t) {
      var r;
      return (r = this.constructor._registeredPropagators.get(t)) === null || r === void 0 ? void 0 : r();
    }, e.prototype._getSpanExporter = function(t) {
      var r;
      return (r = this.constructor._registeredExporters.get(t)) === null || r === void 0 ? void 0 : r();
    }, e.prototype._buildPropagatorFromEnv = function() {
      var t = this, r = Array.from(new Set(Je().OTEL_PROPAGATORS)), n = r.map(function(o) {
        var a = t._getPropagator(o);
        return a || g.warn('Propagator "' + o + '" requested through environment variable is unavailable.'), a;
      }), i = n.reduce(function(o, a) {
        return a && o.push(a), o;
      }, []);
      if (i.length !== 0)
        return r.length === 1 ? i[0] : new sa({
          propagators: i
        });
    }, e.prototype._buildExporterFromEnv = function() {
      var t = Je().OTEL_TRACES_EXPORTER;
      if (!(t === "none" || t === "")) {
        var r = this._getSpanExporter(t);
        return r || g.error('Exporter "' + t + '" requested through environment variable is unavailable.'), r;
      }
    }, e._registeredPropagators = /* @__PURE__ */ new Map([
      ["tracecontext", function() {
        return new ua();
      }],
      ["baggage", function() {
        return new ea();
      }]
    ]), e._registeredExporters = /* @__PURE__ */ new Map(), e;
  }()
), Pd = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Nd = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Oa = (
  /** @class */
  function() {
    function e() {
      this._enabled = !1, this._currentContext = we;
    }
    return e.prototype._bindFunction = function(t, r) {
      t === void 0 && (t = we);
      var n = this, i = function() {
        for (var o = this, a = [], u = 0; u < arguments.length; u++)
          a[u] = arguments[u];
        return n.with(t, function() {
          return r.apply(o, a);
        });
      };
      return Object.defineProperty(i, "length", {
        enumerable: !1,
        configurable: !0,
        writable: !1,
        value: r.length
      }), i;
    }, e.prototype.active = function() {
      return this._currentContext;
    }, e.prototype.bind = function(t, r) {
      return t === void 0 && (t = this.active()), typeof r == "function" ? this._bindFunction(t, r) : r;
    }, e.prototype.disable = function() {
      return this._currentContext = we, this._enabled = !1, this;
    }, e.prototype.enable = function() {
      return this._enabled ? this : (this._enabled = !0, this._currentContext = we, this);
    }, e.prototype.with = function(t, r, n) {
      for (var i = [], o = 3; o < arguments.length; o++)
        i[o - 3] = arguments[o];
      var a = this._currentContext;
      this._currentContext = t || we;
      try {
        return r.call.apply(r, Nd([n], Pd(i), !1));
      } finally {
        this._currentContext = a;
      }
    }, e;
  }()
), Cd = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Md = (
  /** @class */
  function(e) {
    Cd(t, e);
    function t(r) {
      r === void 0 && (r = {});
      var n = e.call(this, r) || this;
      if (r.contextManager)
        throw "contextManager should be defined in register method not in constructor";
      if (r.propagator)
        throw "propagator should be defined in register method not in constructor";
      return n;
    }
    return t.prototype.register = function(r) {
      r === void 0 && (r = {}), r.contextManager === void 0 && (r.contextManager = new Oa()), r.contextManager && r.contextManager.enable(), e.prototype.register.call(this, r);
    }, t;
  }(Ld)
), T;
(function(e) {
  e.CONNECT_END = "connectEnd", e.CONNECT_START = "connectStart", e.DECODED_BODY_SIZE = "decodedBodySize", e.DOM_COMPLETE = "domComplete", e.DOM_CONTENT_LOADED_EVENT_END = "domContentLoadedEventEnd", e.DOM_CONTENT_LOADED_EVENT_START = "domContentLoadedEventStart", e.DOM_INTERACTIVE = "domInteractive", e.DOMAIN_LOOKUP_END = "domainLookupEnd", e.DOMAIN_LOOKUP_START = "domainLookupStart", e.ENCODED_BODY_SIZE = "encodedBodySize", e.FETCH_START = "fetchStart", e.LOAD_EVENT_END = "loadEventEnd", e.LOAD_EVENT_START = "loadEventStart", e.NAVIGATION_START = "navigationStart", e.REDIRECT_END = "redirectEnd", e.REDIRECT_START = "redirectStart", e.REQUEST_START = "requestStart", e.RESPONSE_END = "responseEnd", e.RESPONSE_START = "responseStart", e.SECURE_CONNECTION_START = "secureConnectionStart", e.UNLOAD_EVENT_END = "unloadEventEnd", e.UNLOAD_EVENT_START = "unloadEventStart";
})(T || (T = {}));
var Id = "http.response_content_length", xd = "http.response_content_length_uncompressed", Dd = Id, kd = xd, Xr;
function Ud() {
  return Xr || (Xr = document.createElement("a")), Xr;
}
function Ee(e, t) {
  return t in e;
}
function k(e, t, r, n) {
  var i = void 0, o = void 0;
  Ee(r, t) && typeof r[t] == "number" && (i = r[t]);
  var a = T.FETCH_START;
  if (Ee(r, a) && typeof r[a] == "number" && (o = r[a]), i !== void 0 && o !== void 0 && i >= o)
    return e.addEvent(t, i), e;
}
function Qe(e, t, r) {
  r === void 0 && (r = !1), r || (k(e, T.FETCH_START, t), k(e, T.DOMAIN_LOOKUP_START, t), k(e, T.DOMAIN_LOOKUP_END, t), k(e, T.CONNECT_START, t), Ee(t, "name") && t.name.startsWith("https:") && k(e, T.SECURE_CONNECTION_START, t), k(e, T.CONNECT_END, t), k(e, T.REQUEST_START, t), k(e, T.RESPONSE_START, t), k(e, T.RESPONSE_END, t));
  var n = t[T.ENCODED_BODY_SIZE];
  n !== void 0 && e.setAttribute(Dd, n);
  var i = t[T.DECODED_BODY_SIZE];
  i !== void 0 && n !== i && e.setAttribute(kd, i);
}
function Bd(e) {
  return e.slice().sort(function(t, r) {
    var n = t[T.FETCH_START], i = r[T.FETCH_START];
    return n > i ? 1 : n < i ? -1 : 0;
  });
}
function Ra() {
  return typeof location != "undefined" ? location.origin : void 0;
}
function La(e, t, r, n, i, o) {
  i === void 0 && (i = /* @__PURE__ */ new WeakSet());
  var a = ue(e);
  e = a.toString();
  var u = Gd(e, t, r, n, i, o);
  if (u.length === 0)
    return {
      mainRequest: void 0
    };
  if (u.length === 1)
    return {
      mainRequest: u[0]
    };
  var c = Bd(u);
  if (a.origin !== Ra() && c.length > 1) {
    var s = c[0], l = Hd(c, s[T.RESPONSE_END], r), f = s[T.RESPONSE_END], d = l[T.FETCH_START];
    return d < f && (l = s, s = void 0), {
      corsPreFlightRequest: s,
      mainRequest: l
    };
  } else
    return {
      mainRequest: u[0]
    };
}
function Hd(e, t, r) {
  for (var n = ce(r), i = ce(ht(t)), o = e[1], a, u = e.length, c = 1; c < u; c++) {
    var s = e[c], l = ce(ht(s[T.FETCH_START])), f = ce(ht(s[T.RESPONSE_END])), d = n - f;
    l >= i && (!a || d < a) && (a = d, o = s);
  }
  return o;
}
function Gd(e, t, r, n, i, o) {
  var a = ce(t), u = ce(r), c = n.filter(function(s) {
    var l = ce(ht(s[T.FETCH_START])), f = ce(ht(s[T.RESPONSE_END]));
    return s.initiatorType.toLowerCase() === (o || "xmlhttprequest") && s.name === e && l >= a && f <= u;
  });
  return c.length > 0 && (c = c.filter(function(s) {
    return !i.has(s);
  })), c;
}
function ue(e) {
  if (typeof URL == "function")
    return new URL(e, typeof document != "undefined" ? document.baseURI : typeof location != "undefined" ? location.href : void 0);
  var t = Ud();
  return t.href = e, t;
}
function Pa(e, t) {
  if (e.nodeType === Node.DOCUMENT_NODE)
    return "/";
  var r = jd(e, t);
  if (t && r.indexOf("@id") > 0)
    return r;
  var n = "";
  return e.parentNode && (n += Pa(e.parentNode, !1)), n += r, n;
}
function Fd(e) {
  if (!e.parentNode)
    return 0;
  var t = [e.nodeType];
  e.nodeType === Node.CDATA_SECTION_NODE && t.push(Node.TEXT_NODE);
  var r = Array.from(e.parentNode.childNodes);
  return r = r.filter(function(n) {
    var i = n.localName;
    return t.indexOf(n.nodeType) >= 0 && i === e.localName;
  }), r.length >= 1 ? r.indexOf(e) + 1 : 0;
}
function jd(e, t) {
  var r = e.nodeType, n = Fd(e), i = "";
  if (r === Node.ELEMENT_NODE) {
    var o = e.getAttribute("id");
    if (t && o)
      return '//*[@id="' + o + '"]';
    i = e.localName;
  } else if (r === Node.TEXT_NODE || r === Node.CDATA_SECTION_NODE)
    i = "text()";
  else if (r === Node.COMMENT_NODE)
    i = "comment()";
  else
    return "";
  return i && n > 1 ? "/" + i + "[" + n + "]" : "/" + i;
}
function Na(e, t) {
  var r = t || [];
  (typeof r == "string" || r instanceof RegExp) && (r = [r]);
  var n = ue(e);
  return n.origin === Ra() ? !0 : r.some(function(i) {
    return va(e, i);
  });
}
var _t;
(function(e) {
  e.DOCUMENT_LOAD = "documentLoad", e.DOCUMENT_FETCH = "documentFetch", e.RESOURCE_FETCH = "resourceFetch";
})(_t || (_t = {}));
var Vd = "0.44.0", $d = "@opentelemetry/instrumentation-document-load";
const zd = "http.method", Xd = "http.url", qd = "http.status_code", Wd = "http.user_agent", Kd = zd, Ke = Xd, Yd = qd, Jd = Wd;
var ar;
(function(e) {
  e.FIRST_PAINT = "firstPaint", e.FIRST_CONTENTFUL_PAINT = "firstContentfulPaint";
})(ar || (ar = {}));
var Zd = function() {
  var e, t, r = {}, n = (t = (e = K).getEntriesByType) === null || t === void 0 ? void 0 : t.call(e, "navigation")[0];
  if (n) {
    var i = Object.values(T);
    i.forEach(function(u) {
      if (Ee(n, u)) {
        var c = n[u];
        typeof c == "number" && (r[u] = c);
      }
    });
  } else {
    var o = K, a = o.timing;
    if (a) {
      var i = Object.values(T);
      i.forEach(function(c) {
        if (Ee(a, c)) {
          var s = a[c];
          typeof s == "number" && (r[c] = s);
        }
      });
    }
  }
  return r;
}, Gi = {
  "first-paint": ar.FIRST_PAINT,
  "first-contentful-paint": ar.FIRST_CONTENTFUL_PAINT
}, Qd = function(e) {
  var t, r, n = (r = (t = K).getEntriesByType) === null || r === void 0 ? void 0 : r.call(t, "paint");
  n && n.forEach(function(i) {
    var o = i.name, a = i.startTime;
    Ee(Gi, o) && e.addEvent(Gi[o], a);
  });
}, ep = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), tp = (
  /** @class */
  function(e) {
    ep(t, e);
    function t(r) {
      r === void 0 && (r = {});
      var n = e.call(this, $d, Vd, r) || this;
      return n.component = "document-load", n.version = "1", n.moduleName = n.component, n;
    }
    return t.prototype.init = function() {
    }, t.prototype._onDocumentLoaded = function() {
      var r = this;
      window.setTimeout(function() {
        r._collectPerformance();
      });
    }, t.prototype._addResourcesSpans = function(r) {
      var n = this, i, o, a = (o = (i = K).getEntriesByType) === null || o === void 0 ? void 0 : o.call(i, "resource");
      a && a.forEach(function(u) {
        n._initResourceSpan(u, r);
      });
    }, t.prototype._collectPerformance = function() {
      var r = this, n = Array.from(document.getElementsByTagName("meta")).find(function(a) {
        return a.getAttribute("name") === Yt;
      }), i = Zd(), o = n && n.content || "";
      O.with(q.extract(we, { traceparent: o }), function() {
        var a, u = r._startSpan(_t.DOCUMENT_LOAD, T.FETCH_START, i);
        u && (O.with(L.setSpan(O.active(), u), function() {
          var c = r._startSpan(_t.DOCUMENT_FETCH, T.FETCH_START, i);
          c && (c.setAttribute(Ke, location.href), O.with(L.setSpan(O.active(), c), function() {
            var s;
            r.getConfig().ignoreNetworkEvents || Qe(c, i), r._addCustomAttributesOnSpan(c, (s = r.getConfig().applyCustomAttributesOnSpan) === null || s === void 0 ? void 0 : s.documentFetch), r._endSpan(c, T.RESPONSE_END, i);
          }));
        }), u.setAttribute(Ke, location.href), u.setAttribute(Jd, navigator.userAgent), r._addResourcesSpans(u), r.getConfig().ignoreNetworkEvents || (k(u, T.FETCH_START, i), k(u, T.UNLOAD_EVENT_START, i), k(u, T.UNLOAD_EVENT_END, i), k(u, T.DOM_INTERACTIVE, i), k(u, T.DOM_CONTENT_LOADED_EVENT_START, i), k(u, T.DOM_CONTENT_LOADED_EVENT_END, i), k(u, T.DOM_COMPLETE, i), k(u, T.LOAD_EVENT_START, i), k(u, T.LOAD_EVENT_END, i)), r.getConfig().ignorePerformancePaintEvents || Qd(u), r._addCustomAttributesOnSpan(u, (a = r.getConfig().applyCustomAttributesOnSpan) === null || a === void 0 ? void 0 : a.documentLoad), r._endSpan(u, T.LOAD_EVENT_END, i));
      });
    }, t.prototype._endSpan = function(r, n, i) {
      r && (Ee(i, n) ? r.end(i[n]) : r.end());
    }, t.prototype._initResourceSpan = function(r, n) {
      var i, o = this._startSpan(_t.RESOURCE_FETCH, T.FETCH_START, r, n);
      o && (o.setAttribute(Ke, r.name), this.getConfig().ignoreNetworkEvents || Qe(o, r), this._addCustomAttributesOnResourceSpan(o, r, (i = this.getConfig().applyCustomAttributesOnSpan) === null || i === void 0 ? void 0 : i.resourceFetch), this._endSpan(o, T.RESPONSE_END, r));
    }, t.prototype._startSpan = function(r, n, i, o) {
      if (Ee(i, n) && typeof i[n] == "number") {
        var a = this.tracer.startSpan(r, {
          startTime: i[n]
        }, o ? L.setSpan(O.active(), o) : void 0);
        return a;
      }
    }, t.prototype._waitForPageLoad = function() {
      window.document.readyState === "complete" ? this._onDocumentLoaded() : (this._onDocumentLoaded = this._onDocumentLoaded.bind(this), window.addEventListener("load", this._onDocumentLoaded));
    }, t.prototype._addCustomAttributesOnSpan = function(r, n) {
      var i = this;
      n && ir(function() {
        return n(r);
      }, function(o) {
        o && i._diag.error("addCustomAttributesOnSpan", o);
      });
    }, t.prototype._addCustomAttributesOnResourceSpan = function(r, n, i) {
      var o = this;
      i && ir(function() {
        return i(r, n);
      }, function(a) {
        a && o._diag.error("addCustomAttributesOnResourceSpan", a);
      });
    }, t.prototype.enable = function() {
      window.removeEventListener("load", this._onDocumentLoaded), this._waitForPageLoad();
    }, t.prototype.disable = function() {
      window.removeEventListener("load", this._onDocumentLoaded);
    }, t;
  }(Lt)
), sr;
(function(e) {
  e.COMPONENT = "component", e.HTTP_ERROR_NAME = "http.error_name", e.HTTP_STATUS_TEXT = "http.status_text";
})(sr || (sr = {}));
var rp = "http.method", np = "http.url", ip = "http.host", op = "http.scheme", ap = "http.status_code", sp = "http.user_agent", up = "http.request_content_length_uncompressed", cp = rp, lp = np, fp = ip, dp = op, pp = ap, hp = sp, _p = up, vp = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, yp = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, gp = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, mp = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Ca = g.createComponentLogger({
  namespace: "@opentelemetry/opentelemetry-instrumentation-fetch/utils"
});
function Ep() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  if (e[0] instanceof URL || typeof e[0] == "string") {
    var r = e[1];
    if (!(r != null && r.body))
      return Promise.resolve();
    if (r.body instanceof ReadableStream) {
      var n = Tp(r.body), i = n.body, o = n.length;
      return r.body = i, o;
    } else
      return Promise.resolve(Sp(r.body));
  } else {
    var a = e[0];
    return a != null && a.body ? a.clone().text().then(function(u) {
      return En(u);
    }) : Promise.resolve();
  }
}
function Tp(e) {
  if (!e.pipeThrough)
    return Ca.warn("Platform has ReadableStream but not pipeThrough!"), {
      body: e,
      length: Promise.resolve(void 0)
    };
  var t = 0, r, n = new Promise(function(o) {
    r = o;
  }), i = new TransformStream({
    start: function() {
    },
    transform: function(o, a) {
      return vp(this, void 0, void 0, function() {
        var u;
        return yp(this, function(c) {
          switch (c.label) {
            case 0:
              return [4, o];
            case 1:
              return u = c.sent(), t += u.byteLength, a.enqueue(o), [
                2
                /*return*/
              ];
          }
        });
      });
    },
    flush: function() {
      r(t);
    }
  });
  return {
    body: e.pipeThrough(i),
    length: n
  };
}
function Sp(e) {
  if (typeof Document != "undefined" && e instanceof Document)
    return new XMLSerializer().serializeToString(document).length;
  if (e instanceof Blob)
    return e.size;
  if (e.byteLength !== void 0)
    return e.byteLength;
  if (e instanceof FormData)
    return wp(e);
  if (e instanceof URLSearchParams)
    return En(e.toString());
  if (typeof e == "string")
    return En(e);
  Ca.warn("unknown body type");
}
var bp = new TextEncoder();
function En(e) {
  return bp.encode(e).byteLength;
}
function wp(e) {
  var t, r, n = 0;
  try {
    for (var i = gp(e.entries()), o = i.next(); !o.done; o = i.next()) {
      var a = mp(o.value, 2), u = a[0], c = a[1];
      n += u.length, c instanceof Blob ? n += c.size : n += c.length;
    }
  } catch (s) {
    t = { error: s };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return n;
}
var Fi = "0.57.2", Ap = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Op = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Rp = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, qr, Lp = 300, ji = typeof process == "object" && ((qr = process.release) === null || qr === void 0 ? void 0 : qr.name) === "node", Pp = (
  /** @class */
  function(e) {
    Ap(t, e);
    function t(r) {
      r === void 0 && (r = {});
      var n = e.call(this, "@opentelemetry/instrumentation-fetch", Fi, r) || this;
      return n.component = "fetch", n.version = Fi, n.moduleName = n.component, n._usedResources = /* @__PURE__ */ new WeakSet(), n._tasksCount = 0, n;
    }
    return t.prototype.init = function() {
    }, t.prototype._addChildSpan = function(r, n) {
      var i = this.tracer.startSpan("CORS Preflight", {
        startTime: n[T.FETCH_START]
      }, L.setSpan(O.active(), r));
      Qe(i, n, this.getConfig().ignoreNetworkEvents), i.end(n[T.RESPONSE_END]);
    }, t.prototype._addFinalSpanAttributes = function(r, n) {
      var i = ue(n.url);
      r.setAttribute(pp, n.status), n.statusText != null && r.setAttribute(sr.HTTP_STATUS_TEXT, n.statusText), r.setAttribute(fp, i.host), r.setAttribute(dp, i.protocol.replace(":", "")), typeof navigator != "undefined" && r.setAttribute(hp, navigator.userAgent);
    }, t.prototype._addHeaders = function(r, n) {
      if (!Na(n, this.getConfig().propagateTraceHeaderCorsUrls)) {
        var i = {};
        q.inject(O.active(), i), Object.keys(i).length > 0 && this._diag.debug("headers inject skipped due to CORS policy");
        return;
      }
      if (r instanceof Request)
        q.inject(O.active(), r.headers, {
          set: function(o, a, u) {
            return o.set(a, typeof u == "string" ? u : String(u));
          }
        });
      else if (r.headers instanceof Headers)
        q.inject(O.active(), r.headers, {
          set: function(o, a, u) {
            return o.set(a, typeof u == "string" ? u : String(u));
          }
        });
      else if (r.headers instanceof Map)
        q.inject(O.active(), r.headers, {
          set: function(o, a, u) {
            return o.set(a, typeof u == "string" ? u : String(u));
          }
        });
      else {
        var i = {};
        q.inject(O.active(), i), r.headers = Object.assign({}, i, r.headers || {});
      }
    }, t.prototype._clearResources = function() {
      this._tasksCount === 0 && this.getConfig().clearTimingResources && (performance.clearResourceTimings(), this._usedResources = /* @__PURE__ */ new WeakSet());
    }, t.prototype._createSpan = function(r, n) {
      var i;
      if (n === void 0 && (n = {}), ya(r, this.getConfig().ignoreUrls)) {
        this._diag.debug("ignoring span as url matches ignored url");
        return;
      }
      var o = (n.method || "GET").toUpperCase(), a = "HTTP " + o;
      return this.tracer.startSpan(a, {
        kind: mt.CLIENT,
        attributes: (i = {}, i[sr.COMPONENT] = this.moduleName, i[cp] = o, i[lp] = r, i)
      });
    }, t.prototype._findResourceAndAddNetworkEvents = function(r, n, i) {
      var o = n.entries;
      if (!o.length) {
        if (!performance.getEntriesByType)
          return;
        o = performance.getEntriesByType("resource");
      }
      var a = La(n.spanUrl, n.startTime, i, o, this._usedResources, "fetch");
      if (a.mainRequest) {
        var u = a.mainRequest;
        this._markResourceAsUsed(u);
        var c = a.corsPreFlightRequest;
        c && (this._addChildSpan(r, c), this._markResourceAsUsed(c)), Qe(r, u, this.getConfig().ignoreNetworkEvents);
      }
    }, t.prototype._markResourceAsUsed = function(r) {
      this._usedResources.add(r);
    }, t.prototype._endSpan = function(r, n, i) {
      var o = this, a = W(Date.now()), u = Ie();
      this._addFinalSpanAttributes(r, i), setTimeout(function() {
        var c;
        (c = n.observer) === null || c === void 0 || c.disconnect(), o._findResourceAndAddNetworkEvents(r, n, u), o._tasksCount--, o._clearResources(), r.end(a);
      }, Lp);
    }, t.prototype._patchConstructor = function() {
      var r = this;
      return function(n) {
        var i = r;
        return function() {
          for (var a = [], u = 0; u < arguments.length; u++)
            a[u] = arguments[u];
          var c = this, s = ue(a[0] instanceof Request ? a[0].url : String(a[0])).href, l = a[0] instanceof Request ? a[0] : a[1] || {}, f = i._createSpan(s, l);
          if (!f)
            return n.apply(this, a);
          var d = i._prepareSpanData(s);
          i.getConfig().measureRequestSize && Ep.apply(void 0, Rp([], Op(a), !1)).then(function(y) {
            y && f.setAttribute(_p, y);
          }).catch(function(y) {
            i._diag.warn("getFetchBodyLength", y);
          });
          function h(y, m) {
            i._applyAttributesAfterFetch(y, l, m), i._endSpan(y, d, {
              status: m.status || 0,
              statusText: m.message,
              url: s
            });
          }
          function _(y, m) {
            i._applyAttributesAfterFetch(y, l, m), m.status >= 200 && m.status < 400 ? i._endSpan(y, d, m) : i._endSpan(y, d, {
              status: m.status,
              statusText: m.statusText,
              url: s
            });
          }
          function p(y, m, w) {
            try {
              var A = w.clone(), R = w.clone(), C = A.body;
              if (C) {
                var I = C.getReader(), P = function() {
                  I.read().then(function(V) {
                    var Q = V.done;
                    Q ? _(y, R) : P();
                  }, function(V) {
                    h(y, V);
                  });
                };
                P();
              } else
                _(y, w);
            } finally {
              m(w);
            }
          }
          function v(y, m, w) {
            try {
              h(y, w);
            } finally {
              m(w);
            }
          }
          return new Promise(function(y, m) {
            return O.with(L.setSpan(O.active(), f), function() {
              return i._addHeaders(l, s), i._tasksCount++, n.apply(c, l instanceof Request ? [l] : [s, l]).then(p.bind(c, f, y), v.bind(c, f, m));
            });
          });
        };
      };
    }, t.prototype._applyAttributesAfterFetch = function(r, n, i) {
      var o = this, a = this.getConfig().applyCustomAttributesOnSpan;
      a && ir(function() {
        return a(r, n, i);
      }, function(u) {
        u && o._diag.error("applyCustomAttributesOnSpan", u);
      });
    }, t.prototype._prepareSpanData = function(r) {
      var n = Ie(), i = [];
      if (typeof PerformanceObserver != "function")
        return { entries: i, startTime: n, spanUrl: r };
      var o = new PerformanceObserver(function(a) {
        var u = a.getEntries();
        u.forEach(function(c) {
          c.initiatorType === "fetch" && c.name === r && i.push(c);
        });
      });
      return o.observe({
        entryTypes: ["resource"]
      }), { entries: i, observer: o, startTime: n, spanUrl: r };
    }, t.prototype.enable = function() {
      if (ji) {
        this._diag.warn("this instrumentation is intended for web usage only, it does not instrument Node.js's fetch()");
        return;
      }
      D(fetch) && (this._unwrap(pt, "fetch"), this._diag.debug("removing previous patch for constructor")), this._wrap(pt, "fetch", this._patchConstructor());
    }, t.prototype.disable = function() {
      ji || (this._unwrap(pt, "fetch"), this._usedResources = /* @__PURE__ */ new WeakSet());
    }, t;
  }(Lt)
), Np = "http.method", Cp = "http.url", Mp = "http.host", Ip = "http.scheme", xp = "http.status_code", Dp = "http.user_agent", kp = "http.request_content_length_uncompressed", Up = Np, Bp = Cp, Hp = Mp, Gp = Ip, Fp = xp, jp = Dp, Vp = kp, se;
(function(e) {
  e.METHOD_OPEN = "open", e.METHOD_SEND = "send", e.EVENT_ABORT = "abort", e.EVENT_ERROR = "error", e.EVENT_LOAD = "loaded", e.EVENT_TIMEOUT = "timeout";
})(se || (se = {}));
var $p = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, zp = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Xp = g.createComponentLogger({
  namespace: "@opentelemetry/opentelemetry-instrumentation-xml-http-request/utils"
});
function qp(e) {
  if (typeof Document != "undefined" && e instanceof Document)
    return new XMLSerializer().serializeToString(document).length;
  if (e instanceof Blob)
    return e.size;
  if (e.byteLength !== void 0)
    return e.byteLength;
  if (e instanceof FormData)
    return Kp(e);
  if (e instanceof URLSearchParams)
    return Vi(e.toString());
  if (typeof e == "string")
    return Vi(e);
  Xp.warn("unknown body type");
}
var Wp = new TextEncoder();
function Vi(e) {
  return Wp.encode(e).byteLength;
}
function Kp(e) {
  var t, r, n = 0;
  try {
    for (var i = $p(e.entries()), o = i.next(); !o.done; o = i.next()) {
      var a = zp(o.value, 2), u = a[0], c = a[1];
      n += u.length, c instanceof Blob ? n += c.size : n += c.length;
    }
  } catch (s) {
    t = { error: s };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return n;
}
var $i = "0.57.2", Tn;
(function(e) {
  e.HTTP_STATUS_TEXT = "http.status_text";
})(Tn || (Tn = {}));
var Yp = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Jp = 300, Zp = (
  /** @class */
  function(e) {
    Yp(t, e);
    function t(r) {
      r === void 0 && (r = {});
      var n = e.call(this, "@opentelemetry/instrumentation-xml-http-request", $i, r) || this;
      return n.component = "xml-http-request", n.version = $i, n.moduleName = n.component, n._tasksCount = 0, n._xhrMem = /* @__PURE__ */ new WeakMap(), n._usedResources = /* @__PURE__ */ new WeakSet(), n;
    }
    return t.prototype.init = function() {
    }, t.prototype._addHeaders = function(r, n) {
      var i = ue(n).href;
      if (!Na(i, this.getConfig().propagateTraceHeaderCorsUrls)) {
        var o = {};
        q.inject(O.active(), o), Object.keys(o).length > 0 && this._diag.debug("headers inject skipped due to CORS policy");
        return;
      }
      var a = {};
      q.inject(O.active(), a), Object.keys(a).forEach(function(u) {
        r.setRequestHeader(u, String(a[u]));
      });
    }, t.prototype._addChildSpan = function(r, n) {
      var i = this;
      O.with(L.setSpan(O.active(), r), function() {
        var o = i.tracer.startSpan("CORS Preflight", {
          startTime: n[T.FETCH_START]
        });
        Qe(o, n, i.getConfig().ignoreNetworkEvents), o.end(n[T.RESPONSE_END]);
      });
    }, t.prototype._addFinalSpanAttributes = function(r, n, i) {
      if (typeof i == "string") {
        var o = ue(i);
        n.status !== void 0 && r.setAttribute(Fp, n.status), n.statusText !== void 0 && r.setAttribute(Tn.HTTP_STATUS_TEXT, n.statusText), r.setAttribute(Hp, o.host), r.setAttribute(Gp, o.protocol.replace(":", "")), r.setAttribute(jp, navigator.userAgent);
      }
    }, t.prototype._applyAttributesAfterXHR = function(r, n) {
      var i = this, o = this.getConfig().applyCustomAttributesOnSpan;
      typeof o == "function" && ir(function() {
        return o(r, n);
      }, function(a) {
        a && i._diag.error("applyCustomAttributesOnSpan", a);
      });
    }, t.prototype._addResourceObserver = function(r, n) {
      var i = this._xhrMem.get(r);
      !i || typeof PerformanceObserver != "function" || typeof PerformanceResourceTiming != "function" || (i.createdResources = {
        observer: new PerformanceObserver(function(o) {
          var a = o.getEntries(), u = ue(n);
          a.forEach(function(c) {
            c.initiatorType === "xmlhttprequest" && c.name === u.href && i.createdResources && i.createdResources.entries.push(c);
          });
        }),
        entries: []
      }, i.createdResources.observer.observe({
        entryTypes: ["resource"]
      }));
    }, t.prototype._clearResources = function() {
      this._tasksCount === 0 && this.getConfig().clearTimingResources && (K.clearResourceTimings(), this._xhrMem = /* @__PURE__ */ new WeakMap(), this._usedResources = /* @__PURE__ */ new WeakSet());
    }, t.prototype._findResourceAndAddNetworkEvents = function(r, n, i, o, a) {
      if (!(!i || !o || !a || !r.createdResources)) {
        var u = r.createdResources.entries;
        (!u || !u.length) && (u = K.getEntriesByType("resource"));
        var c = La(ue(i).href, o, a, u, this._usedResources);
        if (c.mainRequest) {
          var s = c.mainRequest;
          this._markResourceAsUsed(s);
          var l = c.corsPreFlightRequest;
          l && (this._addChildSpan(n, l), this._markResourceAsUsed(l)), Qe(n, s, this.getConfig().ignoreNetworkEvents);
        }
      }
    }, t.prototype._cleanPreviousSpanInformation = function(r) {
      var n = this._xhrMem.get(r);
      if (n) {
        var i = n.callbackToRemoveEvents;
        i && i(), this._xhrMem.delete(r);
      }
    }, t.prototype._createSpan = function(r, n, i) {
      var o;
      if (ya(n, this.getConfig().ignoreUrls)) {
        this._diag.debug("ignoring span as url matches ignored url");
        return;
      }
      var a = i.toUpperCase(), u = this.tracer.startSpan(a, {
        kind: mt.CLIENT,
        attributes: (o = {}, o[Up] = i, o[Bp] = ue(n).toString(), o)
      });
      return u.addEvent(se.METHOD_OPEN), this._cleanPreviousSpanInformation(r), this._xhrMem.set(r, {
        span: u,
        spanUrl: n
      }), u;
    }, t.prototype._markResourceAsUsed = function(r) {
      this._usedResources.add(r);
    }, t.prototype._patchOpen = function() {
      var r = this;
      return function(n) {
        var i = r;
        return function() {
          for (var a = [], u = 0; u < arguments.length; u++)
            a[u] = arguments[u];
          var c = a[0], s = a[1];
          return i._createSpan(this, s, c), n.apply(this, a);
        };
      };
    }, t.prototype._patchSend = function() {
      var r = this;
      function n(l, f, d, h) {
        var _ = f.callbackToRemoveEvents;
        typeof _ == "function" && _();
        var p = f.span, v = f.spanUrl, y = f.sendStartTime;
        p && (r._findResourceAndAddNetworkEvents(f, p, v, y, d), p.addEvent(l, h), r._addFinalSpanAttributes(p, f, v), p.end(h), r._tasksCount--), r._clearResources();
      }
      function i(l, f) {
        var d = r._xhrMem.get(f);
        if (d) {
          d.status = f.status, d.statusText = f.statusText, r._xhrMem.delete(f), d.span && r._applyAttributesAfterXHR(d.span, f);
          var h = Ie(), _ = Date.now();
          setTimeout(function() {
            n(l, d, h, _);
          }, Jp);
        }
      }
      function o() {
        i(se.EVENT_ERROR, this);
      }
      function a() {
        i(se.EVENT_ABORT, this);
      }
      function u() {
        i(se.EVENT_TIMEOUT, this);
      }
      function c() {
        this.status < 299 ? i(se.EVENT_LOAD, this) : i(se.EVENT_ERROR, this);
      }
      function s(l) {
        l.removeEventListener("abort", a), l.removeEventListener("error", o), l.removeEventListener("load", c), l.removeEventListener("timeout", u);
        var f = r._xhrMem.get(l);
        f && (f.callbackToRemoveEvents = void 0);
      }
      return function(l) {
        return function() {
          for (var d = this, h = [], _ = 0; _ < arguments.length; _++)
            h[_] = arguments[_];
          var p = r._xhrMem.get(this);
          if (!p)
            return l.apply(this, h);
          var v = p.span, y = p.spanUrl;
          if (v && y) {
            if (r.getConfig().measureRequestSize && (h != null && h[0])) {
              var m = h[0], w = qp(m);
              w !== void 0 && v.setAttribute(Vp, w);
            }
            O.with(L.setSpan(O.active(), v), function() {
              r._tasksCount++, p.sendStartTime = Ie(), v.addEvent(se.METHOD_SEND), d.addEventListener("abort", a), d.addEventListener("error", o), d.addEventListener("load", c), d.addEventListener("timeout", u), p.callbackToRemoveEvents = function() {
                s(d), p.createdResources && p.createdResources.observer.disconnect();
              }, r._addHeaders(d, y), r._addResourceObserver(d, y);
            });
          }
          return l.apply(this, h);
        };
      };
    }, t.prototype.enable = function() {
      this._diag.debug("applying patch to", this.moduleName, this.version), D(XMLHttpRequest.prototype.open) && (this._unwrap(XMLHttpRequest.prototype, "open"), this._diag.debug("removing previous patch from method open")), D(XMLHttpRequest.prototype.send) && (this._unwrap(XMLHttpRequest.prototype, "send"), this._diag.debug("removing previous patch from method send")), this._wrap(XMLHttpRequest.prototype, "open", this._patchOpen()), this._wrap(XMLHttpRequest.prototype, "send", this._patchSend());
    }, t.prototype.disable = function() {
      this._diag.debug("removing patch from", this.moduleName, this.version), this._unwrap(XMLHttpRequest.prototype, "open"), this._unwrap(XMLHttpRequest.prototype, "send"), this._tasksCount = 0, this._xhrMem = /* @__PURE__ */ new WeakMap(), this._usedResources = /* @__PURE__ */ new WeakSet();
    }, t;
  }(Lt)
);
const Wr = /\b(query|mutation|subscription)\b\s*([A-Za-z_]\w*)?/g;
function Qp(e) {
  var s;
  const t = th(e);
  if (t === null || typeof t != "object")
    return null;
  const r = Array.isArray(t) ? t[0] : t;
  if (!r || typeof r != "object")
    return null;
  const n = r, i = typeof n.query == "string" ? n.query : void 0, o = typeof n.operationName == "string" ? n.operationName : void 0;
  if (i === void 0 && o === void 0)
    return null;
  const a = i ? eh(i, o) : null, u = (s = a == null ? void 0 : a[1]) != null ? s : rh(i), c = o != null ? o : a == null ? void 0 : a[2];
  return c === void 0 && u === void 0 ? null : { name: c, type: u };
}
function eh(e, t) {
  Wr.lastIndex = 0;
  let r = null;
  for (let n = Wr.exec(e); n !== null; n = Wr.exec(e)) {
    if (t === void 0 || n[2] === t)
      return n;
    r === null && (r = n);
  }
  return r;
}
function th(e) {
  if (e == null)
    return null;
  if (typeof e == "object")
    return e;
  if (typeof e != "string")
    return null;
  try {
    return JSON.parse(e);
  } catch (t) {
    return null;
  }
}
function rh(e) {
  if (e !== void 0 && /^\s*\{/.test(e))
    return "query";
}
const nh = 0, zi = 2e3;
class ih {
  /**
   * @param windowMillis The dedupe window in milliseconds. A value of `0` (or
   * negative) disables deduplication, so every exposure is recorded.
   * @param maxSize The maximum number of exposure keys to track. When exceeded,
   * the least recently recorded keys are evicted. A value of `0` (or negative)
   * falls back to the default.
   */
  constructor(t = nh, r = zi) {
    this.lastRecordedAt = /* @__PURE__ */ new Map(), this.windowMillis = t, this.maxSize = r > 0 ? r : zi;
  }
  /**
   * Returns `true` if an exposure for the given key should be recorded (i.e. no
   * exposure for the same key was recorded within the window). Returns `false`
   * if it should be suppressed.
   *
   * This is a pure query and does NOT update the window. Call
   * {@link markRecorded} only after the exposure has actually been emitted, so
   * that a failure to emit doesn't suppress subsequent exposures.
   *
   * @param key A stable key identifying the exposure (e.g. flag key, value,
   * variation, reason, and context).
   * @param now The current time in milliseconds. Defaults to `Date.now()`.
   */
  shouldRecord(t, r = Date.now()) {
    if (this.windowMillis <= 0)
      return !0;
    const n = this.lastRecordedAt.get(t);
    return n === void 0 || n <= r - this.windowMillis;
  }
  /**
   * Marks an exposure for the given key as recorded at `now`, starting a new
   * dedupe window. Call this only after the exposure has been successfully
   * emitted.
   *
   * @param key A stable key identifying the exposure.
   * @param now The current time in milliseconds. Defaults to `Date.now()`.
   */
  markRecorded(t, r = Date.now()) {
    if (!(this.windowMillis <= 0))
      for (this.lastRecordedAt.delete(t), this.lastRecordedAt.set(t, r); this.lastRecordedAt.size > this.maxSize; ) {
        const n = this.lastRecordedAt.keys().next().value;
        if (n === void 0)
          break;
        this.lastRecordedAt.delete(n);
      }
  }
  /**
   * Clears all recorded exposures. Call when the evaluation context changes
   * (e.g. after `identify`).
   */
  reset() {
    this.lastRecordedAt.clear();
  }
}
const oh = new RegExp("sdk\\/evalx\\/[^/]+\\/contexts\\/(?<context>[^/?]*)\\??.*?"), ah = new RegExp("\\/eval\\/[^/]+\\/(?<context>[^/?]*)\\??.*?");
function sh(e) {
  return !!(e.includes("/sdk/evalx") && e.match(oh) || e.includes("/eval/") && e.match(ah));
}
const Ma = "X-Highlight-Request", Xi = (e) => {
  let t = e;
  return !e.startsWith("https://") && !e.startsWith("http://") && (t = `${window.location.origin}${t}`), t.replace(/\/+$/, "");
}, uh = (e, {
  headersToRedact: t,
  headersToRecord: r,
  requestResponseSanitizer: n
}) => {
  var c, s;
  let i = e;
  if (n) {
    let f = !0;
    try {
      i.request.body = JSON.parse(i.request.body);
    } catch (h) {
      f = !1;
    }
    let d = !0;
    try {
      i.response.body = JSON.parse(
        i.response.body
      );
    } catch (h) {
      d = !1;
    }
    try {
      i = n(i);
    } catch (h) {
    } finally {
      f = f && !!((c = i == null ? void 0 : i.request) != null && c.body), d = d && !!((s = i == null ? void 0 : i.response) != null && s.body), f && (i.request.body = JSON.stringify(
        i.request.body
      )), d && (i.response.body = JSON.stringify(
        i.response.body
      ));
    }
    if (!i)
      return null;
  }
  const l = i, { request: o, response: a } = l, u = Ar(l, ["request", "response"]);
  return E({
    request: Ei(o, t, r),
    response: Ei(a, t, r)
  }, u);
}, Jg = (e, t, r, n) => {
  e.sort((c, s) => c.responseEnd - s.responseEnd);
  const i = {
    xmlhttprequest: {},
    others: {},
    fetch: {}
  }, o = e.reduce((c, s) => {
    const l = Xi(s.name);
    return s.initiatorType === r ? c[r][l] = [
      ...c[r][l] || [],
      s
    ] : c.others[l] = [
      ...c.others[l] || [],
      s
    ], c;
  }, i);
  let a = {};
  a = t.reduce(
    (c, s) => {
      const l = Xi(s.request.url);
      return c[l] = [...c[l] || [], s], c;
    },
    a
  );
  for (let c in o[r]) {
    const s = o[r][c], l = a[c];
    if (!l)
      continue;
    const f = Math.max(
      s.length - l.length,
      0
    );
    for (let d = f; d < s.length; d++)
      s[d] && (s[d].requestResponsePair = l[d - f]);
  }
  let u = [];
  for (let c in o)
    for (let s in o[c])
      u = u.concat(o[c][s]);
  return u.sort((c, s) => c.fetchStart - s.fetchStart).reduce(
    (c, s) => {
      let l = s.requestResponsePair;
      return l && (l = uh(
        s.requestResponsePair,
        n
      ), !l) || (s.toJSON = function() {
        const f = window.performance.timeOrigin;
        return {
          initiatorType: this.initiatorType,
          startTimeAbs: f + this.startTime,
          connectStartAbs: f + this.connectStart,
          connectEndAbs: f + this.connectEnd,
          domainLookupStartAbs: f + this.domainLookupStart,
          domainLookupEndAbs: f + this.domainLookupEnd,
          fetchStartAbs: f + this.fetchStart,
          redirectStartAbs: f + this.redirectStart,
          redirectEndAbs: f + this.redirectEnd,
          requestStartAbs: f + this.requestStart,
          responseStartAbs: f + this.responseStart,
          responseEndAbs: f + this.responseEnd,
          secureConnectionStartAbs: f + this.secureConnectionStart,
          workerStartAbs: f + this.workerStart,
          name: this.name,
          transferSize: this.transferSize,
          encodedBodySize: this.encodedBodySize,
          decodedBodySize: this.decodedBodySize,
          nextHopProtocol: this.nextHopProtocol,
          requestResponsePairs: l
        };
      }, c.push(s)), c;
    },
    []
  );
}, ch = (e) => ["events.ld.catamorphic.com", "events.launchdarkly.com"].some(
  (t) => e.toLocaleLowerCase().includes(t)
), lh = (e) => sh(e), fh = (e, t) => t.some(
  (r) => e.toLocaleLowerCase().includes(r)
), zn = (e, t, r) => !fh(e, t) && !lh(e) && !ch(e), Xn = (e, t, r) => {
  var a;
  if (r.some(
    (u) => e.toLowerCase().includes(u)
  ))
    return !1;
  let n = [];
  t === !0 ? (n = ["localhost", /^\//], (a = window == null ? void 0 : window.location) != null && a.host && n.push(Ia(window.location.host))) : t instanceof Array && (n = t);
  const i = ph(e);
  let o = !1;
  return n.forEach((u) => {
    i.match(u) && (o = !0);
  }), o;
}, dh = (e) => e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), Ia = (e) => new RegExp("^https?://([^/]+\\.)?" + dh(e) + "([:/?#]|$)"), ph = (e) => {
  if (e.startsWith("/") && !e.startsWith("//"))
    return e;
  try {
    return new URL(e).origin;
  } catch (t) {
    return e;
  }
};
function hh(e) {
  for (var t = "", r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", n = r.length, i = 0; i < e; i++)
    t += r.charAt(
      Math.floor(Math.random() * n)
    );
  return t;
}
const xa = () => {
  const e = hh(10), t = qy(), r = t == null ? void 0 : t.spanContext().traceId;
  return [he(), r != null ? r : e];
}, Da = (e, t) => e + "/" + t, Zg = (e, t, r, n, i, o) => {
  const a = XMLHttpRequest.prototype, u = a.open, c = a.send, s = a.setRequestHeader;
  return a.open = function(l, f) {
    return typeof f == "string" ? this._url = f : this._url = f.toString(), this._method = l, this._requestHeaders = {}, this._shouldRecordHeaderAndBody = !n.some(
      (d) => this._url.toLowerCase().includes(d)
    ), u.apply(this, arguments);
  }, a.setRequestHeader = function(l, f) {
    return this._requestHeaders[l] = f, s.apply(this, arguments);
  }, a.send = function(l) {
    if (!zn(
      this._url,
      t
    ))
      return c.apply(this, arguments);
    const [f, d] = xa();
    Xn(
      this._url,
      r,
      n
    ) && this.setRequestHeader(
      Ma,
      Da(f, d)
    );
    const h = this._shouldRecordHeaderAndBody, _ = {
      sessionSecureID: f,
      id: d,
      url: this._url,
      verb: this._method,
      headers: h ? this._requestHeaders : {},
      body: void 0
    };
    if (h && l) {
      const p = Sn(l, _.url);
      p && (this._body = p, _.body = ne(
        p,
        i,
        o,
        _.headers
      ));
    }
    return this.addEventListener("load", function() {
      return U(this, null, function* () {
        const p = {
          status: this.status,
          headers: {},
          body: void 0
        };
        if (h) {
          const m = this.getAllResponseHeaders().trim().split(/[\r\n]+/), w = {};
          if (m.forEach(function(A) {
            const R = A.split(": "), C = R.shift();
            w[C] = R.join(": ");
          }), p.headers = w, l) {
            const A = Sn(l, _.url);
            A && (_.body = ne(
              A,
              i,
              o,
              p.headers
            ));
          }
          if (this.responseType === "" || this.responseType === "text")
            p.body = ne(
              this.responseText,
              i,
              o,
              p.headers
            ), p.size = this.responseText.length * 8;
          else if (this.responseType === "blob") {
            if (this.response instanceof Blob)
              try {
                const A = yield this.response.text();
                p.body = ne(
                  A,
                  i,
                  o,
                  p.headers
                ), p.size = this.response.size;
              } catch (A) {
              }
          } else
            try {
              p.body = ne(
                this.response,
                i,
                o,
                p.headers
              );
            } catch (A) {
            }
        }
        e({
          request: _,
          response: p,
          urlBlocked: !h
        });
      });
    }), this.addEventListener("error", function() {
      return U(this, null, function* () {
        const p = {
          status: this.status,
          headers: void 0,
          body: void 0
        };
        e({
          request: _,
          response: p,
          urlBlocked: !1
        });
      });
    }), c.apply(this, arguments);
  }, () => {
    a.open = u, a.send = c, a.setRequestHeader = s;
  };
}, _h = /^\[object (ArrayBuffer|SharedArrayBuffer|DataView|(?:Ui|I)nt(?:8|16|32)Array|Uint8ClampedArray|Float(?:16|32|64)Array|Big(?:Ui|I)nt64Array|Blob|File|FormData|URLSearchParams|ReadableStream)\]$/, vh = (e) => typeof e == "object" && e !== null && _h.test(Object.prototype.toString.call(e)), yh = (e) => {
  var r, n;
  return typeof Blob != "undefined" && e instanceof Blob ? `[Blob type="${e.type}" size=${e.size}]` : typeof FormData != "undefined" && e instanceof FormData ? "[FormData]" : typeof URLSearchParams != "undefined" && e instanceof URLSearchParams ? e.toString().slice(0, bn) : `[binary size=${(n = (r = e == null ? void 0 : e.byteLength) != null ? r : e == null ? void 0 : e.size) != null ? n : 0}]`;
}, Sn = (e, t) => {
  if (vh(e))
    return yh(e);
  if (typeof e == "string") {
    if (!((t != null && t.includes("localhost") || t != null && t.includes("highlight.run")) && (e.includes("pushPayload") || e.includes("pushSessionEvents"))))
      return e;
  } else if (typeof e == "object" || typeof e == "number" || typeof e == "boolean")
    return Ye(e);
  return null;
}, bn = 64 * 1024, gh = {
  "application/json": 256 * 1024,
  // 256 KiB
  "text/plain": 256 * 1024
  // 256 KiB
}, ka = (e, t) => `[body omitted: ${e} bytes exceeds the ${t} byte limit]`, qn = (e) => {
  var r, n;
  if (!e)
    return bn;
  let t = "";
  if (typeof e.get == "function")
    t = (r = e.get("content-type")) != null ? r : "";
  else {
    const i = e, o = Object.keys(i).find(
      (a) => a.toLowerCase() === "content-type"
    );
    t = o && i[o] || "";
  }
  try {
    t = t.split(";")[0].trim();
  } catch (i) {
  }
  return (n = gh[t]) != null ? n : bn;
}, qi = (e) => typeof e == "object" && e !== null && !Array.isArray(e), ne = (e, t, r, n) => {
  const i = qn(n);
  if (typeof e == "string" && e.length > i)
    return ka(e.length, i);
  if (e) {
    if (t)
      try {
        const o = JSON.parse(e);
        Array.isArray(o) ? o.forEach((a) => {
          qi(a) && Object.keys(a).forEach((u) => {
            t.includes(
              u.toLocaleLowerCase()
            ) && (a[u] = "[REDACTED]");
          });
        }) : Object.keys(o).forEach((a) => {
          t.includes(a.toLocaleLowerCase()) && (o[a] = "[REDACTED]");
        }), e = JSON.stringify(o);
      } catch (o) {
      }
    if (r)
      try {
        const o = JSON.parse(e);
        Array.isArray(o) ? o.forEach((a, u) => {
          if (!qi(a)) {
            o[u] = "[REDACTED]";
            return;
          }
          Object.keys(a).forEach((c) => {
            r.includes(
              c.toLocaleLowerCase()
            ) || (a[c] = "[REDACTED]");
          });
        }) : Object.keys(o).forEach((a) => {
          r.includes(a.toLocaleLowerCase()) || (o[a] = "[REDACTED]");
        }), e = JSON.stringify(o);
      } catch (o) {
      }
  }
  try {
    e = e.slice(0, i);
  } catch (o) {
  }
  return e;
}, Qg = (e, t, r, n, i, o) => {
  const a = window._fetchProxy;
  return window._fetchProxy = function(u, c) {
    const { method: s, url: l } = mh(u, c);
    if (!zn(
      l,
      t
    ))
      return a.call(this, u, c);
    const [f, d] = xa();
    if (Xn(l, r, n)) {
      c = c || {};
      let v = new Headers(c.headers);
      u instanceof Request && [...u.headers].forEach(
        ([y, m]) => v.set(y, m)
      ), v.set(
        Ma,
        Da(f, d)
      ), c.headers = Object.fromEntries(v.entries());
    }
    const h = {
      sessionSecureID: f,
      id: d,
      headers: {},
      body: void 0,
      url: l,
      verb: s
    }, _ = !n.some(
      (v) => l.toLowerCase().includes(v)
    );
    _ && (h.headers = Object.fromEntries(
      new Headers(c == null ? void 0 : c.headers).entries()
    ), h.body = ne(
      c == null ? void 0 : c.body,
      i,
      o,
      c == null ? void 0 : c.headers
    ));
    let p = a.call(this, u, c);
    return Eh(
      p,
      h,
      e,
      _,
      i,
      o
    ), p;
  }, () => {
    window._fetchProxy = a;
  };
}, mh = (e, t) => {
  const r = t && t.method || typeof e == "object" && "method" in e && e.method || "GET";
  let n;
  return typeof e == "object" ? "url" in e && e.url ? n = e.url : n = e.toString() : n = e, {
    method: r,
    url: n
  };
}, Eh = (e, t, r, n, i, o) => {
  const a = (u) => U(void 0, null, function* () {
    let c = {
      body: void 0,
      headers: void 0,
      status: 0,
      size: 0
    }, s = !1, l = !n;
    "stack" in u || u instanceof Error ? (c = x(E({}, c), {
      body: u.message,
      status: 0,
      size: void 0
    }), s = !0) : "status" in u && (c = x(E({}, c), {
      status: u.status
    }), n && (c.body = yield Ua(
      u,
      o,
      i
    ), c.headers = Object.fromEntries(
      u.headers.entries()
    ), c.size = c.body.length * 8), (u.type === "opaque" || u.type === "opaqueredirect") && (l = !0, c = x(E({}, c), {
      body: "CORS blocked request"
    })), s = !0), s && r({
      request: t,
      response: c,
      urlBlocked: l
    });
  });
  e.then(a).catch(() => {
  });
}, Ua = (e, t, r) => U(void 0, null, function* () {
  let n;
  try {
    const o = e.clone().body;
    if (o) {
      let a = o.getReader(), u = new TextDecoder(), c;
      const s = qn(e.headers);
      let l = "", f = !1;
      for (; !(c = yield a.read()).done; ) {
        let d = c.value;
        if (l += u.decode(d, { stream: !0 }), l.length > s) {
          f = !0, a.cancel().catch(() => {
          });
          break;
        }
      }
      f || (l += u.decode()), n = f ? ka(
        Number(e.headers.get("content-length")) || l.length,
        s
      ) : l, n = ne(
        n,
        r,
        t,
        e.headers
      );
    } else
      n = "";
  } catch (i) {
    n = `Unable to clone response: ${i}`;
  }
  return n;
});
var Ba = (
  /** @class */
  function() {
    function e(t) {
      this._delegate = t;
    }
    return e.prototype.export = function(t, r) {
      this._delegate.export(t, r);
    }, e.prototype.forceFlush = function() {
      return this._delegate.forceFlush();
    }, e.prototype.shutdown = function() {
      return this._delegate.shutdown();
    }, e;
  }()
), Th = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Wi = (
  /** @class */
  function(e) {
    Th(t, e);
    function t(r, n, i) {
      var o = e.call(this, r) || this;
      return o.name = "OTLPExporterError", o.data = i, o.code = n, o;
    }
    return t;
  }(Error)
);
function Sh(e) {
  if (!Number.isNaN(e) && Number.isFinite(e) && e > 0)
    return e;
  throw new Error("Configuration: timeoutMillis is invalid, expected number greater than 0 (actual: '" + e + "')");
}
function bh(e) {
  if (e != null)
    return function() {
      return e;
    };
}
function wh(e, t, r) {
  var n, i, o, a, u, c;
  return {
    timeoutMillis: Sh((i = (n = e.timeoutMillis) !== null && n !== void 0 ? n : t.timeoutMillis) !== null && i !== void 0 ? i : r.timeoutMillis),
    concurrencyLimit: (a = (o = e.concurrencyLimit) !== null && o !== void 0 ? o : t.concurrencyLimit) !== null && a !== void 0 ? a : r.concurrencyLimit,
    compression: (c = (u = e.compression) !== null && u !== void 0 ? u : t.compression) !== null && c !== void 0 ? c : r.compression
  };
}
function Ah() {
  return {
    timeoutMillis: 1e4,
    concurrencyLimit: 30,
    compression: "none"
  };
}
var Oh = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, Rh = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Lh = (
  /** @class */
  function() {
    function e(t) {
      this._sendingPromises = [], this._concurrencyLimit = t;
    }
    return e.prototype.pushPromise = function(t) {
      var r = this;
      if (this.hasReachedLimit())
        throw new Error("Concurrency Limit reached");
      this._sendingPromises.push(t);
      var n = function() {
        var i = r._sendingPromises.indexOf(t);
        r._sendingPromises.splice(i, 1);
      };
      t.then(n, n);
    }, e.prototype.hasReachedLimit = function() {
      return this._sendingPromises.length >= this._concurrencyLimit;
    }, e.prototype.awaitAll = function() {
      return Oh(this, void 0, void 0, function() {
        return Rh(this, function(t) {
          switch (t.label) {
            case 0:
              return [4, Promise.all(this._sendingPromises)];
            case 1:
              return t.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e;
  }()
);
function Ph(e) {
  return new Lh(e.concurrencyLimit);
}
function Nh(e) {
  return Object.prototype.hasOwnProperty.call(e, "partialSuccess");
}
function Ch() {
  return {
    handleResponse: function(e) {
      e == null || !Nh(e) || e.partialSuccess == null || Object.keys(e.partialSuccess).length === 0 || g.warn("Received Partial Success response:", JSON.stringify(e.partialSuccess));
    }
  };
}
var Mh = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, Ih = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, xh = (
  /** @class */
  function() {
    function e(t, r, n, i, o) {
      this._transport = t, this._serializer = r, this._responseHandler = n, this._promiseQueue = i, this._timeout = o, this._diagLogger = g.createComponentLogger({
        namespace: "OTLPExportDelegate"
      });
    }
    return e.prototype.export = function(t, r) {
      var n = this;
      if (this._diagLogger.debug("items to be sent", t), this._promiseQueue.hasReachedLimit()) {
        r({
          code: N.FAILED,
          error: new Error("Concurrent export limit reached")
        });
        return;
      }
      var i = this._serializer.serializeRequest(t);
      if (i == null) {
        r({
          code: N.FAILED,
          error: new Error("Nothing to send")
        });
        return;
      }
      this._promiseQueue.pushPromise(this._transport.send(i, this._timeout).then(function(o) {
        if (o.status === "success") {
          if (o.data != null)
            try {
              n._responseHandler.handleResponse(n._serializer.deserializeResponse(o.data));
            } catch (a) {
              n._diagLogger.warn("Export succeeded but could not deserialize response - is the response specification compliant?", a, o.data);
            }
          r({
            code: N.SUCCESS
          });
          return;
        } else if (o.status === "failure" && o.error) {
          r({
            code: N.FAILED,
            error: o.error
          });
          return;
        } else o.status === "retryable" ? r({
          code: N.FAILED,
          error: new Wi("Export failed with retryable status")
        }) : r({
          code: N.FAILED,
          error: new Wi("Export failed with unknown error")
        });
      }, function(o) {
        return r({
          code: N.FAILED,
          error: o
        });
      }));
    }, e.prototype.forceFlush = function() {
      return this._promiseQueue.awaitAll();
    }, e.prototype.shutdown = function() {
      return Mh(this, void 0, void 0, function() {
        return Ih(this, function(t) {
          switch (t.label) {
            case 0:
              return this._diagLogger.debug("shutdown started"), [4, this.forceFlush()];
            case 1:
              return t.sent(), this._transport.shutdown(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e;
  }()
);
function Dh(e, t) {
  return new xh(e.transport, e.serializer, Ch(), e.promiseHandler, t.timeout);
}
function Ha(e, t, r) {
  return Dh({
    transport: r,
    serializer: t,
    promiseHandler: Ph(e)
  }, { timeout: e.timeoutMillis });
}
function Ga(e) {
  var t = BigInt(1e9);
  return BigInt(e[0]) * t + BigInt(e[1]);
}
function kh(e) {
  var t = Number(BigInt.asUintN(32, e)), r = Number(BigInt.asUintN(32, e >> BigInt(32)));
  return { low: t, high: r };
}
function Fa(e) {
  var t = Ga(e);
  return kh(t);
}
function Uh(e) {
  var t = Ga(e);
  return t.toString();
}
var Bh = typeof BigInt != "undefined" ? Uh : ce;
function Ki(e) {
  return e;
}
function ja(e) {
  if (e !== void 0)
    return jn(e);
}
var Hh = {
  encodeHrTime: Fa,
  encodeSpanContext: jn,
  encodeOptionalSpanContext: ja
};
function Va(e) {
  var t, r;
  if (e === void 0)
    return Hh;
  var n = (t = e.useLongBits) !== null && t !== void 0 ? t : !0, i = (r = e.useHex) !== null && r !== void 0 ? r : !1;
  return {
    encodeHrTime: n ? Fa : Bh,
    encodeSpanContext: i ? Ki : jn,
    encodeOptionalSpanContext: i ? Ki : ja
  };
}
var Gh = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function $a(e) {
  return {
    attributes: Ue(e.attributes),
    droppedAttributesCount: 0
  };
}
function za(e) {
  return {
    name: e.name,
    version: e.version
  };
}
function Ue(e) {
  return Object.keys(e).map(function(t) {
    return Xa(t, e[t]);
  });
}
function Xa(e, t) {
  return {
    key: e,
    value: qa(t)
  };
}
function qa(e) {
  var t = typeof e;
  return t === "string" ? { stringValue: e } : t === "number" ? Number.isInteger(e) ? { intValue: e } : { doubleValue: e } : t === "boolean" ? { boolValue: e } : e instanceof Uint8Array ? { bytesValue: e } : Array.isArray(e) ? { arrayValue: { values: e.map(qa) } } : t === "object" && e != null ? {
    kvlistValue: {
      values: Object.entries(e).map(function(r) {
        var n = Gh(r, 2), i = n[0], o = n[1];
        return Xa(i, o);
      })
    }
  } : {};
}
var Z;
(function(e) {
  e[e.DELTA = 0] = "DELTA", e[e.CUMULATIVE = 1] = "CUMULATIVE";
})(Z || (Z = {}));
var ie;
(function(e) {
  e[e.HISTOGRAM = 0] = "HISTOGRAM", e[e.EXPONENTIAL_HISTOGRAM = 1] = "EXPONENTIAL_HISTOGRAM", e[e.GAUGE = 2] = "GAUGE", e[e.SUM = 3] = "SUM";
})(ie || (ie = {}));
var Fh = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Yi = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, Ji = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, jh = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Vh = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, $h = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function zh(e) {
  return e != null;
}
function Wa(e) {
  var t = Object.keys(e);
  return t.length === 0 ? "" : (t = t.sort(), JSON.stringify(t.map(function(r) {
    return [r, e[r]];
  })));
}
function Xh(e) {
  var t, r;
  return e.name + ":" + ((t = e.version) !== null && t !== void 0 ? t : "") + ":" + ((r = e.schemaUrl) !== null && r !== void 0 ? r : "");
}
var Ka = (
  /** @class */
  function(e) {
    Fh(t, e);
    function t(r) {
      var n = e.call(this, r) || this;
      return Object.setPrototypeOf(n, t.prototype), n;
    }
    return t;
  }(Error)
);
function Tt(e, t) {
  var r, n = new Promise(function(o, a) {
    r = setTimeout(function() {
      a(new Ka("Operation timed out."));
    }, t);
  });
  return Promise.race([e, n]).then(function(i) {
    return clearTimeout(r), i;
  }, function(i) {
    throw clearTimeout(r), i;
  });
}
function qh(e) {
  return Yi(this, void 0, void 0, function() {
    var t = this;
    return Ji(this, function(r) {
      return [2, Promise.all(e.map(function(n) {
        return Yi(t, void 0, void 0, function() {
          var i, o;
          return Ji(this, function(a) {
            switch (a.label) {
              case 0:
                return a.trys.push([0, 2, , 3]), [4, n];
              case 1:
                return i = a.sent(), [2, {
                  status: "fulfilled",
                  value: i
                }];
              case 2:
                return o = a.sent(), [2, {
                  status: "rejected",
                  reason: o
                }];
              case 3:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }))];
    });
  });
}
function Wh(e) {
  return e.status === "rejected";
}
function Zi(e, t) {
  var r = [];
  return e.forEach(function(n) {
    r.push.apply(r, Vh([], jh(t(n)), !1));
  }), r;
}
function Kh(e, t) {
  var r, n;
  if (e.size !== t.size)
    return !1;
  try {
    for (var i = $h(e), o = i.next(); !o.done; o = i.next()) {
      var a = o.value;
      if (!t.has(a))
        return !1;
    }
  } catch (u) {
    r = { error: u };
  } finally {
    try {
      o && !o.done && (n = i.return) && n.call(i);
    } finally {
      if (r) throw r.error;
    }
  }
  return !0;
}
function Yh(e, t) {
  for (var r = 0, n = e.length - 1, i = e.length; n >= r; ) {
    var o = r + Math.trunc((n - r) / 2);
    e[o] < t ? r = o + 1 : (i = o, n = o - 1);
  }
  return i;
}
function Jh(e, t) {
  return e.toLowerCase() === t.toLowerCase();
}
var xe;
(function(e) {
  e[e.DROP = 0] = "DROP", e[e.SUM = 1] = "SUM", e[e.LAST_VALUE = 2] = "LAST_VALUE", e[e.HISTOGRAM = 3] = "HISTOGRAM", e[e.EXPONENTIAL_HISTOGRAM = 4] = "EXPONENTIAL_HISTOGRAM";
})(xe || (xe = {}));
var Zh = (
  /** @class */
  function() {
    function e() {
      this.kind = xe.DROP;
    }
    return e.prototype.createAccumulation = function() {
    }, e.prototype.merge = function(t, r) {
    }, e.prototype.diff = function(t, r) {
    }, e.prototype.toMetricData = function(t, r, n, i) {
    }, e;
  }()
), S;
(function(e) {
  e.COUNTER = "COUNTER", e.GAUGE = "GAUGE", e.HISTOGRAM = "HISTOGRAM", e.UP_DOWN_COUNTER = "UP_DOWN_COUNTER", e.OBSERVABLE_COUNTER = "OBSERVABLE_COUNTER", e.OBSERVABLE_GAUGE = "OBSERVABLE_GAUGE", e.OBSERVABLE_UP_DOWN_COUNTER = "OBSERVABLE_UP_DOWN_COUNTER";
})(S || (S = {}));
function pe(e, t, r) {
  var n, i, o, a;
  return r_(e) || g.warn('Invalid metric name: "' + e + '". The metric name should be a ASCII string with a length no greater than 255 characters.'), {
    name: e,
    type: t,
    description: (n = r == null ? void 0 : r.description) !== null && n !== void 0 ? n : "",
    unit: (i = r == null ? void 0 : r.unit) !== null && i !== void 0 ? i : "",
    valueType: (o = r == null ? void 0 : r.valueType) !== null && o !== void 0 ? o : ge.DOUBLE,
    advice: (a = r == null ? void 0 : r.advice) !== null && a !== void 0 ? a : {}
  };
}
function Qh(e, t) {
  var r, n;
  return {
    name: (r = e.name) !== null && r !== void 0 ? r : t.name,
    description: (n = e.description) !== null && n !== void 0 ? n : t.description,
    type: t.type,
    unit: t.unit,
    valueType: t.valueType,
    advice: t.advice
  };
}
function e_(e, t) {
  return Jh(e.name, t.name) && e.unit === t.unit && e.type === t.type && e.valueType === t.valueType;
}
var t_ = /^[a-z][a-z0-9_.\-/]{0,254}$/i;
function r_(e) {
  return e.match(t_) != null;
}
var n_ = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function i_(e) {
  var t = e.map(function() {
    return 0;
  });
  return t.push(0), {
    buckets: {
      boundaries: e,
      counts: t
    },
    sum: 0,
    count: 0,
    hasMinMax: !1,
    min: 1 / 0,
    max: -1 / 0
  };
}
var Kr = (
  /** @class */
  function() {
    function e(t, r, n, i) {
      n === void 0 && (n = !0), i === void 0 && (i = i_(r)), this.startTime = t, this._boundaries = r, this._recordMinMax = n, this._current = i;
    }
    return e.prototype.record = function(t) {
      if (!Number.isNaN(t)) {
        this._current.count += 1, this._current.sum += t, this._recordMinMax && (this._current.min = Math.min(t, this._current.min), this._current.max = Math.max(t, this._current.max), this._current.hasMinMax = !0);
        var r = Yh(this._boundaries, t);
        this._current.buckets.counts[r] += 1;
      }
    }, e.prototype.setStartTime = function(t) {
      this.startTime = t;
    }, e.prototype.toPointValue = function() {
      return this._current;
    }, e;
  }()
), Ya = (
  /** @class */
  function() {
    function e(t, r) {
      this._boundaries = t, this._recordMinMax = r, this.kind = xe.HISTOGRAM;
    }
    return e.prototype.createAccumulation = function(t) {
      return new Kr(t, this._boundaries, this._recordMinMax);
    }, e.prototype.merge = function(t, r) {
      for (var n = t.toPointValue(), i = r.toPointValue(), o = n.buckets.counts, a = i.buckets.counts, u = new Array(o.length), c = 0; c < o.length; c++)
        u[c] = o[c] + a[c];
      var s = 1 / 0, l = -1 / 0;
      return this._recordMinMax && (n.hasMinMax && i.hasMinMax ? (s = Math.min(n.min, i.min), l = Math.max(n.max, i.max)) : n.hasMinMax ? (s = n.min, l = n.max) : i.hasMinMax && (s = i.min, l = i.max)), new Kr(t.startTime, n.buckets.boundaries, this._recordMinMax, {
        buckets: {
          boundaries: n.buckets.boundaries,
          counts: u
        },
        count: n.count + i.count,
        sum: n.sum + i.sum,
        hasMinMax: this._recordMinMax && (n.hasMinMax || i.hasMinMax),
        min: s,
        max: l
      });
    }, e.prototype.diff = function(t, r) {
      for (var n = t.toPointValue(), i = r.toPointValue(), o = n.buckets.counts, a = i.buckets.counts, u = new Array(o.length), c = 0; c < o.length; c++)
        u[c] = a[c] - o[c];
      return new Kr(r.startTime, n.buckets.boundaries, this._recordMinMax, {
        buckets: {
          boundaries: n.buckets.boundaries,
          counts: u
        },
        count: i.count - n.count,
        sum: i.sum - n.sum,
        hasMinMax: !1,
        min: 1 / 0,
        max: -1 / 0
      });
    }, e.prototype.toMetricData = function(t, r, n, i) {
      return {
        descriptor: t,
        aggregationTemporality: r,
        dataPointType: ie.HISTOGRAM,
        dataPoints: n.map(function(o) {
          var a = n_(o, 2), u = a[0], c = a[1], s = c.toPointValue(), l = t.type === S.GAUGE || t.type === S.UP_DOWN_COUNTER || t.type === S.OBSERVABLE_GAUGE || t.type === S.OBSERVABLE_UP_DOWN_COUNTER;
          return {
            attributes: u,
            startTime: c.startTime,
            endTime: i,
            value: {
              min: s.hasMinMax ? s.min : void 0,
              max: s.hasMinMax ? s.max : void 0,
              sum: l ? void 0 : s.sum,
              buckets: s.buckets,
              count: s.count
            }
          };
        })
      };
    }, e;
  }()
), Yr = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Jr = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Qi = (
  /** @class */
  function() {
    function e(t, r, n, i) {
      t === void 0 && (t = new o_()), r === void 0 && (r = 0), n === void 0 && (n = 0), i === void 0 && (i = 0), this.backing = t, this.indexBase = r, this.indexStart = n, this.indexEnd = i;
    }
    return Object.defineProperty(e.prototype, "offset", {
      /**
       * Offset is the bucket index of the smallest entry in the counts array
       * @returns {number}
       */
      get: function() {
        return this.indexStart;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "length", {
      /**
       * Buckets is a view into the backing array.
       * @returns {number}
       */
      get: function() {
        return this.backing.length === 0 || this.indexEnd === this.indexStart && this.at(0) === 0 ? 0 : this.indexEnd - this.indexStart + 1;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.counts = function() {
      var t = this;
      return Array.from({ length: this.length }, function(r, n) {
        return t.at(n);
      });
    }, e.prototype.at = function(t) {
      var r = this.indexBase - this.indexStart;
      return t < r && (t += this.backing.length), t -= r, this.backing.countAt(t);
    }, e.prototype.incrementBucket = function(t, r) {
      this.backing.increment(t, r);
    }, e.prototype.decrementBucket = function(t, r) {
      this.backing.decrement(t, r);
    }, e.prototype.trim = function() {
      for (var t = 0; t < this.length; t++)
        if (this.at(t) !== 0) {
          this.indexStart += t;
          break;
        } else if (t === this.length - 1) {
          this.indexStart = this.indexEnd = this.indexBase = 0;
          return;
        }
      for (var t = this.length - 1; t >= 0; t--)
        if (this.at(t) !== 0) {
          this.indexEnd -= this.length - t - 1;
          break;
        }
      this._rotate();
    }, e.prototype.downscale = function(t) {
      this._rotate();
      for (var r = 1 + this.indexEnd - this.indexStart, n = 1 << t, i = 0, o = 0, a = this.indexStart; a <= this.indexEnd; ) {
        var u = a % n;
        u < 0 && (u += n);
        for (var c = u; c < n && i < r; c++)
          this._relocateBucket(o, i), i++, a++;
        o++;
      }
      this.indexStart >>= t, this.indexEnd >>= t, this.indexBase = this.indexStart;
    }, e.prototype.clone = function() {
      return new e(this.backing.clone(), this.indexBase, this.indexStart, this.indexEnd);
    }, e.prototype._rotate = function() {
      var t = this.indexBase - this.indexStart;
      t !== 0 && (t > 0 ? (this.backing.reverse(0, this.backing.length), this.backing.reverse(0, t), this.backing.reverse(t, this.backing.length)) : (this.backing.reverse(0, this.backing.length), this.backing.reverse(0, this.backing.length + t)), this.indexBase = this.indexStart);
    }, e.prototype._relocateBucket = function(t, r) {
      t !== r && this.incrementBucket(t, this.backing.emptyBucket(r));
    }, e;
  }()
), o_ = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = [0]), this._counts = t;
    }
    return Object.defineProperty(e.prototype, "length", {
      /**
       * length returns the physical size of the backing array, which
       * is >= buckets.length()
       */
      get: function() {
        return this._counts.length;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.countAt = function(t) {
      return this._counts[t];
    }, e.prototype.growTo = function(t, r, n) {
      var i = new Array(t).fill(0);
      i.splice.apply(i, Jr([
        n,
        this._counts.length - r
      ], Yr(this._counts.slice(r)), !1)), i.splice.apply(i, Jr([0, r], Yr(this._counts.slice(0, r)), !1)), this._counts = i;
    }, e.prototype.reverse = function(t, r) {
      for (var n = Math.floor((t + r) / 2) - t, i = 0; i < n; i++) {
        var o = this._counts[t + i];
        this._counts[t + i] = this._counts[r - i - 1], this._counts[r - i - 1] = o;
      }
    }, e.prototype.emptyBucket = function(t) {
      var r = this._counts[t];
      return this._counts[t] = 0, r;
    }, e.prototype.increment = function(t, r) {
      this._counts[t] += r;
    }, e.prototype.decrement = function(t, r) {
      this._counts[t] >= r ? this._counts[t] -= r : this._counts[t] = 0;
    }, e.prototype.clone = function() {
      return new e(Jr([], Yr(this._counts), !1));
    }, e;
  }()
), a_ = 52, s_ = 2146435072, u_ = 1048575, Wn = 1023, Ja = -Wn + 1, Za = Wn, wn = Math.pow(2, -1022);
function Qa(e) {
  var t = new DataView(new ArrayBuffer(8));
  t.setFloat64(0, e);
  var r = t.getUint32(0), n = (r & s_) >> 20;
  return n - Wn;
}
function es(e) {
  var t = new DataView(new ArrayBuffer(8));
  t.setFloat64(0, e);
  var r = t.getUint32(0), n = t.getUint32(4), i = (r & u_) * Math.pow(2, 32);
  return i + n;
}
function An(e, t) {
  return e === 0 || e === Number.POSITIVE_INFINITY || e === Number.NEGATIVE_INFINITY || Number.isNaN(e) ? e : e * Math.pow(2, t);
}
function c_(e) {
  return e--, e |= e >> 1, e |= e >> 2, e |= e >> 4, e |= e >> 8, e |= e >> 16, e++, e;
}
var l_ = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), St = (
  /** @class */
  function(e) {
    l_(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(Error)
), f_ = (
  /** @class */
  function() {
    function e(t) {
      this._shift = -t;
    }
    return e.prototype.mapToIndex = function(t) {
      if (t < wn)
        return this._minNormalLowerBoundaryIndex();
      var r = Qa(t), n = this._rightShift(es(t) - 1, a_);
      return r + n >> this._shift;
    }, e.prototype.lowerBoundary = function(t) {
      var r = this._minNormalLowerBoundaryIndex();
      if (t < r)
        throw new St("underflow: " + t + " is < minimum lower boundary: " + r);
      var n = this._maxNormalLowerBoundaryIndex();
      if (t > n)
        throw new St("overflow: " + t + " is > maximum lower boundary: " + n);
      return An(1, t << this._shift);
    }, Object.defineProperty(e.prototype, "scale", {
      /**
       * The scale used by this mapping
       * @returns {number}
       */
      get: function() {
        return this._shift === 0 ? 0 : -this._shift;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._minNormalLowerBoundaryIndex = function() {
      var t = Ja >> this._shift;
      return this._shift < 2 && t--, t;
    }, e.prototype._maxNormalLowerBoundaryIndex = function() {
      return Za >> this._shift;
    }, e.prototype._rightShift = function(t, r) {
      return Math.floor(t * Math.pow(2, -r));
    }, e;
  }()
), d_ = (
  /** @class */
  function() {
    function e(t) {
      this._scale = t, this._scaleFactor = An(Math.LOG2E, t), this._inverseFactor = An(Math.LN2, -t);
    }
    return e.prototype.mapToIndex = function(t) {
      if (t <= wn)
        return this._minNormalLowerBoundaryIndex() - 1;
      if (es(t) === 0) {
        var r = Qa(t);
        return (r << this._scale) - 1;
      }
      var n = Math.floor(Math.log(t) * this._scaleFactor), i = this._maxNormalLowerBoundaryIndex();
      return n >= i ? i : n;
    }, e.prototype.lowerBoundary = function(t) {
      var r = this._maxNormalLowerBoundaryIndex();
      if (t >= r) {
        if (t === r)
          return 2 * Math.exp((t - (1 << this._scale)) / this._scaleFactor);
        throw new St("overflow: " + t + " is > maximum lower boundary: " + r);
      }
      var n = this._minNormalLowerBoundaryIndex();
      if (t <= n) {
        if (t === n)
          return wn;
        if (t === n - 1)
          return Math.exp((t + (1 << this._scale)) / this._scaleFactor) / 2;
        throw new St("overflow: " + t + " is < minimum lower boundary: " + n);
      }
      return Math.exp(t * this._inverseFactor);
    }, Object.defineProperty(e.prototype, "scale", {
      /**
       * The scale used by this mapping
       * @returns {number}
       */
      get: function() {
        return this._scale;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._minNormalLowerBoundaryIndex = function() {
      return Ja << this._scale;
    }, e.prototype._maxNormalLowerBoundaryIndex = function() {
      return (Za + 1 << this._scale) - 1;
    }, e;
  }()
), eo = -10, to = 20, p_ = Array.from({ length: 31 }, function(e, t) {
  return t > 10 ? new d_(t - 10) : new f_(t - 10);
});
function ro(e) {
  if (e > to || e < eo)
    throw new St("expected scale >= " + eo + " && <= " + to + ", got: " + e);
  return p_[e + 10];
}
var h_ = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Ut = (
  /** @class */
  function() {
    function e(t, r) {
      this.low = t, this.high = r;
    }
    return e.combine = function(t, r) {
      return new e(Math.min(t.low, r.low), Math.max(t.high, r.high));
    }, e;
  }()
), __ = 20, v_ = 160, Zr = 2, y_ = (
  /** @class */
  function() {
    function e(t, r, n, i, o, a, u, c, s, l, f) {
      t === void 0 && (t = t), r === void 0 && (r = v_), n === void 0 && (n = !0), i === void 0 && (i = 0), o === void 0 && (o = 0), a === void 0 && (a = 0), u === void 0 && (u = Number.POSITIVE_INFINITY), c === void 0 && (c = Number.NEGATIVE_INFINITY), s === void 0 && (s = new Qi()), l === void 0 && (l = new Qi()), f === void 0 && (f = ro(__)), this.startTime = t, this._maxSize = r, this._recordMinMax = n, this._sum = i, this._count = o, this._zeroCount = a, this._min = u, this._max = c, this._positive = s, this._negative = l, this._mapping = f, this._maxSize < Zr && (g.warn("Exponential Histogram Max Size set to " + this._maxSize + ",                 changing to the minimum size of: " + Zr), this._maxSize = Zr);
    }
    return e.prototype.record = function(t) {
      this.updateByIncrement(t, 1);
    }, e.prototype.setStartTime = function(t) {
      this.startTime = t;
    }, e.prototype.toPointValue = function() {
      return {
        hasMinMax: this._recordMinMax,
        min: this.min,
        max: this.max,
        sum: this.sum,
        positive: {
          offset: this.positive.offset,
          bucketCounts: this.positive.counts()
        },
        negative: {
          offset: this.negative.offset,
          bucketCounts: this.negative.counts()
        },
        count: this.count,
        scale: this.scale,
        zeroCount: this.zeroCount
      };
    }, Object.defineProperty(e.prototype, "sum", {
      /**
       * @returns {Number} The sum of values recorded by this accumulation
       */
      get: function() {
        return this._sum;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "min", {
      /**
       * @returns {Number} The minimum value recorded by this accumulation
       */
      get: function() {
        return this._min;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "max", {
      /**
       * @returns {Number} The maximum value recorded by this accumulation
       */
      get: function() {
        return this._max;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "count", {
      /**
       * @returns {Number} The count of values recorded by this accumulation
       */
      get: function() {
        return this._count;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "zeroCount", {
      /**
       * @returns {Number} The number of 0 values recorded by this accumulation
       */
      get: function() {
        return this._zeroCount;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "scale", {
      /**
       * @returns {Number} The scale used by this accumulation
       */
      get: function() {
        return this._count === this._zeroCount ? 0 : this._mapping.scale;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "positive", {
      /**
       * positive holds the positive values
       * @returns {Buckets}
       */
      get: function() {
        return this._positive;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "negative", {
      /**
       * negative holds the negative values by their absolute value
       * @returns {Buckets}
       */
      get: function() {
        return this._negative;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.updateByIncrement = function(t, r) {
      if (!Number.isNaN(t)) {
        if (t > this._max && (this._max = t), t < this._min && (this._min = t), this._count += r, t === 0) {
          this._zeroCount += r;
          return;
        }
        this._sum += t * r, t > 0 ? this._updateBuckets(this._positive, t, r) : this._updateBuckets(this._negative, -t, r);
      }
    }, e.prototype.merge = function(t) {
      this._count === 0 ? (this._min = t.min, this._max = t.max) : t.count !== 0 && (t.min < this.min && (this._min = t.min), t.max > this.max && (this._max = t.max)), this.startTime = t.startTime, this._sum += t.sum, this._count += t.count, this._zeroCount += t.zeroCount;
      var r = this._minScale(t);
      this._downscale(this.scale - r), this._mergeBuckets(this.positive, t, t.positive, r), this._mergeBuckets(this.negative, t, t.negative, r);
    }, e.prototype.diff = function(t) {
      this._min = 1 / 0, this._max = -1 / 0, this._sum -= t.sum, this._count -= t.count, this._zeroCount -= t.zeroCount;
      var r = this._minScale(t);
      this._downscale(this.scale - r), this._diffBuckets(this.positive, t, t.positive, r), this._diffBuckets(this.negative, t, t.negative, r);
    }, e.prototype.clone = function() {
      return new e(this.startTime, this._maxSize, this._recordMinMax, this._sum, this._count, this._zeroCount, this._min, this._max, this.positive.clone(), this.negative.clone(), this._mapping);
    }, e.prototype._updateBuckets = function(t, r, n) {
      var i = this._mapping.mapToIndex(r), o = !1, a = 0, u = 0;
      if (t.length === 0 ? (t.indexStart = i, t.indexEnd = t.indexStart, t.indexBase = t.indexStart) : i < t.indexStart && t.indexEnd - i >= this._maxSize ? (o = !0, u = i, a = t.indexEnd) : i > t.indexEnd && i - t.indexStart >= this._maxSize && (o = !0, u = t.indexStart, a = i), o) {
        var c = this._changeScale(a, u);
        this._downscale(c), i = this._mapping.mapToIndex(r);
      }
      this._incrementIndexBy(t, i, n);
    }, e.prototype._incrementIndexBy = function(t, r, n) {
      if (n !== 0) {
        if (t.length === 0 && (t.indexStart = t.indexEnd = t.indexBase = r), r < t.indexStart) {
          var i = t.indexEnd - r;
          i >= t.backing.length && this._grow(t, i + 1), t.indexStart = r;
        } else if (r > t.indexEnd) {
          var i = r - t.indexStart;
          i >= t.backing.length && this._grow(t, i + 1), t.indexEnd = r;
        }
        var o = r - t.indexBase;
        o < 0 && (o += t.backing.length), t.incrementBucket(o, n);
      }
    }, e.prototype._grow = function(t, r) {
      var n = t.backing.length, i = t.indexBase - t.indexStart, o = n - i, a = c_(r);
      a > this._maxSize && (a = this._maxSize);
      var u = a - i;
      t.backing.growTo(a, o, u);
    }, e.prototype._changeScale = function(t, r) {
      for (var n = 0; t - r >= this._maxSize; )
        t >>= 1, r >>= 1, n++;
      return n;
    }, e.prototype._downscale = function(t) {
      if (t !== 0) {
        if (t < 0)
          throw new Error("impossible change of scale: " + this.scale);
        var r = this._mapping.scale - t;
        this._positive.downscale(t), this._negative.downscale(t), this._mapping = ro(r);
      }
    }, e.prototype._minScale = function(t) {
      var r = Math.min(this.scale, t.scale), n = Ut.combine(this._highLowAtScale(this.positive, this.scale, r), this._highLowAtScale(t.positive, t.scale, r)), i = Ut.combine(this._highLowAtScale(this.negative, this.scale, r), this._highLowAtScale(t.negative, t.scale, r));
      return Math.min(r - this._changeScale(n.high, n.low), r - this._changeScale(i.high, i.low));
    }, e.prototype._highLowAtScale = function(t, r, n) {
      if (t.length === 0)
        return new Ut(0, -1);
      var i = r - n;
      return new Ut(t.indexStart >> i, t.indexEnd >> i);
    }, e.prototype._mergeBuckets = function(t, r, n, i) {
      for (var o = n.offset, a = r.scale - i, u = 0; u < n.length; u++)
        this._incrementIndexBy(t, o + u >> a, n.at(u));
    }, e.prototype._diffBuckets = function(t, r, n, i) {
      for (var o = n.offset, a = r.scale - i, u = 0; u < n.length; u++) {
        var c = o + u >> a, s = c - t.indexBase;
        s < 0 && (s += t.backing.length), t.decrementBucket(s, n.at(u));
      }
      t.trim();
    }, e;
  }()
), g_ = (
  /** @class */
  function() {
    function e(t, r) {
      this._maxSize = t, this._recordMinMax = r, this.kind = xe.EXPONENTIAL_HISTOGRAM;
    }
    return e.prototype.createAccumulation = function(t) {
      return new y_(t, this._maxSize, this._recordMinMax);
    }, e.prototype.merge = function(t, r) {
      var n = r.clone();
      return n.merge(t), n;
    }, e.prototype.diff = function(t, r) {
      var n = r.clone();
      return n.diff(t), n;
    }, e.prototype.toMetricData = function(t, r, n, i) {
      return {
        descriptor: t,
        aggregationTemporality: r,
        dataPointType: ie.EXPONENTIAL_HISTOGRAM,
        dataPoints: n.map(function(o) {
          var a = h_(o, 2), u = a[0], c = a[1], s = c.toPointValue(), l = t.type === S.GAUGE || t.type === S.UP_DOWN_COUNTER || t.type === S.OBSERVABLE_GAUGE || t.type === S.OBSERVABLE_UP_DOWN_COUNTER;
          return {
            attributes: u,
            startTime: c.startTime,
            endTime: i,
            value: {
              min: s.hasMinMax ? s.min : void 0,
              max: s.hasMinMax ? s.max : void 0,
              sum: l ? void 0 : s.sum,
              positive: {
                offset: s.positive.offset,
                bucketCounts: s.positive.bucketCounts
              },
              negative: {
                offset: s.negative.offset,
                bucketCounts: s.negative.bucketCounts
              },
              count: s.count,
              scale: s.scale,
              zeroCount: s.zeroCount
            }
          };
        })
      };
    }, e;
  }()
), m_ = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Qr = (
  /** @class */
  function() {
    function e(t, r, n) {
      r === void 0 && (r = 0), n === void 0 && (n = [0, 0]), this.startTime = t, this._current = r, this.sampleTime = n;
    }
    return e.prototype.record = function(t) {
      this._current = t, this.sampleTime = W(Date.now());
    }, e.prototype.setStartTime = function(t) {
      this.startTime = t;
    }, e.prototype.toPointValue = function() {
      return this._current;
    }, e;
  }()
), E_ = (
  /** @class */
  function() {
    function e() {
      this.kind = xe.LAST_VALUE;
    }
    return e.prototype.createAccumulation = function(t) {
      return new Qr(t);
    }, e.prototype.merge = function(t, r) {
      var n = Mt(r.sampleTime) >= Mt(t.sampleTime) ? r : t;
      return new Qr(t.startTime, n.toPointValue(), n.sampleTime);
    }, e.prototype.diff = function(t, r) {
      var n = Mt(r.sampleTime) >= Mt(t.sampleTime) ? r : t;
      return new Qr(r.startTime, n.toPointValue(), n.sampleTime);
    }, e.prototype.toMetricData = function(t, r, n, i) {
      return {
        descriptor: t,
        aggregationTemporality: r,
        dataPointType: ie.GAUGE,
        dataPoints: n.map(function(o) {
          var a = m_(o, 2), u = a[0], c = a[1];
          return {
            attributes: u,
            startTime: c.startTime,
            endTime: i,
            value: c.toPointValue()
          };
        })
      };
    }, e;
  }()
), T_ = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, lt = (
  /** @class */
  function() {
    function e(t, r, n, i) {
      n === void 0 && (n = 0), i === void 0 && (i = !1), this.startTime = t, this.monotonic = r, this._current = n, this.reset = i;
    }
    return e.prototype.record = function(t) {
      this.monotonic && t < 0 || (this._current += t);
    }, e.prototype.setStartTime = function(t) {
      this.startTime = t;
    }, e.prototype.toPointValue = function() {
      return this._current;
    }, e;
  }()
), no = (
  /** @class */
  function() {
    function e(t) {
      this.monotonic = t, this.kind = xe.SUM;
    }
    return e.prototype.createAccumulation = function(t) {
      return new lt(t, this.monotonic);
    }, e.prototype.merge = function(t, r) {
      var n = t.toPointValue(), i = r.toPointValue();
      return r.reset ? new lt(r.startTime, this.monotonic, i, r.reset) : new lt(t.startTime, this.monotonic, n + i);
    }, e.prototype.diff = function(t, r) {
      var n = t.toPointValue(), i = r.toPointValue();
      return this.monotonic && n > i ? new lt(r.startTime, this.monotonic, i, !0) : new lt(r.startTime, this.monotonic, i - n);
    }, e.prototype.toMetricData = function(t, r, n, i) {
      return {
        descriptor: t,
        aggregationTemporality: r,
        dataPointType: ie.SUM,
        dataPoints: n.map(function(o) {
          var a = T_(o, 2), u = a[0], c = a[1];
          return {
            attributes: u,
            startTime: c.startTime,
            endTime: i,
            value: c.toPointValue()
          };
        }),
        isMonotonic: this.monotonic
      };
    }, e;
  }()
), Be = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), fe = (
  /** @class */
  function() {
    function e() {
    }
    return e.Drop = function() {
      return ts;
    }, e.Sum = function() {
      return rs;
    }, e.LastValue = function() {
      return ns;
    }, e.Histogram = function() {
      return is;
    }, e.ExponentialHistogram = function() {
      return P_;
    }, e.Default = function() {
      return N_;
    }, e;
  }()
), S_ = (
  /** @class */
  function(e) {
    Be(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.createAggregator = function(r) {
      return t.DEFAULT_INSTANCE;
    }, t.DEFAULT_INSTANCE = new Zh(), t;
  }(fe)
), b_ = (
  /** @class */
  function(e) {
    Be(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.createAggregator = function(r) {
      switch (r.type) {
        case S.COUNTER:
        case S.OBSERVABLE_COUNTER:
        case S.HISTOGRAM:
          return t.MONOTONIC_INSTANCE;
        default:
          return t.NON_MONOTONIC_INSTANCE;
      }
    }, t.MONOTONIC_INSTANCE = new no(!0), t.NON_MONOTONIC_INSTANCE = new no(!1), t;
  }(fe)
), w_ = (
  /** @class */
  function(e) {
    Be(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.createAggregator = function(r) {
      return t.DEFAULT_INSTANCE;
    }, t.DEFAULT_INSTANCE = new E_(), t;
  }(fe)
), A_ = (
  /** @class */
  function(e) {
    Be(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.createAggregator = function(r) {
      return t.DEFAULT_INSTANCE;
    }, t.DEFAULT_INSTANCE = new Ya([0, 5, 10, 25, 50, 75, 100, 250, 500, 750, 1e3, 2500, 5e3, 7500, 1e4], !0), t;
  }(fe)
), O_ = (
  /** @class */
  function(e) {
    Be(t, e);
    function t(r, n) {
      n === void 0 && (n = !0);
      var i = e.call(this) || this;
      if (i._recordMinMax = n, r == null)
        throw new Error("ExplicitBucketHistogramAggregation should be created with explicit boundaries, if a single bucket histogram is required, please pass an empty array");
      r = r.concat(), r = r.sort(function(u, c) {
        return u - c;
      });
      var o = r.lastIndexOf(-1 / 0), a = r.indexOf(1 / 0);
      return a === -1 && (a = void 0), i._boundaries = r.slice(o + 1, a), i;
    }
    return t.prototype.createAggregator = function(r) {
      return new Ya(this._boundaries, this._recordMinMax);
    }, t;
  }(fe)
), R_ = (
  /** @class */
  function(e) {
    Be(t, e);
    function t(r, n) {
      r === void 0 && (r = 160), n === void 0 && (n = !0);
      var i = e.call(this) || this;
      return i._maxSize = r, i._recordMinMax = n, i;
    }
    return t.prototype.createAggregator = function(r) {
      return new g_(this._maxSize, this._recordMinMax);
    }, t;
  }(fe)
), L_ = (
  /** @class */
  function(e) {
    Be(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype._resolve = function(r) {
      switch (r.type) {
        case S.COUNTER:
        case S.UP_DOWN_COUNTER:
        case S.OBSERVABLE_COUNTER:
        case S.OBSERVABLE_UP_DOWN_COUNTER:
          return rs;
        case S.GAUGE:
        case S.OBSERVABLE_GAUGE:
          return ns;
        case S.HISTOGRAM:
          return r.advice.explicitBucketBoundaries ? new O_(r.advice.explicitBucketBoundaries) : is;
      }
      return g.warn("Unable to recognize instrument type: " + r.type), ts;
    }, t.prototype.createAggregator = function(r) {
      return this._resolve(r).createAggregator(r);
    }, t;
  }(fe)
), ts = new S_(), rs = new b_(), ns = new w_(), is = new A_(), P_ = new R_(), N_ = new L_(), C_ = function(e) {
  return fe.Default();
}, M_ = function(e) {
  return Z.CUMULATIVE;
}, en = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, tn = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, io = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, I_ = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, x_ = (
  /** @class */
  function() {
    function e(t) {
      var r, n, i;
      this._shutdown = !1, this._aggregationSelector = (r = t == null ? void 0 : t.aggregationSelector) !== null && r !== void 0 ? r : C_, this._aggregationTemporalitySelector = (n = t == null ? void 0 : t.aggregationTemporalitySelector) !== null && n !== void 0 ? n : M_, this._metricProducers = (i = t == null ? void 0 : t.metricProducers) !== null && i !== void 0 ? i : [], this._cardinalitySelector = t == null ? void 0 : t.cardinalitySelector;
    }
    return e.prototype.setMetricProducer = function(t) {
      if (this._sdkMetricProducer)
        throw new Error("MetricReader can not be bound to a MeterProvider again.");
      this._sdkMetricProducer = t, this.onInitialized();
    }, e.prototype.selectAggregation = function(t) {
      return this._aggregationSelector(t);
    }, e.prototype.selectAggregationTemporality = function(t) {
      return this._aggregationTemporalitySelector(t);
    }, e.prototype.selectCardinalityLimit = function(t) {
      return this._cardinalitySelector ? this._cardinalitySelector(t) : 2e3;
    }, e.prototype.onInitialized = function() {
    }, e.prototype.collect = function(t) {
      return en(this, void 0, void 0, function() {
        var r, n, i, o, a, u;
        return tn(this, function(c) {
          switch (c.label) {
            case 0:
              if (this._sdkMetricProducer === void 0)
                throw new Error("MetricReader is not bound to a MetricProducer");
              if (this._shutdown)
                throw new Error("MetricReader is shutdown");
              return [4, Promise.all(I_([
                this._sdkMetricProducer.collect({
                  timeoutMillis: t == null ? void 0 : t.timeoutMillis
                })
              ], io(this._metricProducers.map(function(s) {
                return s.collect({
                  timeoutMillis: t == null ? void 0 : t.timeoutMillis
                });
              })), !1))];
            case 1:
              return r = io.apply(void 0, [c.sent()]), n = r[0], i = r.slice(1), o = n.errors.concat(Zi(i, function(s) {
                return s.errors;
              })), a = n.resourceMetrics.resource, u = n.resourceMetrics.scopeMetrics.concat(Zi(i, function(s) {
                return s.resourceMetrics.scopeMetrics;
              })), [2, {
                resourceMetrics: {
                  resource: a,
                  scopeMetrics: u
                },
                errors: o
              }];
          }
        });
      });
    }, e.prototype.shutdown = function(t) {
      return en(this, void 0, void 0, function() {
        return tn(this, function(r) {
          switch (r.label) {
            case 0:
              return this._shutdown ? (g.error("Cannot call shutdown twice."), [
                2
                /*return*/
              ]) : (t == null ? void 0 : t.timeoutMillis) != null ? [3, 2] : [4, this.onShutdown()];
            case 1:
              return r.sent(), [3, 4];
            case 2:
              return [4, Tt(this.onShutdown(), t.timeoutMillis)];
            case 3:
              r.sent(), r.label = 4;
            case 4:
              return this._shutdown = !0, [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.forceFlush = function(t) {
      return en(this, void 0, void 0, function() {
        return tn(this, function(r) {
          switch (r.label) {
            case 0:
              return this._shutdown ? (g.warn("Cannot forceFlush on already shutdown MetricReader."), [
                2
                /*return*/
              ]) : (t == null ? void 0 : t.timeoutMillis) != null ? [3, 2] : [4, this.onForceFlush()];
            case 1:
              return r.sent(), [
                2
                /*return*/
              ];
            case 2:
              return [4, Tt(this.onForceFlush(), t.timeoutMillis)];
            case 3:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e;
  }()
), D_ = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Bt = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, Ht = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, k_ = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, U_ = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, B_ = (
  /** @class */
  function(e) {
    D_(t, e);
    function t(r) {
      var n, i, o, a, u = e.call(this, {
        aggregationSelector: (n = r.exporter.selectAggregation) === null || n === void 0 ? void 0 : n.bind(r.exporter),
        aggregationTemporalitySelector: (i = r.exporter.selectAggregationTemporality) === null || i === void 0 ? void 0 : i.bind(r.exporter),
        metricProducers: r.metricProducers
      }) || this;
      if (r.exportIntervalMillis !== void 0 && r.exportIntervalMillis <= 0)
        throw Error("exportIntervalMillis must be greater than 0");
      if (r.exportTimeoutMillis !== void 0 && r.exportTimeoutMillis <= 0)
        throw Error("exportTimeoutMillis must be greater than 0");
      if (r.exportTimeoutMillis !== void 0 && r.exportIntervalMillis !== void 0 && r.exportIntervalMillis < r.exportTimeoutMillis)
        throw Error("exportIntervalMillis must be greater than or equal to exportTimeoutMillis");
      return u._exportInterval = (o = r.exportIntervalMillis) !== null && o !== void 0 ? o : 6e4, u._exportTimeout = (a = r.exportTimeoutMillis) !== null && a !== void 0 ? a : 3e4, u._exporter = r.exporter, u;
    }
    return t.prototype._runOnce = function() {
      return Bt(this, void 0, void 0, function() {
        var r;
        return Ht(this, function(n) {
          switch (n.label) {
            case 0:
              return n.trys.push([0, 2, , 3]), [4, Tt(this._doRun(), this._exportTimeout)];
            case 1:
              return n.sent(), [3, 3];
            case 2:
              return r = n.sent(), r instanceof Ka ? (g.error("Export took longer than %s milliseconds and timed out.", this._exportTimeout), [
                2
                /*return*/
              ]) : (me(r), [3, 3]);
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype._doRun = function() {
      var r, n;
      return Bt(this, void 0, void 0, function() {
        var i, o, a, u, c, s;
        return Ht(this, function(l) {
          switch (l.label) {
            case 0:
              return [4, this.collect({
                timeoutMillis: this._exportTimeout
              })];
            case 1:
              if (i = l.sent(), o = i.resourceMetrics, a = i.errors, a.length > 0 && (s = g).error.apply(s, U_(["PeriodicExportingMetricReader: metrics collection errors"], k_(a), !1)), !o.resource.asyncAttributesPending) return [3, 5];
              l.label = 2;
            case 2:
              return l.trys.push([2, 4, , 5]), [4, (n = (r = o.resource).waitForAsyncAttributes) === null || n === void 0 ? void 0 : n.call(r)];
            case 3:
              return l.sent(), [3, 5];
            case 4:
              return u = l.sent(), g.debug("Error while resolving async portion of resource: ", u), me(u), [3, 5];
            case 5:
              return o.scopeMetrics.length === 0 ? [
                2
                /*return*/
              ] : [4, Hf._export(this._exporter, o)];
            case 6:
              if (c = l.sent(), c.code !== N.SUCCESS)
                throw new Error("PeriodicExportingMetricReader: metrics export failed (error " + c.error + ")");
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.onInitialized = function() {
      var r = this;
      this._interval = setInterval(function() {
        r._runOnce();
      }, this._exportInterval);
    }, t.prototype.onForceFlush = function() {
      return Bt(this, void 0, void 0, function() {
        return Ht(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, this._runOnce()];
            case 1:
              return r.sent(), [4, this._exporter.forceFlush()];
            case 2:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.onShutdown = function() {
      return Bt(this, void 0, void 0, function() {
        return Ht(this, function(r) {
          switch (r.label) {
            case 0:
              return this._interval && clearInterval(this._interval), [4, this.onForceFlush()];
            case 1:
              return r.sent(), [4, this._exporter.shutdown()];
            case 2:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t;
  }(x_)
), H_ = (
  /** @class */
  function() {
    function e() {
      this._registeredViews = [];
    }
    return e.prototype.addView = function(t) {
      this._registeredViews.push(t);
    }, e.prototype.findViews = function(t, r) {
      var n = this, i = this._registeredViews.filter(function(o) {
        return n._matchInstrument(o.instrumentSelector, t) && n._matchMeter(o.meterSelector, r);
      });
      return i;
    }, e.prototype._matchInstrument = function(t, r) {
      return (t.getType() === void 0 || r.type === t.getType()) && t.getNameFilter().match(r.name) && t.getUnitFilter().match(r.unit);
    }, e.prototype._matchMeter = function(t, r) {
      return t.getNameFilter().match(r.name) && (r.version === void 0 || t.getVersionFilter().match(r.version)) && (r.schemaUrl === void 0 || t.getSchemaUrlFilter().match(r.schemaUrl));
    }, e;
  }()
), He = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), mr = (
  /** @class */
  function() {
    function e(t, r) {
      this._writableMetricStorage = t, this._descriptor = r;
    }
    return e.prototype._record = function(t, r, n) {
      if (r === void 0 && (r = {}), n === void 0 && (n = O.active()), typeof t != "number") {
        g.warn("non-number value provided to metric " + this._descriptor.name + ": " + t);
        return;
      }
      this._descriptor.valueType === ge.INT && !Number.isInteger(t) && (g.warn("INT value type cannot accept a floating-point value for " + this._descriptor.name + ", ignoring the fractional digits."), t = Math.trunc(t), !Number.isInteger(t)) || this._writableMetricStorage.record(t, r, n, W(Date.now()));
    }, e;
  }()
), G_ = (
  /** @class */
  function(e) {
    He(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.add = function(r, n, i) {
      this._record(r, n, i);
    }, t;
  }(mr)
), F_ = (
  /** @class */
  function(e) {
    He(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.add = function(r, n, i) {
      if (r < 0) {
        g.warn("negative value provided to counter " + this._descriptor.name + ": " + r);
        return;
      }
      this._record(r, n, i);
    }, t;
  }(mr)
), j_ = (
  /** @class */
  function(e) {
    He(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.record = function(r, n, i) {
      this._record(r, n, i);
    }, t;
  }(mr)
), V_ = (
  /** @class */
  function(e) {
    He(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.record = function(r, n, i) {
      if (r < 0) {
        g.warn("negative value provided to histogram " + this._descriptor.name + ": " + r);
        return;
      }
      this._record(r, n, i);
    }, t;
  }(mr)
), Er = (
  /** @class */
  function() {
    function e(t, r, n) {
      this._observableRegistry = n, this._descriptor = t, this._metricStorages = r;
    }
    return e.prototype.addCallback = function(t) {
      this._observableRegistry.addCallback(t, this);
    }, e.prototype.removeCallback = function(t) {
      this._observableRegistry.removeCallback(t, this);
    }, e;
  }()
), $_ = (
  /** @class */
  function(e) {
    He(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(Er)
), z_ = (
  /** @class */
  function(e) {
    He(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(Er)
), X_ = (
  /** @class */
  function(e) {
    He(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(Er)
);
function On(e) {
  return e instanceof Er;
}
var q_ = (
  /** @class */
  function() {
    function e(t) {
      this._meterSharedState = t;
    }
    return e.prototype.createGauge = function(t, r) {
      var n = pe(t, S.GAUGE, r), i = this._meterSharedState.registerMetricStorage(n);
      return new j_(i, n);
    }, e.prototype.createHistogram = function(t, r) {
      var n = pe(t, S.HISTOGRAM, r), i = this._meterSharedState.registerMetricStorage(n);
      return new V_(i, n);
    }, e.prototype.createCounter = function(t, r) {
      var n = pe(t, S.COUNTER, r), i = this._meterSharedState.registerMetricStorage(n);
      return new F_(i, n);
    }, e.prototype.createUpDownCounter = function(t, r) {
      var n = pe(t, S.UP_DOWN_COUNTER, r), i = this._meterSharedState.registerMetricStorage(n);
      return new G_(i, n);
    }, e.prototype.createObservableGauge = function(t, r) {
      var n = pe(t, S.OBSERVABLE_GAUGE, r), i = this._meterSharedState.registerAsyncMetricStorage(n);
      return new z_(n, i, this._meterSharedState.observableRegistry);
    }, e.prototype.createObservableCounter = function(t, r) {
      var n = pe(t, S.OBSERVABLE_COUNTER, r), i = this._meterSharedState.registerAsyncMetricStorage(n);
      return new $_(n, i, this._meterSharedState.observableRegistry);
    }, e.prototype.createObservableUpDownCounter = function(t, r) {
      var n = pe(t, S.OBSERVABLE_UP_DOWN_COUNTER, r), i = this._meterSharedState.registerAsyncMetricStorage(n);
      return new X_(n, i, this._meterSharedState.observableRegistry);
    }, e.prototype.addBatchObservableCallback = function(t, r) {
      this._meterSharedState.observableRegistry.addBatchCallback(t, r);
    }, e.prototype.removeBatchObservableCallback = function(t, r) {
      this._meterSharedState.observableRegistry.removeBatchCallback(t, r);
    }, e;
  }()
), os = (
  /** @class */
  function() {
    function e(t) {
      this._instrumentDescriptor = t;
    }
    return e.prototype.getInstrumentDescriptor = function() {
      return this._instrumentDescriptor;
    }, e.prototype.updateDescription = function(t) {
      this._instrumentDescriptor = pe(this._instrumentDescriptor.name, this._instrumentDescriptor.type, {
        description: t,
        valueType: this._instrumentDescriptor.valueType,
        unit: this._instrumentDescriptor.unit,
        advice: this._instrumentDescriptor.advice
      });
    }, e;
  }()
), W_ = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), oo = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, K_ = (
  /** @class */
  function() {
    function e(t) {
      this._hash = t, this._valueMap = /* @__PURE__ */ new Map(), this._keyMap = /* @__PURE__ */ new Map();
    }
    return e.prototype.get = function(t, r) {
      return r != null || (r = this._hash(t)), this._valueMap.get(r);
    }, e.prototype.getOrDefault = function(t, r) {
      var n = this._hash(t);
      if (this._valueMap.has(n))
        return this._valueMap.get(n);
      var i = r();
      return this._keyMap.has(n) || this._keyMap.set(n, t), this._valueMap.set(n, i), i;
    }, e.prototype.set = function(t, r, n) {
      n != null || (n = this._hash(t)), this._keyMap.has(n) || this._keyMap.set(n, t), this._valueMap.set(n, r);
    }, e.prototype.has = function(t, r) {
      return r != null || (r = this._hash(t)), this._valueMap.has(r);
    }, e.prototype.keys = function() {
      var t, r;
      return oo(this, function(n) {
        switch (n.label) {
          case 0:
            t = this._keyMap.entries(), r = t.next(), n.label = 1;
          case 1:
            return r.done === !0 ? [3, 3] : [4, [r.value[1], r.value[0]]];
          case 2:
            return n.sent(), r = t.next(), [3, 1];
          case 3:
            return [
              2
              /*return*/
            ];
        }
      });
    }, e.prototype.entries = function() {
      var t, r;
      return oo(this, function(n) {
        switch (n.label) {
          case 0:
            t = this._valueMap.entries(), r = t.next(), n.label = 1;
          case 1:
            return r.done === !0 ? [3, 3] : [4, [this._keyMap.get(r.value[0]), r.value[1], r.value[0]]];
          case 2:
            return n.sent(), r = t.next(), [3, 1];
          case 3:
            return [
              2
              /*return*/
            ];
        }
      });
    }, Object.defineProperty(e.prototype, "size", {
      get: function() {
        return this._valueMap.size;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }()
), Ne = (
  /** @class */
  function(e) {
    W_(t, e);
    function t() {
      return e.call(this, Wa) || this;
    }
    return t;
  }(K_)
), Y_ = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, as = (
  /** @class */
  function() {
    function e(t, r) {
      this._aggregator = t, this._activeCollectionStorage = new Ne(), this._cumulativeMemoStorage = new Ne(), this._overflowAttributes = { "otel.metric.overflow": !0 }, this._cardinalityLimit = (r != null ? r : 2e3) - 1, this._overflowHashCode = Wa(this._overflowAttributes);
    }
    return e.prototype.record = function(t, r, n, i) {
      var o = this, a = this._activeCollectionStorage.get(r);
      if (!a) {
        if (this._activeCollectionStorage.size >= this._cardinalityLimit) {
          var u = this._activeCollectionStorage.getOrDefault(this._overflowAttributes, function() {
            return o._aggregator.createAccumulation(i);
          });
          u == null || u.record(t);
          return;
        }
        a = this._aggregator.createAccumulation(i), this._activeCollectionStorage.set(r, a);
      }
      a == null || a.record(t);
    }, e.prototype.batchCumulate = function(t, r) {
      var n = this;
      Array.from(t.entries()).forEach(function(i) {
        var o = Y_(i, 3), a = o[0], u = o[1], c = o[2], s = n._aggregator.createAccumulation(r);
        s == null || s.record(u);
        var l = s;
        if (n._cumulativeMemoStorage.has(a, c)) {
          var f = n._cumulativeMemoStorage.get(a, c);
          l = n._aggregator.diff(f, s);
        } else if (n._cumulativeMemoStorage.size >= n._cardinalityLimit && (a = n._overflowAttributes, c = n._overflowHashCode, n._cumulativeMemoStorage.has(a, c))) {
          var f = n._cumulativeMemoStorage.get(a, c);
          l = n._aggregator.diff(f, s);
        }
        if (n._activeCollectionStorage.has(a, c)) {
          var d = n._activeCollectionStorage.get(a, c);
          l = n._aggregator.merge(d, l);
        }
        n._cumulativeMemoStorage.set(a, s, c), n._activeCollectionStorage.set(a, l, c);
      });
    }, e.prototype.collect = function() {
      var t = this._activeCollectionStorage;
      return this._activeCollectionStorage = new Ne(), t;
    }, e;
  }()
), rn = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, ao = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, ss = (
  /** @class */
  function() {
    function e(t, r) {
      var n = this;
      this._aggregator = t, this._unreportedAccumulations = /* @__PURE__ */ new Map(), this._reportHistory = /* @__PURE__ */ new Map(), r.forEach(function(i) {
        n._unreportedAccumulations.set(i, []);
      });
    }
    return e.prototype.buildMetrics = function(t, r, n, i) {
      this._stashAccumulations(n);
      var o = this._getMergedUnreportedAccumulations(t), a = o, u;
      if (this._reportHistory.has(t)) {
        var c = this._reportHistory.get(t), s = c.collectionTime;
        u = c.aggregationTemporality, u === Z.CUMULATIVE ? a = e.merge(c.accumulations, o, this._aggregator) : a = e.calibrateStartTime(c.accumulations, o, s);
      } else
        u = t.selectAggregationTemporality(r.type);
      this._reportHistory.set(t, {
        accumulations: a,
        collectionTime: i,
        aggregationTemporality: u
      });
      var l = J_(a);
      if (l.length !== 0)
        return this._aggregator.toMetricData(
          r,
          u,
          l,
          /* endTime */
          i
        );
    }, e.prototype._stashAccumulations = function(t) {
      var r, n, i = this._unreportedAccumulations.keys();
      try {
        for (var o = rn(i), a = o.next(); !a.done; a = o.next()) {
          var u = a.value, c = this._unreportedAccumulations.get(u);
          c === void 0 && (c = [], this._unreportedAccumulations.set(u, c)), c.push(t);
        }
      } catch (s) {
        r = { error: s };
      } finally {
        try {
          a && !a.done && (n = o.return) && n.call(o);
        } finally {
          if (r) throw r.error;
        }
      }
    }, e.prototype._getMergedUnreportedAccumulations = function(t) {
      var r, n, i = new Ne(), o = this._unreportedAccumulations.get(t);
      if (this._unreportedAccumulations.set(t, []), o === void 0)
        return i;
      try {
        for (var a = rn(o), u = a.next(); !u.done; u = a.next()) {
          var c = u.value;
          i = e.merge(i, c, this._aggregator);
        }
      } catch (s) {
        r = { error: s };
      } finally {
        try {
          u && !u.done && (n = a.return) && n.call(a);
        } finally {
          if (r) throw r.error;
        }
      }
      return i;
    }, e.merge = function(t, r, n) {
      for (var i = t, o = r.entries(), a = o.next(); a.done !== !0; ) {
        var u = ao(a.value, 3), c = u[0], s = u[1], l = u[2];
        if (t.has(c, l)) {
          var f = t.get(c, l), d = n.merge(f, s);
          i.set(c, d, l);
        } else
          i.set(c, s, l);
        a = o.next();
      }
      return i;
    }, e.calibrateStartTime = function(t, r, n) {
      var i, o;
      try {
        for (var a = rn(t.keys()), u = a.next(); !u.done; u = a.next()) {
          var c = ao(u.value, 2), s = c[0], l = c[1], f = r.get(s, l);
          f == null || f.setStartTime(n);
        }
      } catch (d) {
        i = { error: d };
      } finally {
        try {
          u && !u.done && (o = a.return) && o.call(a);
        } finally {
          if (i) throw i.error;
        }
      }
      return r;
    }, e;
  }()
);
function J_(e) {
  return Array.from(e.entries());
}
var Z_ = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Q_ = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, ev = (
  /** @class */
  function(e) {
    Z_(t, e);
    function t(r, n, i, o, a) {
      var u = e.call(this, r) || this;
      return u._attributesProcessor = i, u._aggregationCardinalityLimit = a, u._deltaMetricStorage = new as(n, u._aggregationCardinalityLimit), u._temporalMetricStorage = new ss(n, o), u;
    }
    return t.prototype.record = function(r, n) {
      var i = this, o = new Ne();
      Array.from(r.entries()).forEach(function(a) {
        var u = Q_(a, 2), c = u[0], s = u[1];
        o.set(i._attributesProcessor.process(c), s);
      }), this._deltaMetricStorage.batchCumulate(o, n);
    }, t.prototype.collect = function(r, n) {
      var i = this._deltaMetricStorage.collect();
      return this._temporalMetricStorage.buildMetrics(r, this._instrumentDescriptor, i, n);
    }, t;
  }(os)
);
function so(e, t) {
  var r = "";
  return e.unit !== t.unit && (r += "	- Unit '" + e.unit + "' does not match '" + t.unit + `'
`), e.type !== t.type && (r += "	- Type '" + e.type + "' does not match '" + t.type + `'
`), e.valueType !== t.valueType && (r += "	- Value Type '" + e.valueType + "' does not match '" + t.valueType + `'
`), e.description !== t.description && (r += "	- Description '" + e.description + "' does not match '" + t.description + `'
`), r;
}
function tv(e, t) {
  return "	- use valueType '" + e.valueType + "' on instrument creation or use an instrument name other than '" + t.name + "'";
}
function rv(e, t) {
  return "	- use unit '" + e.unit + "' on instrument creation or use an instrument name other than '" + t.name + "'";
}
function nv(e, t) {
  var r = {
    name: t.name,
    type: t.type,
    unit: t.unit
  }, n = JSON.stringify(r);
  return "	- create a new view with a name other than '" + e.name + "' and InstrumentSelector '" + n + "'";
}
function iv(e, t) {
  var r = {
    name: t.name,
    type: t.type,
    unit: t.unit
  }, n = JSON.stringify(r);
  return "	- create a new view with a name other than '" + e.name + "' and InstrumentSelector '" + n + `'
    	- OR - create a new view with the name ` + e.name + " and description '" + e.description + "' and InstrumentSelector " + n + `
    	- OR - create a new view with the name ` + t.name + " and description '" + e.description + "' and InstrumentSelector " + n;
}
function uo(e, t) {
  return e.valueType !== t.valueType ? tv(e, t) : e.unit !== t.unit ? rv(e, t) : e.type !== t.type ? nv(e, t) : e.description !== t.description ? iv(e, t) : "";
}
var nn = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, ov = (
  /** @class */
  function() {
    function e() {
      this._sharedRegistry = /* @__PURE__ */ new Map(), this._perCollectorRegistry = /* @__PURE__ */ new Map();
    }
    return e.create = function() {
      return new e();
    }, e.prototype.getStorages = function(t) {
      var r, n, i, o, a = [];
      try {
        for (var u = nn(this._sharedRegistry.values()), c = u.next(); !c.done; c = u.next()) {
          var s = c.value;
          a = a.concat(s);
        }
      } catch (h) {
        r = { error: h };
      } finally {
        try {
          c && !c.done && (n = u.return) && n.call(u);
        } finally {
          if (r) throw r.error;
        }
      }
      var l = this._perCollectorRegistry.get(t);
      if (l != null)
        try {
          for (var f = nn(l.values()), d = f.next(); !d.done; d = f.next()) {
            var s = d.value;
            a = a.concat(s);
          }
        } catch (h) {
          i = { error: h };
        } finally {
          try {
            d && !d.done && (o = f.return) && o.call(f);
          } finally {
            if (i) throw i.error;
          }
        }
      return a;
    }, e.prototype.register = function(t) {
      this._registerStorage(t, this._sharedRegistry);
    }, e.prototype.registerForCollector = function(t, r) {
      var n = this._perCollectorRegistry.get(t);
      n == null && (n = /* @__PURE__ */ new Map(), this._perCollectorRegistry.set(t, n)), this._registerStorage(r, n);
    }, e.prototype.findOrUpdateCompatibleStorage = function(t) {
      var r = this._sharedRegistry.get(t.name);
      return r === void 0 ? null : this._findOrUpdateCompatibleStorage(t, r);
    }, e.prototype.findOrUpdateCompatibleCollectorStorage = function(t, r) {
      var n = this._perCollectorRegistry.get(t);
      if (n === void 0)
        return null;
      var i = n.get(r.name);
      return i === void 0 ? null : this._findOrUpdateCompatibleStorage(r, i);
    }, e.prototype._registerStorage = function(t, r) {
      var n = t.getInstrumentDescriptor(), i = r.get(n.name);
      if (i === void 0) {
        r.set(n.name, [t]);
        return;
      }
      i.push(t);
    }, e.prototype._findOrUpdateCompatibleStorage = function(t, r) {
      var n, i, o = null;
      try {
        for (var a = nn(r), u = a.next(); !u.done; u = a.next()) {
          var c = u.value, s = c.getInstrumentDescriptor();
          e_(s, t) ? (s.description !== t.description && (t.description.length > s.description.length && c.updateDescription(t.description), g.warn("A view or instrument with the name ", t.name, ` has already been registered, but has a different description and is incompatible with another registered view.
`, `Details:
`, so(s, t), `The longer description will be used.
To resolve the conflict:`, uo(s, t))), o = c) : g.warn("A view or instrument with the name ", t.name, ` has already been registered and is incompatible with another registered view.
`, `Details:
`, so(s, t), `To resolve the conflict:
`, uo(s, t));
        }
      } catch (l) {
        n = { error: l };
      } finally {
        try {
          u && !u.done && (i = a.return) && i.call(a);
        } finally {
          if (n) throw n.error;
        }
      }
      return o;
    }, e;
  }()
), av = (
  /** @class */
  function() {
    function e(t) {
      this._backingStorages = t;
    }
    return e.prototype.record = function(t, r, n, i) {
      this._backingStorages.forEach(function(o) {
        o.record(t, r, n, i);
      });
    }, e;
  }()
), sv = (
  /** @class */
  function() {
    function e(t, r) {
      this._instrumentName = t, this._valueType = r, this._buffer = new Ne();
    }
    return e.prototype.observe = function(t, r) {
      if (r === void 0 && (r = {}), typeof t != "number") {
        g.warn("non-number value provided to metric " + this._instrumentName + ": " + t);
        return;
      }
      this._valueType === ge.INT && !Number.isInteger(t) && (g.warn("INT value type cannot accept a floating-point value for " + this._instrumentName + ", ignoring the fractional digits."), t = Math.trunc(t), !Number.isInteger(t)) || this._buffer.set(r, t);
    }, e;
  }()
), uv = (
  /** @class */
  function() {
    function e() {
      this._buffer = /* @__PURE__ */ new Map();
    }
    return e.prototype.observe = function(t, r, n) {
      if (n === void 0 && (n = {}), !!On(t)) {
        var i = this._buffer.get(t);
        if (i == null && (i = new Ne(), this._buffer.set(t, i)), typeof r != "number") {
          g.warn("non-number value provided to metric " + t._descriptor.name + ": " + r);
          return;
        }
        t._descriptor.valueType === ge.INT && !Number.isInteger(r) && (g.warn("INT value type cannot accept a floating-point value for " + t._descriptor.name + ", ignoring the fractional digits."), r = Math.trunc(r), !Number.isInteger(r)) || i.set(n, r);
      }
    }, e;
  }()
), on = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, an = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, co = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, lo = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, cv = (
  /** @class */
  function() {
    function e() {
      this._callbacks = [], this._batchCallbacks = [];
    }
    return e.prototype.addCallback = function(t, r) {
      var n = this._findCallback(t, r);
      n >= 0 || this._callbacks.push({ callback: t, instrument: r });
    }, e.prototype.removeCallback = function(t, r) {
      var n = this._findCallback(t, r);
      n < 0 || this._callbacks.splice(n, 1);
    }, e.prototype.addBatchCallback = function(t, r) {
      var n = new Set(r.filter(On));
      if (n.size === 0) {
        g.error("BatchObservableCallback is not associated with valid instruments", r);
        return;
      }
      var i = this._findBatchCallback(t, n);
      i >= 0 || this._batchCallbacks.push({ callback: t, instruments: n });
    }, e.prototype.removeBatchCallback = function(t, r) {
      var n = new Set(r.filter(On)), i = this._findBatchCallback(t, n);
      i < 0 || this._batchCallbacks.splice(i, 1);
    }, e.prototype.observe = function(t, r) {
      return on(this, void 0, void 0, function() {
        var n, i, o, a;
        return an(this, function(u) {
          switch (u.label) {
            case 0:
              return n = this._observeCallbacks(t, r), i = this._observeBatchCallbacks(t, r), [4, qh(lo(lo([], co(n), !1), co(i), !1))];
            case 1:
              return o = u.sent(), a = o.filter(Wh).map(function(c) {
                return c.reason;
              }), [2, a];
          }
        });
      });
    }, e.prototype._observeCallbacks = function(t, r) {
      var n = this;
      return this._callbacks.map(function(i) {
        var o = i.callback, a = i.instrument;
        return on(n, void 0, void 0, function() {
          var u, c;
          return an(this, function(s) {
            switch (s.label) {
              case 0:
                return u = new sv(a._descriptor.name, a._descriptor.valueType), c = Promise.resolve(o(u)), r != null && (c = Tt(c, r)), [4, c];
              case 1:
                return s.sent(), a._metricStorages.forEach(function(l) {
                  l.record(u._buffer, t);
                }), [
                  2
                  /*return*/
                ];
            }
          });
        });
      });
    }, e.prototype._observeBatchCallbacks = function(t, r) {
      var n = this;
      return this._batchCallbacks.map(function(i) {
        var o = i.callback, a = i.instruments;
        return on(n, void 0, void 0, function() {
          var u, c;
          return an(this, function(s) {
            switch (s.label) {
              case 0:
                return u = new uv(), c = Promise.resolve(o(u)), r != null && (c = Tt(c, r)), [4, c];
              case 1:
                return s.sent(), a.forEach(function(l) {
                  var f = u._buffer.get(l);
                  f != null && l._metricStorages.forEach(function(d) {
                    d.record(f, t);
                  });
                }), [
                  2
                  /*return*/
                ];
            }
          });
        });
      });
    }, e.prototype._findCallback = function(t, r) {
      return this._callbacks.findIndex(function(n) {
        return n.callback === t && n.instrument === r;
      });
    }, e.prototype._findBatchCallback = function(t, r) {
      return this._batchCallbacks.findIndex(function(n) {
        return n.callback === t && Kh(n.instruments, r);
      });
    }, e;
  }()
), lv = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), fv = (
  /** @class */
  function(e) {
    lv(t, e);
    function t(r, n, i, o, a) {
      var u = e.call(this, r) || this;
      return u._attributesProcessor = i, u._aggregationCardinalityLimit = a, u._deltaMetricStorage = new as(n, u._aggregationCardinalityLimit), u._temporalMetricStorage = new ss(n, o), u;
    }
    return t.prototype.record = function(r, n, i, o) {
      n = this._attributesProcessor.process(n, i), this._deltaMetricStorage.record(r, n, i, o);
    }, t.prototype.collect = function(r, n) {
      var i = this._deltaMetricStorage.collect();
      return this._temporalMetricStorage.buildMetrics(r, this._instrumentDescriptor, i, n);
    }, t;
  }(os)
), us = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Kn = (
  /** @class */
  function() {
    function e() {
    }
    return e.Noop = function() {
      return pv;
    }, e;
  }()
), dv = (
  /** @class */
  function(e) {
    us(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.process = function(r, n) {
      return r;
    }, t;
  }(Kn)
);
(function(e) {
  us(t, e);
  function t(r) {
    var n = e.call(this) || this;
    return n._allowedAttributeNames = r, n;
  }
  return t.prototype.process = function(r, n) {
    var i = this, o = {};
    return Object.keys(r).filter(function(a) {
      return i._allowedAttributeNames.includes(a);
    }).forEach(function(a) {
      return o[a] = r[a];
    }), o;
  }, t;
})(Kn);
var pv = new dv(), hv = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, _v = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, vv = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, yv = (
  /** @class */
  function() {
    function e(t, r) {
      this._meterProviderSharedState = t, this._instrumentationScope = r, this.metricStorageRegistry = new ov(), this.observableRegistry = new cv(), this.meter = new q_(this);
    }
    return e.prototype.registerMetricStorage = function(t) {
      var r = this._registerMetricStorage(t, fv);
      return r.length === 1 ? r[0] : new av(r);
    }, e.prototype.registerAsyncMetricStorage = function(t) {
      var r = this._registerMetricStorage(t, ev);
      return r;
    }, e.prototype.collect = function(t, r, n) {
      return hv(this, void 0, void 0, function() {
        var i, o, a;
        return _v(this, function(u) {
          switch (u.label) {
            case 0:
              return [4, this.observableRegistry.observe(r, n == null ? void 0 : n.timeoutMillis)];
            case 1:
              return i = u.sent(), o = this.metricStorageRegistry.getStorages(t), o.length === 0 ? [2, null] : (a = o.map(function(c) {
                return c.collect(t, r);
              }).filter(zh), a.length === 0 ? [2, { errors: i }] : [2, {
                scopeMetrics: {
                  scope: this._instrumentationScope,
                  metrics: a
                },
                errors: i
              }]);
          }
        });
      });
    }, e.prototype._registerMetricStorage = function(t, r) {
      var n = this, i = this._meterProviderSharedState.viewRegistry.findViews(t, this._instrumentationScope), o = i.map(function(c) {
        var s = Qh(c, t), l = n.metricStorageRegistry.findOrUpdateCompatibleStorage(s);
        if (l != null)
          return l;
        var f = c.aggregation.createAggregator(s), d = new r(s, f, c.attributesProcessor, n._meterProviderSharedState.metricCollectors, c.aggregationCardinalityLimit);
        return n.metricStorageRegistry.register(d), d;
      });
      if (o.length === 0) {
        var a = this._meterProviderSharedState.selectAggregations(t.type), u = a.map(function(c) {
          var s = vv(c, 2), l = s[0], f = s[1], d = n.metricStorageRegistry.findOrUpdateCompatibleCollectorStorage(l, t);
          if (d != null)
            return d;
          var h = f.createAggregator(t), _ = l.selectCardinalityLimit(t.type), p = new r(t, h, Kn.Noop(), [l], _);
          return n.metricStorageRegistry.registerForCollector(l, p), p;
        });
        o = o.concat(u);
      }
      return o;
    }, e;
  }()
), gv = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, mv = (
  /** @class */
  function() {
    function e(t) {
      this.resource = t, this.viewRegistry = new H_(), this.metricCollectors = [], this.meterSharedStates = /* @__PURE__ */ new Map();
    }
    return e.prototype.getMeterSharedState = function(t) {
      var r = Xh(t), n = this.meterSharedStates.get(r);
      return n == null && (n = new yv(this, t), this.meterSharedStates.set(r, n)), n;
    }, e.prototype.selectAggregations = function(t) {
      var r, n, i = [];
      try {
        for (var o = gv(this.metricCollectors), a = o.next(); !a.done; a = o.next()) {
          var u = a.value;
          i.push([u, u.selectAggregation(t)]);
        }
      } catch (c) {
        r = { error: c };
      } finally {
        try {
          a && !a.done && (n = o.return) && n.call(o);
        } finally {
          if (r) throw r.error;
        }
      }
      return i;
    }, e;
  }()
), Gt = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, Ft = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Ev = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Tv = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Sv = (
  /** @class */
  function() {
    function e(t, r) {
      this._sharedState = t, this._metricReader = r;
    }
    return e.prototype.collect = function(t) {
      return Gt(this, void 0, void 0, function() {
        var r, n, i, o, a = this;
        return Ft(this, function(u) {
          switch (u.label) {
            case 0:
              return r = W(Date.now()), n = [], i = [], o = Array.from(this._sharedState.meterSharedStates.values()).map(function(c) {
                return Gt(a, void 0, void 0, function() {
                  var s;
                  return Ft(this, function(l) {
                    switch (l.label) {
                      case 0:
                        return [4, c.collect(this, r, t)];
                      case 1:
                        return s = l.sent(), (s == null ? void 0 : s.scopeMetrics) != null && n.push(s.scopeMetrics), (s == null ? void 0 : s.errors) != null && i.push.apply(i, Tv([], Ev(s.errors), !1)), [
                          2
                          /*return*/
                        ];
                    }
                  });
                });
              }), [4, Promise.all(o)];
            case 1:
              return u.sent(), [2, {
                resourceMetrics: {
                  resource: this._sharedState.resource,
                  scopeMetrics: n
                },
                errors: i
              }];
          }
        });
      });
    }, e.prototype.forceFlush = function(t) {
      return Gt(this, void 0, void 0, function() {
        return Ft(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, this._metricReader.forceFlush(t)];
            case 1:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.shutdown = function(t) {
      return Gt(this, void 0, void 0, function() {
        return Ft(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, this._metricReader.shutdown(t)];
            case 1:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.selectAggregationTemporality = function(t) {
      return this._metricReader.selectAggregationTemporality(t);
    }, e.prototype.selectAggregation = function(t) {
      return this._metricReader.selectAggregation(t);
    }, e.prototype.selectCardinalityLimit = function(t) {
      var r, n, i;
      return (i = (n = (r = this._metricReader).selectCardinalityLimit) === null || n === void 0 ? void 0 : n.call(r, t)) !== null && i !== void 0 ? i : 2e3;
    }, e;
  }()
), fo = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, po = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, ho = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function bv(e, t) {
  var r = t != null ? t : Et.empty();
  return e ? Et.default().merge(r) : r;
}
var wv = (
  /** @class */
  function() {
    function e(t) {
      var r, n, i, o, a;
      if (this._shutdown = !1, this._sharedState = new mv(bv((a = t == null ? void 0 : t.mergeResourceWithDefaults) !== null && a !== void 0 ? a : !0, t == null ? void 0 : t.resource)), (t == null ? void 0 : t.views) != null && t.views.length > 0)
        try {
          for (var u = ho(t.views), c = u.next(); !c.done; c = u.next()) {
            var s = c.value;
            this._sharedState.viewRegistry.addView(s);
          }
        } catch (h) {
          r = { error: h };
        } finally {
          try {
            c && !c.done && (n = u.return) && n.call(u);
          } finally {
            if (r) throw r.error;
          }
        }
      if ((t == null ? void 0 : t.readers) != null && t.readers.length > 0)
        try {
          for (var l = ho(t.readers), f = l.next(); !f.done; f = l.next()) {
            var d = f.value;
            this.addMetricReader(d);
          }
        } catch (h) {
          i = { error: h };
        } finally {
          try {
            f && !f.done && (o = l.return) && o.call(l);
          } finally {
            if (i) throw i.error;
          }
        }
    }
    return e.prototype.getMeter = function(t, r, n) {
      return r === void 0 && (r = ""), n === void 0 && (n = {}), this._shutdown ? (g.warn("A shutdown MeterProvider cannot provide a Meter"), xc()) : this._sharedState.getMeterSharedState({
        name: t,
        version: r,
        schemaUrl: n.schemaUrl
      }).meter;
    }, e.prototype.addMetricReader = function(t) {
      var r = new Sv(this._sharedState, t);
      t.setMetricProducer(r), this._sharedState.metricCollectors.push(r);
    }, e.prototype.shutdown = function(t) {
      return fo(this, void 0, void 0, function() {
        return po(this, function(r) {
          switch (r.label) {
            case 0:
              return this._shutdown ? (g.warn("shutdown may only be called once per MeterProvider"), [
                2
                /*return*/
              ]) : (this._shutdown = !0, [4, Promise.all(this._sharedState.metricCollectors.map(function(n) {
                return n.shutdown(t);
              }))]);
            case 1:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.forceFlush = function(t) {
      return fo(this, void 0, void 0, function() {
        return po(this, function(r) {
          switch (r.label) {
            case 0:
              return this._shutdown ? (g.warn("invalid attempt to force flush after MeterProvider shutdown"), [
                2
                /*return*/
              ]) : [4, Promise.all(this._sharedState.metricCollectors.map(function(n) {
                return n.forceFlush(t);
              }))];
            case 1:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e;
  }()
);
function Av(e, t) {
  var r = Va(t);
  return {
    resource: $a(e.resource),
    schemaUrl: void 0,
    scopeMetrics: Ov(e.scopeMetrics, r)
  };
}
function Ov(e, t) {
  return Array.from(e.map(function(r) {
    return {
      scope: za(r.scope),
      metrics: r.metrics.map(function(n) {
        return Rv(n, t);
      }),
      schemaUrl: r.scope.schemaUrl
    };
  }));
}
function Rv(e, t) {
  var r = {
    name: e.descriptor.name,
    description: e.descriptor.description,
    unit: e.descriptor.unit
  }, n = Cv(e.aggregationTemporality);
  switch (e.dataPointType) {
    case ie.SUM:
      r.sum = {
        aggregationTemporality: n,
        isMonotonic: e.isMonotonic,
        dataPoints: _o(e, t)
      };
      break;
    case ie.GAUGE:
      r.gauge = {
        dataPoints: _o(e, t)
      };
      break;
    case ie.HISTOGRAM:
      r.histogram = {
        aggregationTemporality: n,
        dataPoints: Pv(e, t)
      };
      break;
    case ie.EXPONENTIAL_HISTOGRAM:
      r.exponentialHistogram = {
        aggregationTemporality: n,
        dataPoints: Nv(e, t)
      };
      break;
  }
  return r;
}
function Lv(e, t, r) {
  var n = {
    attributes: Ue(e.attributes),
    startTimeUnixNano: r.encodeHrTime(e.startTime),
    timeUnixNano: r.encodeHrTime(e.endTime)
  };
  switch (t) {
    case ge.INT:
      n.asInt = e.value;
      break;
    case ge.DOUBLE:
      n.asDouble = e.value;
      break;
  }
  return n;
}
function _o(e, t) {
  return e.dataPoints.map(function(r) {
    return Lv(r, e.descriptor.valueType, t);
  });
}
function Pv(e, t) {
  return e.dataPoints.map(function(r) {
    var n = r.value;
    return {
      attributes: Ue(r.attributes),
      bucketCounts: n.buckets.counts,
      explicitBounds: n.buckets.boundaries,
      count: n.count,
      sum: n.sum,
      min: n.min,
      max: n.max,
      startTimeUnixNano: t.encodeHrTime(r.startTime),
      timeUnixNano: t.encodeHrTime(r.endTime)
    };
  });
}
function Nv(e, t) {
  return e.dataPoints.map(function(r) {
    var n = r.value;
    return {
      attributes: Ue(r.attributes),
      count: n.count,
      min: n.min,
      max: n.max,
      sum: n.sum,
      positive: {
        offset: n.positive.offset,
        bucketCounts: n.positive.bucketCounts
      },
      negative: {
        offset: n.negative.offset,
        bucketCounts: n.negative.bucketCounts
      },
      scale: n.scale,
      zeroCount: n.zeroCount,
      startTimeUnixNano: t.encodeHrTime(r.startTime),
      timeUnixNano: t.encodeHrTime(r.endTime)
    };
  });
}
function Cv(e) {
  switch (e) {
    case Z.DELTA:
      return 1;
    case Z.CUMULATIVE:
      return 2;
  }
}
function Mv(e, t) {
  return {
    resourceMetrics: e.map(function(r) {
      return Av(r, t);
    })
  };
}
var Iv = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, xv = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function Dv(e, t) {
  var r, n = e.spanContext(), i = e.status;
  return {
    traceId: t.encodeSpanContext(n.traceId),
    spanId: t.encodeSpanContext(n.spanId),
    parentSpanId: t.encodeOptionalSpanContext(e.parentSpanId),
    traceState: (r = n.traceState) === null || r === void 0 ? void 0 : r.serialize(),
    name: e.name,
    // Span kind is offset by 1 because the API does not define a value for unset
    kind: e.kind == null ? 0 : e.kind + 1,
    startTimeUnixNano: t.encodeHrTime(e.startTime),
    endTimeUnixNano: t.encodeHrTime(e.endTime),
    attributes: Ue(e.attributes),
    droppedAttributesCount: e.droppedAttributesCount,
    events: e.events.map(function(o) {
      return Uv(o, t);
    }),
    droppedEventsCount: e.droppedEventsCount,
    status: {
      // API and proto enums share the same values
      code: i.code,
      message: i.message
    },
    links: e.links.map(function(o) {
      return kv(o, t);
    }),
    droppedLinksCount: e.droppedLinksCount
  };
}
function kv(e, t) {
  var r;
  return {
    attributes: e.attributes ? Ue(e.attributes) : [],
    spanId: t.encodeSpanContext(e.context.spanId),
    traceId: t.encodeSpanContext(e.context.traceId),
    traceState: (r = e.context.traceState) === null || r === void 0 ? void 0 : r.serialize(),
    droppedAttributesCount: e.droppedAttributesCount || 0
  };
}
function Uv(e, t) {
  return {
    attributes: e.attributes ? Ue(e.attributes) : [],
    name: e.name,
    timeUnixNano: t.encodeHrTime(e.time),
    droppedAttributesCount: e.droppedAttributesCount || 0
  };
}
function Bv(e, t) {
  var r = Va(t);
  return {
    resourceSpans: Gv(e, r)
  };
}
function Hv(e) {
  var t, r, n = /* @__PURE__ */ new Map();
  try {
    for (var i = Iv(e), o = i.next(); !o.done; o = i.next()) {
      var a = o.value, u = n.get(a.resource);
      u || (u = /* @__PURE__ */ new Map(), n.set(a.resource, u));
      var c = a.instrumentationLibrary.name + "@" + (a.instrumentationLibrary.version || "") + ":" + (a.instrumentationLibrary.schemaUrl || ""), s = u.get(c);
      s || (s = [], u.set(c, s)), s.push(a);
    }
  } catch (l) {
    t = { error: l };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return n;
}
function Gv(e, t) {
  for (var r = Hv(e), n = [], i = r.entries(), o = i.next(); !o.done; ) {
    for (var a = xv(o.value, 2), u = a[0], c = a[1], s = [], l = c.values(), f = l.next(); !f.done; ) {
      var d = f.value;
      if (d.length > 0) {
        var h = d.map(function(p) {
          return Dv(p, t);
        });
        s.push({
          scope: za(d[0].instrumentationLibrary),
          spans: h,
          schemaUrl: d[0].instrumentationLibrary.schemaUrl
        });
      }
      f = l.next();
    }
    var _ = {
      resource: $a(u),
      scopeSpans: s,
      schemaUrl: void 0
    };
    n.push(_), o = i.next();
  }
  return n;
}
var cs = {
  serializeRequest: function(e) {
    var t = Mv([e], {
      useLongBits: !1
    }), r = new TextEncoder();
    return r.encode(JSON.stringify(t));
  },
  deserializeResponse: function(e) {
    var t = new TextDecoder();
    return JSON.parse(t.decode(e));
  }
}, ls = {
  serializeRequest: function(e) {
    var t = Bv(e, {
      useHex: !0,
      useLongBits: !1
    }), r = new TextEncoder();
    return r.encode(JSON.stringify(t));
  },
  deserializeResponse: function(e) {
    var t = new TextDecoder();
    return JSON.parse(t.decode(e));
  }
}, Fv = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, jv = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Vv = 5, $v = 1e3, zv = 5e3, Xv = 1.5, vo = 0.2;
function qv() {
  return Math.random() * (2 * vo) - vo;
}
var Wv = (
  /** @class */
  function() {
    function e(t) {
      this._transport = t;
    }
    return e.prototype.retry = function(t, r, n) {
      var i = this;
      return new Promise(function(o, a) {
        setTimeout(function() {
          i._transport.send(t, r).then(o, a);
        }, n);
      });
    }, e.prototype.send = function(t, r) {
      var n;
      return Fv(this, void 0, void 0, function() {
        var i, o, a, u, c, s, l;
        return jv(this, function(f) {
          switch (f.label) {
            case 0:
              return i = Date.now() + r, [4, this._transport.send(t, r)];
            case 1:
              o = f.sent(), a = Vv, u = $v, f.label = 2;
            case 2:
              return o.status === "retryable" && a > 0 ? (a--, c = Math.max(Math.min(u, zv) + qv(), 0), u = u * Xv, s = (n = o.retryInMillis) !== null && n !== void 0 ? n : c, l = i - Date.now(), s > l ? [2, o] : [4, this.retry(t, l, s)]) : [3, 4];
            case 3:
              return o = f.sent(), [3, 2];
            case 4:
              return [2, o];
          }
        });
      });
    }, e.prototype.shutdown = function() {
      return this._transport.shutdown();
    }, e;
  }()
);
function fs(e) {
  return new Wv(e.transport);
}
function Kv(e) {
  var t = [429, 502, 503, 504];
  return t.includes(e);
}
function Yv(e) {
  if (e != null) {
    var t = Number.parseInt(e, 10);
    if (Number.isInteger(t))
      return t > 0 ? t * 1e3 : -1;
    var r = new Date(e).getTime() - Date.now();
    return r >= 0 ? r : 0;
  }
}
var Jv = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Zv = (
  /** @class */
  function() {
    function e(t) {
      this._parameters = t;
    }
    return e.prototype.send = function(t, r) {
      var n = this;
      return new Promise(function(i) {
        var o = new XMLHttpRequest();
        o.timeout = r, o.open("POST", n._parameters.url);
        var a = n._parameters.headers();
        Object.entries(a).forEach(function(u) {
          var c = Jv(u, 2), s = c[0], l = c[1];
          o.setRequestHeader(s, l);
        }), o.ontimeout = function(u) {
          i({
            status: "failure",
            error: new Error("XHR request timed out")
          });
        }, o.onreadystatechange = function() {
          o.status >= 200 && o.status <= 299 ? (g.debug("XHR success"), i({
            status: "success"
          })) : o.status && Kv(o.status) ? i({
            status: "retryable",
            retryInMillis: Yv(o.getResponseHeader("Retry-After"))
          }) : o.status !== 0 && i({
            status: "failure",
            error: new Error("XHR request failed with non-retryable status")
          });
        }, o.onabort = function() {
          i({
            status: "failure",
            error: new Error("XHR request aborted")
          });
        }, o.onerror = function() {
          i({
            status: "failure",
            error: new Error("XHR request errored")
          });
        }, o.send(t);
      });
    }, e.prototype.shutdown = function() {
    }, e;
  }()
);
function Qv(e) {
  return new Zv(e);
}
var ey = (
  /** @class */
  function() {
    function e(t) {
      this._params = t;
    }
    return e.prototype.send = function(t) {
      var r = this;
      return new Promise(function(n) {
        navigator.sendBeacon(r._params.url, new Blob([t], { type: r._params.blobType })) ? (g.debug("SendBeacon success"), n({
          status: "success"
        })) : n({
          status: "failure",
          error: new Error("SendBeacon failed")
        });
      });
    }, e.prototype.shutdown = function() {
    }, e;
  }()
);
function ty(e) {
  return new ey(e);
}
function ry(e, t) {
  return Ha(e, t, fs({
    transport: Qv(e)
  }));
}
function ny(e, t) {
  return Ha(e, t, fs({
    transport: ty({
      url: e.url,
      blobType: e.headers()["Content-Type"]
    })
  }));
}
var iy = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function oy(e) {
  return function() {
    var t, r = {};
    return Object.entries((t = e == null ? void 0 : e()) !== null && t !== void 0 ? t : {}).forEach(function(n) {
      var i = iy(n, 2), o = i[0], a = i[1];
      typeof a != "undefined" ? r[o] = String(a) : g.warn('Header "' + o + '" has invalid value (' + a + ") and will be ignored");
    }), r;
  };
}
var De = function() {
  return De = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, De.apply(this, arguments);
};
function ay(e, t, r) {
  var n = De({}, r()), i = {};
  return function() {
    return t != null && Object.assign(i, t()), e != null && Object.assign(i, e()), Object.assign(i, n);
  };
}
function sy(e) {
  if (e != null)
    try {
      return new URL(e), e;
    } catch (t) {
      throw new Error("Configuration: Could not parse user-provided export URL: '" + e + "'");
    }
}
function uy(e, t, r) {
  var n, i, o, a;
  return De(De({}, wh(e, t, r)), { headers: ay(oy(e.headers), t.headers, r.headers), url: (i = (n = sy(e.url)) !== null && n !== void 0 ? n : t.url) !== null && i !== void 0 ? i : r.url, agentOptions: (a = (o = e.agentOptions) !== null && o !== void 0 ? o : t.agentOptions) !== null && a !== void 0 ? a : r.agentOptions });
}
function cy(e, t) {
  return De(De({}, Ah()), { headers: function() {
    return e;
  }, url: "http://localhost:4318/" + t, agentOptions: { keepAlive: !0 } });
}
function ly(e, t, r) {
  return uy(
    {
      url: e.url,
      timeoutMillis: e.timeoutMillis,
      headers: bh(e.headers),
      concurrencyLimit: e.concurrencyLimit
    },
    {},
    // no fallback for browser case
    cy(r, t)
  );
}
function ds(e, t, r, n) {
  var i = !!e.headers || typeof navigator.sendBeacon != "function", o = ly(e, r, n);
  return i ? ry(o, t) : ny(o, t);
}
var fy = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), dy = (
  /** @class */
  function(e) {
    fy(t, e);
    function t(r) {
      return r === void 0 && (r = {}), e.call(this, ds(r, ls, "v1/traces", { "Content-Type": "application/json" })) || this;
    }
    return t;
  }(Ba)
), ur;
(function(e) {
  e[e.DELTA = 0] = "DELTA", e[e.CUMULATIVE = 1] = "CUMULATIVE", e[e.LOWMEMORY = 2] = "LOWMEMORY";
})(ur || (ur = {}));
var py = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Rn = function() {
  return Z.CUMULATIVE;
}, ps = function(e) {
  switch (e) {
    case S.COUNTER:
    case S.OBSERVABLE_COUNTER:
    case S.GAUGE:
    case S.HISTOGRAM:
    case S.OBSERVABLE_GAUGE:
      return Z.DELTA;
    case S.UP_DOWN_COUNTER:
    case S.OBSERVABLE_UP_DOWN_COUNTER:
      return Z.CUMULATIVE;
  }
}, hs = function(e) {
  switch (e) {
    case S.COUNTER:
    case S.HISTOGRAM:
      return Z.DELTA;
    case S.GAUGE:
    case S.UP_DOWN_COUNTER:
    case S.OBSERVABLE_UP_DOWN_COUNTER:
    case S.OBSERVABLE_COUNTER:
    case S.OBSERVABLE_GAUGE:
      return Z.CUMULATIVE;
  }
};
function hy() {
  var e = Je(), t = e.OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE.trim().toLowerCase();
  return t === "cumulative" ? Rn : t === "delta" ? ps : t === "lowmemory" ? hs : (g.warn("OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE is set to '" + e.OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE + "', but only 'cumulative' and 'delta' are allowed. Using default ('cumulative') instead."), Rn);
}
function _y(e) {
  return e != null ? e === ur.DELTA ? ps : e === ur.LOWMEMORY ? hs : Rn : hy();
}
function vy(e) {
  return e != null && e.aggregationPreference ? e.aggregationPreference : function(t) {
    return fe.Default();
  };
}
var yy = (
  /** @class */
  function(e) {
    py(t, e);
    function t(r, n) {
      var i = e.call(this, r) || this;
      return i._aggregationSelector = vy(n), i._aggregationTemporalitySelector = _y(n == null ? void 0 : n.temporalityPreference), i;
    }
    return t.prototype.selectAggregation = function(r) {
      return this._aggregationSelector(r);
    }, t.prototype.selectAggregationTemporality = function(r) {
      return this._aggregationTemporalitySelector(r);
    }, t;
  }(Ba)
), gy = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), my = (
  /** @class */
  function(e) {
    gy(t, e);
    function t(r) {
      return e.call(this, ds(r != null ? r : {}, cs, "v1/metrics", { "Content-Type": "application/json" }), r) || this;
    }
    return t;
  }(yy)
);
function Ey(e, t) {
  const r = e.spanContext();
  return {
    name: e.name,
    kind: e.kind,
    spanContext: () => r,
    parentSpanId: e.parentSpanId,
    startTime: e.startTime,
    endTime: e.endTime,
    status: e.status,
    attributes: pa(e.attributes, t),
    links: e.links,
    events: e.events,
    duration: e.duration,
    ended: e.ended,
    resource: e.resource,
    instrumentationLibrary: e.instrumentationLibrary,
    droppedAttributesCount: e.droppedAttributesCount,
    droppedEventsCount: e.droppedEventsCount,
    droppedLinksCount: e.droppedLinksCount
  };
}
function Ty(e, t) {
  if (!t.isSamplingEnabled())
    return e;
  const r = [], n = {}, i = {};
  for (const o of e) {
    o.parentSpanId && (i[o.parentSpanId] = i[o.parentSpanId] || [], i[o.parentSpanId].push(
      o.spanContext().spanId
    ));
    const a = t.shouldSample(o);
    a.sample ? a.attributes ? n[o.spanContext().spanId] = Ey(
      o,
      a.attributes
    ) : n[o.spanContext().spanId] = o : r.push(o.spanContext().spanId);
  }
  for (; r.length > 0; ) {
    const o = r.shift(), a = i[o];
    if (a)
      for (const u of a)
        delete n[u], r.push(u);
  }
  return Object.values(n);
}
const Sy = (e, t, r) => {
  if (typeof navigator == "undefined" || !navigator.sendBeacon)
    return !1;
  try {
    const n = new Blob([t], { type: r });
    return navigator.sendBeacon(e, n);
  } catch (n) {
    return !1;
  }
}, _s = (e, t, r, n) => {
  const i = (o) => {
    if (Sy(e, t, r))
      return n({ code: N.SUCCESS });
    n({ code: N.FAILED, error: o });
  };
  try {
    const o = new Blob([t], { type: r });
    fetch(e, {
      method: "POST",
      body: o,
      keepalive: !0,
      headers: { "Content-Type": r },
      credentials: "omit"
    }).then(
      (a) => {
        if (a.ok)
          return n({ code: N.SUCCESS });
        n({
          code: N.FAILED,
          error: new Error(
            `keepalive fetch export failed with status ${a.status}`
          )
        });
      },
      // Promise rejection path: keepalive body-size overflow, network
      // error, CORS preflight failure, etc. This is where keepalive's
      // ~64KiB overflow lands — per WHATWG Fetch §4.6 it's an async
      // network error, not a synchronous throw.
      (a) => i(a)
    );
  } catch (o) {
    i(o);
  }
};
class by extends dy {
  constructor(r, n) {
    var i;
    super(x(E({}, r), {
      headers: {}
      // a truthy value enables sending with XHR instead of beacon
    }));
    b(this, "url");
    b(this, "unloading", !1);
    this.sampler = n, this.url = (i = r == null ? void 0 : r.url) != null ? i : "";
  }
  setUnloading(r) {
    this.unloading = r;
  }
  export(r, n) {
    const i = Ty(r, this.sampler);
    if (i.length === 0)
      return n({ code: N.SUCCESS });
    if (this.unloading) {
      const u = ls.serializeRequest(i);
      if (!u || !this.url)
        return n({
          code: N.FAILED,
          error: new Error(
            "keepalive export failed: serializer returned empty or url missing"
          )
        });
      _s(
        this.url,
        u,
        "application/json",
        n
      );
      return;
    }
    let o = 0;
    const a = (u) => {
      if (u.code === N.SUCCESS)
        return n({
          code: N.SUCCESS
        });
      if (o++, o > ko)
        return n({
          code: N.FAILED,
          error: u.error
        });
      new Promise(
        (c) => setTimeout(
          c,
          Uo + Bo * Math.pow(2, o)
        )
      ).then(() => {
        super.export(i, a);
      });
    };
    super.export(i, a);
  }
}
class wy extends my {
  constructor(r) {
    var n;
    super(x(E({}, r), {
      headers: {}
    }));
    b(this, "url");
    b(this, "unloading", !1);
    this.url = (n = r == null ? void 0 : r.url) != null ? n : "";
  }
  setUnloading(r) {
    this.unloading = r;
  }
  export(r, n) {
    if (this.unloading) {
      const a = cs.serializeRequest(r);
      if (!a || !this.url)
        return n({
          code: N.FAILED,
          error: new Error(
            "keepalive export failed: serializer returned empty or url missing"
          )
        });
      _s(
        this.url,
        a,
        "application/json",
        n
      );
      return;
    }
    let i = 0;
    const o = (a) => {
      var u;
      if (a.code === N.SUCCESS)
        return n({
          code: N.SUCCESS
        });
      if (i++, i > ko)
        return j(
          "error",
          `[@launchdarkly/observability] failed to export OTeL metrics: ${(u = a.error) == null ? void 0 : u.message}`,
          a.error
        ), n({
          code: N.FAILED,
          error: a.error
        });
      new Promise(
        (c) => setTimeout(
          c,
          Uo + Bo * Math.pow(2, i)
        )
      ).then(() => {
        var c;
        j(
          "warn",
          `[@launchdarkly/observability] retry ${i}, failed to export OTeL metrics: ${(c = a.error) == null ? void 0 : c.message}`,
          a.error
        ), super.export(r, o);
      });
    };
    super.export(r, o);
  }
}
const Ay = "OT_ZONE_CONTEXT", Oy = "Navigation:";
function Ry() {
  return !1;
}
const ee = class ee extends Lt {
  constructor(r = {}) {
    var n, i;
    super(
      ee.moduleName,
      ee.version,
      r
    );
    b(this, "_spansData", /* @__PURE__ */ new WeakMap());
    b(this, "_zonePatched");
    // for addEventListener/removeEventListener state
    b(this, "_wrappedListeners", /* @__PURE__ */ new WeakMap());
    // for event bubbling
    b(this, "_eventsSpanMap", /* @__PURE__ */ new WeakMap());
    b(this, "_eventNames");
    b(this, "_shouldPreventSpanCreation");
    b(this, "_getLDContextKeyAttributes");
    this._getLDContextKeyAttributes = r.getLDContextKeyAttributes, this._eventNames = new Set((n = r == null ? void 0 : r.eventNames) != null ? n : []), ((i = r.productAnalyticsEvents) == null ? void 0 : i.clicks) !== !1 && this._eventNames.add("click"), this._shouldPreventSpanCreation = typeof (r == null ? void 0 : r.shouldPreventSpanCreation) == "function" ? r.shouldPreventSpanCreation : Ry;
  }
  init() {
  }
  /**
   * This will check if last task was timeout and will save the time to
   * fix the user interaction when nothing happens
   * This timeout comes from xhr plugin which is needed to collect information
   * about last xhr main request from observer
   * @param task
   * @param span
   */
  _checkForTimeout(r, n) {
    const i = this._spansData.get(n);
    i && (r.source === "setTimeout" ? i.hrTimeLastTimeout = Ie() : r.source !== "Promise.then" && r.source !== "setTimeout" && (i.hrTimeLastTimeout = void 0));
  }
  /**
   * Controls whether or not to create a span, based on the event type.
   */
  _allowEventName(r) {
    return this._eventNames.has(r);
  }
  /**
   * Creates a new span
   * @param event
   * @param parentSpan
   */
  _createSpan(r, n) {
    var u, c;
    const i = r == null ? void 0 : r.target, o = r == null ? void 0 : r.type;
    if (!(i instanceof HTMLElement) || !i.getAttribute || i.hasAttribute("disabled") || !this._allowEventName(o))
      return;
    const a = Pa(i, !0);
    try {
      const s = this.tracer.startSpan(
        o,
        {
          attributes: {
            [ye]: window.location.href,
            "event.type": o,
            "event.tag": i.tagName,
            "event.xpath": a,
            "event.id": i.id,
            "event.classname": i.className,
            "event.text": (u = i.textContent) != null ? u : "",
            "event.url": window.location.href,
            "viewport.width": window.innerWidth,
            "viewport.height": window.innerHeight
          }
        },
        n ? L.setSpan(O.active(), n) : void 0
      );
      r instanceof MouseEvent && (s.setAttribute("event.x", r.clientX), s.setAttribute("event.y", r.clientY), s.setAttribute(
        "event.relativeX",
        r.clientX / window.innerWidth
      ), s.setAttribute(
        "event.relativeY",
        r.clientY / window.innerHeight
      ), o === "scroll" && (s.setAttribute("event.scrollX", window.scrollX), s.setAttribute("event.scrollY", window.scrollY)));
      const l = (c = this._getLDContextKeyAttributes) == null ? void 0 : c.call(this);
      return l && s.setAttributes(l), this._shouldPreventSpanCreation(o, i, s) === !0 ? void 0 : (this._spansData.set(s, {
        taskCount: 0
      }), s);
    } catch (s) {
      this._diag.error(
        "failed to start create new user interaction span",
        s
      );
    }
  }
  /**
   * Decrement number of tasks that left in zone,
   * This is needed to be able to end span when no more tasks left
   * @param span
   */
  _decrementTask(r) {
    const n = this._spansData.get(r);
    n && (n.taskCount--, n.taskCount === 0 && this._tryToEndSpan(r, n.hrTimeLastTimeout));
  }
  /**
   * Return the current span
   * @param zone
   * @private
   */
  _getCurrentSpan(r) {
    const n = r.get(Ay);
    return n && L.getSpan(n);
  }
  /**
   * Increment number of tasks that are run within the same zone.
   *     This is needed to be able to end span when no more tasks left
   * @param span
   */
  _incrementTask(r) {
    const n = this._spansData.get(r);
    n && n.taskCount++;
  }
  /**
   * Returns true iff we should use the patched callback; false if it's already been patched
   */
  addPatchedListener(r, n, i, o) {
    let a = this._wrappedListeners.get(i);
    a || (a = /* @__PURE__ */ new Map(), this._wrappedListeners.set(i, a));
    let u = a.get(n);
    return u || (u = /* @__PURE__ */ new Map(), a.set(n, u)), u.has(r) ? !1 : (u.set(r, o), !0);
  }
  /**
   * Returns the patched version of the callback (or undefined)
   */
  removePatchedListener(r, n, i) {
    const o = this._wrappedListeners.get(i);
    if (!o)
      return;
    const a = o.get(n);
    if (!a)
      return;
    const u = a.get(r);
    return u && (a.delete(r), a.size === 0 && (o.delete(n), o.size === 0 && this._wrappedListeners.delete(i))), u;
  }
  // utility method to deal with the Function|EventListener nature of addEventListener
  _invokeListener(r, n, i) {
    return typeof r == "function" ? r.apply(n, i) : r.handleEvent(i[0]);
  }
  /**
   * This patches the addEventListener of HTMLElement to be able to
   * auto instrument the click events
   * This is done when zone is not available
   */
  _patchAddEventListener() {
    const r = this;
    let n = /* @__PURE__ */ new Map();
    return (i) => function(a, u, c) {
      if (!u)
        return i.call(this, a, u, c);
      const s = c && typeof c == "object" && c.once, l = function(...f) {
        var p;
        let d;
        const h = f[0];
        if (!(h != null && h.type))
          return r._invokeListener(u, this, f);
        if (Date.now() - ((p = n.get(h.type)) != null ? p : 0) < 1e3 / 60)
          return r._invokeListener(u, this, f);
        n.set(h.type, Date.now()), h && (d = r._eventsSpanMap.get(h)), s && r.removePatchedListener(this, a, u);
        const _ = r._createSpan(h, d);
        return _ ? (h && r._eventsSpanMap.set(h, _), O.with(
          L.setSpan(O.active(), _),
          () => {
            const v = r._invokeListener(
              u,
              this,
              f
            );
            return _.end(), v;
          }
        )) : r._invokeListener(u, this, f);
      };
      if (r.addPatchedListener(
        this,
        a,
        u,
        l
      ))
        return i.call(
          this,
          a,
          l,
          c
        );
    };
  }
  /**
   * This patches the removeEventListener of HTMLElement to handle the fact that
   * we patched the original callbacks
   * This is done when zone is not available
   */
  _patchRemoveEventListener() {
    const r = this;
    return (n) => function(o, a, u) {
      const c = r.removePatchedListener(
        this,
        o,
        a
      );
      return c ? n.call(
        this,
        o,
        c,
        u
      ) : n.call(this, o, a, u);
    };
  }
  /**
   * Most browser provide event listener api via EventTarget in prototype chain.
   * Exception to this is IE 11 which has it on the prototypes closest to EventTarget:
   *
   * * - has addEventListener in IE
   * ** - has addEventListener in all other browsers
   * ! - missing in IE
   *
   * HTMLElement -> Element -> Node * -> EventTarget **! -> Object
   * Document -> Node * -> EventTarget **! -> Object
   * Window * -> WindowProperties ! -> EventTarget **! -> Object
   */
  _getPatchableEventTargets() {
    return window.EventTarget ? [EventTarget.prototype] : [Node.prototype, Window.prototype];
  }
  /**
   * Patches the history api
   */
  _patchHistoryApi() {
    this._unpatchHistoryApi(), this._wrap(history, "replaceState", this._patchHistoryMethod()), this._wrap(history, "pushState", this._patchHistoryMethod()), this._wrap(history, "back", this._patchHistoryMethod()), this._wrap(history, "forward", this._patchHistoryMethod()), this._wrap(history, "go", this._patchHistoryMethod());
  }
  /**
   * Patches the certain history api method
   */
  _patchHistoryMethod() {
    const r = this;
    return (n) => function(...o) {
      const a = `${location.pathname}${location.hash}${location.search}`, u = n.apply(this, o), c = `${location.pathname}${location.hash}${location.search}`;
      return a !== c && r._updateInteractionName(c), u;
    };
  }
  /**
   * unpatch the history api methods
   */
  _unpatchHistoryApi() {
    D(history.replaceState) && this._unwrap(history, "replaceState"), D(history.pushState) && this._unwrap(history, "pushState"), D(history.back) && this._unwrap(history, "back"), D(history.forward) && this._unwrap(history, "forward"), D(history.go) && this._unwrap(history, "go");
  }
  /**
   * Updates interaction span name
   * @param url
   */
  _updateInteractionName(r) {
    const n = L.getSpan(
      O.active()
    );
    n && typeof n.updateName == "function" && n.updateName(`${Oy} ${r}`);
  }
  /**
   * Patches zone cancel task - this is done to be able to correctly
   * decrement the number of remaining tasks
   */
  _patchZoneCancelTask() {
    const r = this;
    return (n) => function(o) {
      const a = Zone.current, u = r._getCurrentSpan(a);
      return u && r._shouldCountTask(o, a) && r._decrementTask(u), n.call(this, o);
    };
  }
  /**
   * Patches zone schedule task - this is done to be able to correctly
   * increment the number of tasks running within current zone but also to
   * save time in case of timeout running from xhr plugin when waiting for
   * main request from PerformanceResourceTiming
   */
  _patchZoneScheduleTask() {
    const r = this;
    return (n) => function(o) {
      const a = Zone.current, u = r._getCurrentSpan(a);
      return u && r._shouldCountTask(o, a) && (r._incrementTask(u), r._checkForTimeout(o, u)), n.call(this, o);
    };
  }
  /**
   * Patches zone run task - this is done to be able to create a span when
   * user interaction starts
   * @private
   */
  _patchZoneRunTask() {
    const r = this;
    return (n) => function(o, a, u) {
      const c = Array.isArray(u) && u[0] instanceof Event ? u[0] : void 0, s = c == null ? void 0 : c.target;
      let l;
      const f = this;
      if (s) {
        if (l = r._createSpan(c), l)
          return r._incrementTask(l), f.run(() => {
            try {
              return O.with(
                L.setSpan(
                  O.active(),
                  l
                ),
                () => {
                  const d = Zone.current;
                  return o._zone = d, n.call(
                    d,
                    o,
                    a,
                    u
                  );
                }
              );
            } finally {
              r._decrementTask(l);
            }
          });
      } else
        l = r._getCurrentSpan(f);
      try {
        return n.call(f, o, a, u);
      } finally {
        l && r._shouldCountTask(o, f) && r._decrementTask(l);
      }
    };
  }
  /**
   * Decides if task should be counted.
   * @param task
   * @param currentZone
   * @private
   */
  _shouldCountTask(r, n) {
    if (r._zone && (n = r._zone), !n || !r.data || r.data.isPeriodic)
      return !1;
    const i = this._getCurrentSpan(n);
    return !i || !this._spansData.get(i) ? !1 : r.type === "macroTask" || r.type === "microTask";
  }
  /**
   * Will try to end span when such span still exists.
   * @param span
   * @param endTime
   * @private
   */
  _tryToEndSpan(r, n) {
    r && this._spansData.get(r) && (r.end(n), this._spansData.delete(r));
  }
  /**
   * implements enable function
   */
  enable() {
    const r = this._getZoneWithPrototype();
    this._diag.debug(
      "applying patch to",
      ee.moduleName,
      ee.version,
      "zone:",
      !!r
    ), r ? (D(r.prototype.runTask) && (this._unwrap(r.prototype, "runTask"), this._diag.debug("removing previous patch from method runTask")), D(r.prototype.scheduleTask) && (this._unwrap(r.prototype, "scheduleTask"), this._diag.debug(
      "removing previous patch from method scheduleTask"
    )), D(r.prototype.cancelTask) && (this._unwrap(r.prototype, "cancelTask"), this._diag.debug(
      "removing previous patch from method cancelTask"
    )), this._zonePatched = !0, this._wrap(
      r.prototype,
      "runTask",
      this._patchZoneRunTask()
    ), this._wrap(
      r.prototype,
      "scheduleTask",
      this._patchZoneScheduleTask()
    ), this._wrap(
      r.prototype,
      "cancelTask",
      this._patchZoneCancelTask()
    )) : (this._zonePatched = !1, this._getPatchableEventTargets().forEach((i) => {
      D(i.addEventListener) && (this._unwrap(i, "addEventListener"), this._diag.debug(
        "removing previous patch from method addEventListener"
      )), D(i.removeEventListener) && (this._unwrap(i, "removeEventListener"), this._diag.debug(
        "removing previous patch from method removeEventListener"
      )), this._wrap(
        i,
        "addEventListener",
        this._patchAddEventListener()
      ), this._wrap(
        i,
        "removeEventListener",
        this._patchRemoveEventListener()
      );
    })), this._patchHistoryApi();
  }
  /**
   * implements unpatch function
   */
  disable() {
    const r = this._getZoneWithPrototype();
    this._diag.debug(
      "removing patch from",
      ee.moduleName,
      ee.version,
      "zone:",
      !!r
    ), r && this._zonePatched ? (D(r.prototype.runTask) && this._unwrap(r.prototype, "runTask"), D(r.prototype.scheduleTask) && this._unwrap(r.prototype, "scheduleTask"), D(r.prototype.cancelTask) && this._unwrap(r.prototype, "cancelTask")) : this._getPatchableEventTargets().forEach((i) => {
      D(i.addEventListener) && this._unwrap(i, "addEventListener"), D(i.removeEventListener) && this._unwrap(i, "removeEventListener");
    }), this._unpatchHistoryApi();
  }
  /**
   * returns Zone
   */
  _getZoneWithPrototype() {
    return window.Zone;
  }
};
b(ee, "version", "0.1.1"), b(ee, "moduleName", "user-interaction");
let Ln = ee;
const Ly = (e) => {
  if (typeof XMLHttpRequest == "undefined")
    return () => {
    };
  const t = XMLHttpRequest.prototype, r = t.open, n = t.setRequestHeader, i = t.send, o = (s) => !!s && e.some(
    (l) => s.toLowerCase().includes(l)
  ), a = function(s, l) {
    return this._method = s, this._url = typeof l == "string" ? l : String(l), this._requestHeaders = {}, this._body = void 0, r.apply(this, arguments);
  }, u = function(s, l) {
    return this._requestHeaders || (this._requestHeaders = {}), this._requestHeaders[s] = l, n.apply(this, arguments);
  }, c = function(s) {
    if (this._body === void 0 && s !== void 0 && s !== null && !o(this._url)) {
      const l = Sn(s, this._url);
      l && (this._body = l);
    }
    return i.apply(this, arguments);
  };
  return t.open = a, t.setRequestHeader = u, t.send = c, () => {
    t.open === a && (t.open = r), t.setRequestHeader === u && (t.setRequestHeader = n), t.send === c && (t.send = i);
  };
}, Py = 256 * 1024, Ny = (e) => !!e && e.split(";")[0].trim().toLowerCase() === "multipart/form-data", vs = (e) => {
  if (!e || typeof e != "object")
    return {};
  if (typeof Headers != "undefined" && e instanceof Headers)
    return Object.fromEntries(e.entries());
  if (Array.isArray(e))
    try {
      return Object.fromEntries(new Headers(e).entries());
    } catch (t) {
      return Object.fromEntries(
        e.map(([r, n]) => [String(r), String(n)])
      );
    }
  return E({}, e);
}, cr = (e) => Object.prototype.toString.call(e), Cy = (e) => typeof ArrayBuffer != "undefined" && e instanceof ArrayBuffer || cr(e) === "[object ArrayBuffer]" || cr(e) === "[object SharedArrayBuffer]", ys = (e) => {
  if (typeof File != "undefined" && e instanceof File || cr(e) === "[object File]") {
    const t = e;
    return `[File name="${t.name}" type="${t.type}" size=${t.size}]`;
  }
  return `[Blob type="${e.type}" size=${e.size}]`;
}, Pn = (e, t, r) => {
  const n = e[t];
  n === void 0 ? e[t] = r : Array.isArray(n) ? n.push(r) : e[t] = [n, r];
}, My = (e) => {
  const t = {};
  return e.forEach((r, n) => {
    Pn(
      t,
      n,
      typeof r == "string" ? r : ys(r)
    );
  }), JSON.stringify(t);
}, Iy = (e) => {
  const t = ArrayBuffer.isView(e) ? new Uint8Array(e.buffer, e.byteOffset, e.byteLength) : new Uint8Array(e);
  if (t.byteLength > Py)
    return `[binary size=${t.byteLength}]`;
  try {
    return new TextDecoder("utf-8", { fatal: !0 }).decode(t);
  } catch (r) {
    return `[binary size=${t.byteLength}]`;
  }
}, gs = (e) => {
  if (e == null)
    return;
  switch (typeof e) {
    case "string":
      return e;
    case "number":
    case "boolean":
    case "bigint":
      return String(e);
    case "object":
      break;
    default:
      return;
  }
  const t = cr(e);
  if (typeof URLSearchParams != "undefined" && e instanceof URLSearchParams || t === "[object URLSearchParams]")
    return e.toString();
  if (typeof FormData != "undefined" && e instanceof FormData || t === "[object FormData]")
    return My(e);
  if (typeof Blob != "undefined" && e instanceof Blob || t === "[object Blob]" || t === "[object File]")
    return ys(e);
  if (Cy(e) || ArrayBuffer.isView(e))
    return Iy(e);
  if (!(typeof ReadableStream != "undefined" && e instanceof ReadableStream || t === "[object ReadableStream]")) {
    if (typeof Document != "undefined" && e instanceof Document)
      try {
        return new XMLSerializer().serializeToString(e);
      } catch (r) {
        return;
      }
    try {
      return Ye(e);
    } catch (r) {
      return;
    }
  }
}, Nn = /* @__PURE__ */ new WeakMap(), xy = (e) => Nn.get(e), Dy = (e, t) => U(void 0, null, function* () {
  const r = e.getReader(), n = [];
  let i = 0;
  for (; i < t; ) {
    const { done: o, value: a } = yield r.read();
    if (o)
      return { chunks: n, byteLength: i, truncated: !1 };
    const u = t - i, c = a.byteLength > u ? a.subarray(0, u) : a;
    n.push(c), i += c.byteLength;
  }
  return r.cancel().catch(() => {
  }), { chunks: n, byteLength: i, truncated: !0 };
}), ky = ({ chunks: e, byteLength: t }) => {
  const r = new Uint8Array(t);
  let n = 0;
  for (const i of e)
    r.set(i, n), n += i.byteLength;
  return r;
}, Uy = (e) => {
  const t = new TextDecoder("utf-8", { fatal: !0 });
  try {
    let r = "";
    for (const n of e.chunks)
      r += t.decode(n, { stream: !0 });
    return e.truncated ? r : r + t.decode();
  } catch (r) {
    return `[binary size${e.truncated ? ">" : "="}${e.byteLength}]`;
  }
}, jt = (e) => `[multipart/form-data size${e.truncated ? ">" : "="}${e.byteLength}]`, By = (e, t) => {
  var i, o, a, u, c, s, l;
  const r = /;\s*boundary=(?:"([^"]*)"|([^;]*))/i.exec(
    t
  ), n = (o = (i = r == null ? void 0 : r[1]) != null ? i : r == null ? void 0 : r[2]) == null ? void 0 : o.trim();
  if (!n)
    return jt(e);
  try {
    const f = ky(e), d = new TextDecoder("windows-1252").decode(f), h = `--${n}`, _ = {};
    let p = d.indexOf(h);
    if (p === -1)
      return jt(e);
    for (; p !== -1 && (p += h.length, !d.startsWith("--", p)); ) {
      const v = d.indexOf(`\r
`, p), y = v === -1 ? -1 : d.indexOf(`\r
\r
`, v);
      if (y === -1)
        break;
      const m = new TextDecoder().decode(
        f.subarray(v + 2, y)
      ), w = y + 4, A = d.indexOf(`\r
${h}`, w), R = A === -1, C = R ? d.length : A, I = (a = /\bname="([^"]*)"/i.exec(m)) == null ? void 0 : a[1];
      if (I !== void 0) {
        const P = (u = /\bfilename="([^"]*)"/i.exec(m)) == null ? void 0 : u[1];
        if (P !== void 0) {
          const V = (l = (s = (c = /^content-type:[ \t]*(.*)$/im.exec(m)) == null ? void 0 : c[1]) == null ? void 0 : s.trim()) != null ? l : "", Q = C - w;
          Pn(
            _,
            I,
            `[File name="${P}" type="${V}" size${R ? ">=" : "="}${Q}]`
          );
        } else
          Pn(
            _,
            I,
            new TextDecoder().decode(
              f.subarray(w, C)
            )
          );
      }
      p = R ? -1 : A + 2;
    }
    return e.truncated && Object.keys(_).length === 0 ? jt(e) : JSON.stringify(_);
  } catch (f) {
    return jt(e);
  }
}, Hy = (e, t) => {
  try {
    if (t && t.body !== void 0 && t.body !== null)
      return Promise.resolve(gs(t.body));
    if (!e.body || e.bodyUsed)
      return Promise.resolve(void 0);
    const r = e.clone();
    if (!r.body)
      return Promise.resolve(void 0);
    const n = e.headers.get("content-type");
    return Dy(r.body, qn(e.headers)).then(
      (i) => Ny(n) ? By(i, n) : Uy(i)
    ).catch(() => {
    });
  } catch (r) {
    return Promise.resolve(void 0);
  }
}, Gy = (e = []) => {
  if (typeof window == "undefined" || typeof window.fetch != "function" || typeof Request == "undefined")
    return () => {
    };
  const t = (i) => e.some(
    (o) => i.toLowerCase().includes(o)
  ), r = window.fetch, n = function(i, o) {
    return i instanceof Request && !Nn.has(i) && !t(i.url) && Nn.set(i, Hy(i, o)), r.call(this != null ? this : window, i, o);
  };
  return window.fetch = n, () => {
    window.fetch === n && (window.fetch = r);
  };
}, qe = class qe extends Lt {
  constructor(r = {}) {
    super(
      qe.moduleName,
      qe.version,
      r
    );
    b(this, "_getLDContextKeyAttributes");
    b(this, "_unlisten");
    b(this, "_lastUrl", "");
    this._getLDContextKeyAttributes = r.getLDContextKeyAttributes;
  }
  init() {
  }
  enable() {
    this._lastUrl = window.location.href, this._unlisten = Xs((r) => {
      var i;
      const n = this._lastUrl;
      if (this._lastUrl = r, n !== r)
        try {
          const o = this.tracer.startSpan(qs, {
            attributes: {
              [ye]: r,
              "page_view.previous_url": n,
              "page_view.url": r
            }
          }), a = (i = this._getLDContextKeyAttributes) == null ? void 0 : i.call(this);
          a && o.setAttributes(a), o.end();
        } catch (o) {
          this._diag.error("failed to create page view span", o);
        }
    });
  }
  disable() {
    var r;
    (r = this._unlisten) == null || r.call(this), this._unlisten = void 0;
  }
};
b(qe, "version", "0.1.0"), b(qe, "moduleName", "location-change");
let Cn = qe, B = {}, ae, Zt, Le, Pe;
const Ce = "highlight.record", Fy = "highlight.session_id", lr = /* @__PURE__ */ new Map(), Mn = (e) => `${e.spanContext().traceId}:${e.spanContext().spanId}`, ms = "launchdarkly.js.log", jy = "launchdarkly.exception.id", yo = "launchdarkly.sampling.ratio", Es = "log.severity", Ts = "log.message", Vy = (e, t) => {
  var v, y, m, w, A, R, C, I, P, V, Q, ei, ti, ri;
  if (B.tracerProvider || B.meterProvider) {
    j("warn", "OTEL already initialized. Skipping...");
    return;
  }
  ae = e, Ru() && g.setLogger(
    {
      verbose: (...F) => j("debug", ...F),
      debug: (...F) => j("debug", ...F),
      info: (...F) => j("info", ...F),
      warn: (...F) => j("warn", ...F),
      error: (...F) => j("error", ...F)
    },
    M.WARN
  );
  const r = e.backendUrl || void 0 || "https://pub.highlight.io", n = [
    ...(y = (v = e.networkRecordingOptions) == null ? void 0 : v.urlBlocklist) != null ? y : [],
    ...xu
  ], i = [r, e.otlpEndpoint].filter((F) => !!F).map((F) => F.toLowerCase()), o = (m = e.environment) != null ? m : "production", a = {
    url: e.otlpEndpoint + "/v1/traces",
    concurrencyLimit: 10,
    timeoutMillis: 3e4,
    // Using any because we were getting an error importing CompressionAlgorithm
    // from @opentelemetry/otlp-exporter-base.
    compression: "gzip",
    keepAlive: !0,
    httpAgentOptions: {
      timeout: 6e4,
      keepAlive: !0
    }
  }, u = new by(
    a,
    t
  ), c = new fr(u, {
    maxExportBatchSize: 1024,
    // Default value from SDK is 512
    maxQueueSize: 2048,
    // Default value from SDK is 2048
    exportTimeoutMillis: a.timeoutMillis,
    // Default value from SDK is 30_000
    scheduledDelayMillis: 5e3
    // OTEL default; shorter window reduces data lost to page unload
  }), s = new Et({
    [Js]: (w = e.serviceName) != null ? w : "highlight-browser",
    [Ys]: e.serviceVersion,
    "deployment.environment.name": o,
    "highlight.project_id": e.projectId,
    [Ks]: navigator.userAgent,
    "browser.language": navigator.language,
    "telemetry.distro.name": "@highlight-run/observability",
    "telemetry.distro.version": Ws
  });
  B.tracerProvider = new Md({
    resource: s,
    mergeResourceWithDefaults: !0,
    spanProcessors: [c]
  }), L.setGlobalTracerProvider(B.tracerProvider);
  const l = new wy(x(E({}, a), {
    url: e.otlpEndpoint + "/v1/metrics"
  })), f = new B_({
    exporter: l,
    exportIntervalMillis: a.timeoutMillis,
    exportTimeoutMillis: a.timeoutMillis
  });
  B.meterProvider = new wv({ resource: s, readers: [f] }), Hn.setGlobalMeterProvider(B.meterProvider);
  let d = [];
  if (((A = e.instrumentations) == null ? void 0 : A["@opentelemetry/instrumentation-document-load"]) !== !1 && d.push(
    new tp({
      applyCustomAttributesOnSpan: {
        documentLoad: To,
        documentFetch: To,
        resourceFetch: rg
      }
    })
  ), ((R = e.instrumentations) == null ? void 0 : R["@opentelemetry/instrumentation-user-interaction"]) !== !1 && d.push(
    new Ln({
      productAnalyticsEvents: e.productAnalyticsEvents,
      getLDContextKeyAttributes: e.getLDContextKeyAttributes
    })
  ), ((C = e.productAnalyticsEvents) == null ? void 0 : C.pageViews) !== !1 && d.push(
    new Cn({
      getLDContextKeyAttributes: e.getLDContextKeyAttributes
    })
  ), (I = e.networkRecordingOptions) != null && I.enabled) {
    if (((P = e.instrumentations) == null ? void 0 : P["@opentelemetry/instrumentation-fetch"]) !== !1) {
      const Te = new Pp({
        propagateTraceHeaderCorsUrls: So(
          e.tracingOrigins
        ),
        applyCustomAttributesOnSpan: (H, de, Fe) => {
          var Nt;
          if (!H.attributes)
            return;
          const rt = H;
          if (rt.attributes[Ce] === !1)
            return;
          const nt = typeof Request != "undefined" && de instanceof Request, it = nt ? xy(de) : void 0;
          mo(
            H,
            nt ? void 0 : de.body,
            de.headers,
            e.networkRecordingOptions
          );
          const ot = () => U(void 0, null, function* () {
            const be = yield it;
            be !== void 0 && Ky(
              H,
              be,
              de.headers,
              e.networkRecordingOptions
            );
          }), Se = () => {
            var be;
            return (be = e.networkRecordingOptions) != null && be.requestResponseSanitizer && Eo(
              H,
              e.networkRecordingOptions.requestResponseSanitizer
            ), rt.attributes[Ce] !== !1;
          };
          if (!(Fe instanceof Response)) {
            if (H.setAttributes({
              "http.response.error": Fe.message,
              [Ho]: Fe.status
            }), !Se())
              return;
            it && lr.set(
              Mn(H),
              ot().then(() => {
                Se();
              })
            );
            return;
          }
          if (Se() && (Nt = e.networkRecordingOptions) != null && Nt.recordHeadersAndBody) {
            const be = U(void 0, null, function* () {
              var ni, ii, oi, ai, si;
              yield ot();
              const Ds = yield Ua(
                Fe,
                (ni = e.networkRecordingOptions) == null ? void 0 : ni.bodyKeysToRecord,
                (ii = e.networkRecordingOptions) == null ? void 0 : ii.networkBodyKeysToRedact
              ), ks = Object.fromEntries(
                Fe.headers.entries()
              ), Us = _r(
                (ai = (oi = e.networkRecordingOptions) == null ? void 0 : oi.networkHeadersToRedact) != null ? ai : [],
                ks,
                (si = e.networkRecordingOptions) == null ? void 0 : si.headerKeysToRecord
              ), Bs = Yn(
                Us,
                "http.response.header"
              );
              Object.assign(
                H.attributes,
                E({
                  "http.response.body": Ds
                }, Bs)
              ), Se();
            });
            lr.set(Mn(H), be);
          }
        }
      });
      d.push(Te);
    }
    ((V = e.instrumentations) == null ? void 0 : V["@opentelemetry/instrumentation-xml-http-request"]) !== !1 && d.push(
      new Zp({
        propagateTraceHeaderCorsUrls: So(
          e.tracingOrigins
        ),
        applyCustomAttributesOnSpan: (Te, H) => {
          var rt, nt, it, ot;
          const de = H;
          if (!(!Te.attributes || Te.attributes[Ce] === !1)) {
            if (mo(
              Te,
              de._body,
              de._requestHeaders,
              e.networkRecordingOptions
            ), (rt = e.networkRecordingOptions) != null && rt.recordHeadersAndBody) {
              let Se = "";
              (H.responseType === "" || H.responseType === "text") && (Se = ne(
                H.responseText,
                (nt = e.networkRecordingOptions) == null ? void 0 : nt.networkBodyKeysToRedact,
                (it = e.networkRecordingOptions) == null ? void 0 : it.bodyKeysToRecord,
                void 0
              ));
              const Nt = Yy(
                H.getAllResponseHeaders()
              );
              eg(
                Te,
                Nt,
                Se,
                e.networkRecordingOptions
              );
            }
            (ot = e.networkRecordingOptions) != null && ot.requestResponseSanitizer && Eo(
              Te,
              e.networkRecordingOptions.requestResponseSanitizer
            );
          }
        }
      })
    );
  }
  Wf({ instrumentations: d }), (Q = e.networkRecordingOptions) != null && Q.enabled && e.networkRecordingOptions.recordHeadersAndBody && ((ei = e.instrumentations) == null ? void 0 : ei["@opentelemetry/instrumentation-xml-http-request"]) !== !1 && (Le == null || Le(), Le = Ly([
    ...n,
    ...i
  ])), (ti = e.networkRecordingOptions) != null && ti.enabled && e.networkRecordingOptions.recordHeadersAndBody && ((ri = e.instrumentations) == null ? void 0 : ri["@opentelemetry/instrumentation-fetch"]) !== !1 && (Pe == null || Pe(), Pe = Gy([
    ...n,
    ...i
  ]));
  const p = new Oa();
  return p.enable(), B.tracerProvider.register({
    contextManager: p,
    propagator: new sa({
      propagators: [
        new ea(),
        new zy({
          backendUrl: r,
          otlpEndpoint: e.otlpEndpoint,
          tracingOrigins: e.tracingOrigins,
          urlBlocklist: n
        })
      ]
    })
  }), Zt = $y(
    u,
    l,
    c,
    () => B
  ), B;
}, $y = (e, t, r, n) => {
  if (typeof document == "undefined" || typeof window == "undefined")
    return () => {
    };
  const i = () => {
    var c, s;
    e.setUnloading(!0), t.setUnloading(!0), r.setSkipPendingOnFlush(!0);
    const u = n();
    (c = u.tracerProvider) == null || c.forceFlush().catch(() => {
    }), (s = u.meterProvider) == null || s.forceFlush().catch(() => {
    });
  }, o = () => {
    document.visibilityState === "hidden" ? i() : document.visibilityState === "visible" && (e.setUnloading(!1), t.setUnloading(!1), r.setSkipPendingOnFlush(!1));
  }, a = () => i();
  return document.addEventListener("visibilitychange", o), window.addEventListener("pagehide", a), () => {
    document.removeEventListener("visibilitychange", o), window.removeEventListener("pagehide", a);
  };
};
class fr extends Aa {
  constructor() {
    super(...arguments);
    b(this, "_pendingSpans", /* @__PURE__ */ new Set());
    // When set, forceFlush/shutdown return immediately without waiting for
    // in-flight response-body reads. Used on page unload where waiting risks
    // the browser freezing JS before we hand the spans to the transport.
    b(this, "_skipPendingOnFlush", !1);
  }
  setSkipPendingOnFlush(r) {
    this._skipPendingOnFlush = r;
  }
  onStart(r, n) {
    r.setAttribute(Fy, he()), super.onStart(r, n);
  }
  onEnd(r) {
    if (r.attributes[Ce] === !1)
      return;
    const n = Mn(r), i = lr.get(n);
    if (i) {
      const o = i.catch((a) => {
        j(
          "warn",
          "[CustomBatchSpanProcessor] Failed to capture response body attributes",
          a
        );
      }).finally(() => {
        lr.delete(n), this._pendingSpans.delete(o), r.attributes[Ce] !== !1 && super.onEnd(r);
      });
      this._pendingSpans.add(o);
      return;
    }
    super.onEnd(r);
  }
  shutdown() {
    return U(this, null, function* () {
      return this._skipPendingOnFlush || (yield Promise.allSettled(this._pendingSpans)), Or(fr.prototype, this, "shutdown").call(this);
    });
  }
  forceFlush() {
    return U(this, null, function* () {
      return this._skipPendingOnFlush || (yield Promise.allSettled(this._pendingSpans)), Or(fr.prototype, this, "forceFlush").call(this);
    });
  }
}
class zy extends ua {
  constructor(r) {
    super();
    b(this, "highlightEndpoints");
    b(this, "tracingOrigins");
    b(this, "urlBlocklist");
    this.highlightEndpoints = [
      r.backendUrl,
      `${r.otlpEndpoint}/v1/traces`,
      `${r.otlpEndpoint}/v1/logs`,
      `${r.otlpEndpoint}/v1/metrics`
    ], this.tracingOrigins = r.tracingOrigins, this.urlBlocklist = r.urlBlocklist;
  }
  inject(r, n, i) {
    var u;
    const o = L.getSpan(r);
    if (!o || !o.attributes)
      return;
    const a = As(o);
    typeof a == "string" && (tg(
      a,
      this.highlightEndpoints,
      this.tracingOrigins,
      this.urlBlocklist
    ) || o.setAttribute(Ce, !1), !Xn(
      a,
      (u = this.tracingOrigins) != null ? u : [],
      this.urlBlocklist
    )) || super.inject(r, n, i);
  }
}
const Ss = "highlight-browser", Xy = Ss, go = () => {
  var e;
  return (e = B.tracerProvider) == null ? void 0 : e.getTracer(Ss);
}, Vt = () => {
  var e;
  return (e = B.meterProvider) == null ? void 0 : e.getMeter(Xy);
}, qy = () => L.getActiveSpan(), Wy = () => U(void 0, null, function* () {
  Zt && (Zt(), Zt = void 0), Le && (Le(), Le = void 0), Pe && (Pe(), Pe = void 0), yield Promise.allSettled([
    U(void 0, null, function* () {
      B.tracerProvider ? (yield B.tracerProvider.shutdown(), B.tracerProvider = void 0) : j(
        "warn",
        "OTEL shutdown called without initialized tracerProvider."
      );
    }),
    U(void 0, null, function* () {
      B.meterProvider ? (yield B.meterProvider.shutdown(), B.meterProvider = void 0) : j(
        "warn",
        "OTEL shutdown called without initialized meterProvider."
      );
    })
  ]);
}), bs = (e) => {
  const t = Qp(e), r = {};
  return t != null && t.name && (r["graphql.operation.name"] = t.name), t != null && t.type && (r["graphql.operation.type"] = t.type), r;
}, Ky = (e, t, r, n) => {
  if (!e.attributes)
    return;
  const i = e.attributes;
  Object.assign(i, bs(t)), n != null && n.recordHeadersAndBody && Object.assign(i, {
    "http.request.body": ne(
      t,
      n.networkBodyKeysToRedact,
      n.bodyKeysToRecord,
      vs(r)
    )
  });
}, mo = (e, t, r, n) => {
  var l;
  if (!e.attributes)
    return;
  const o = As(e), a = dn(o), u = Vo(a), c = gs(t), s = vs(r);
  if (e.setAttributes(bs(c != null ? c : t)), e.setAttributes({
    "highlight.type": "http.request",
    [Ke]: a,
    // overwrite with sanitized version
    [ye]: a,
    [Xt]: u.pathname,
    [Qs]: u.search
  }), e.setAttributes(
    Jy(
      u.searchParams,
      "url.query_params"
    )
  ), n != null && n.recordHeadersAndBody) {
    c !== void 0 && e.setAttribute(
      "http.request.body",
      ne(
        c,
        n.networkBodyKeysToRedact,
        n.bodyKeysToRecord,
        s
      )
    );
    const f = _r(
      (l = n.networkHeadersToRedact) != null ? l : [],
      s,
      n.headerKeysToRecord
    ), d = Yn(
      f,
      "http.request.header"
    );
    e.setAttributes(d);
  }
}, Yy = (e) => {
  const t = {};
  return e && e.trim().split(/[\r\n]+/).forEach((r) => {
    const n = r.split(": "), i = n.shift();
    i && (t[i] = n.join(": "));
  }), t;
}, Yn = (e, t) => {
  const r = {};
  return Object.entries(e).forEach(([n, i]) => {
    const o = n.toLowerCase().replace(/_/g, "-"), a = `${t}.${o}`, u = Qy(o, i);
    if (r[a]) {
      const c = r[a];
      Array.isArray(c) ? r[a] = [...c, ...u] : r[a] = [c, ...u];
    } else
      r[a] = u.length === 1 ? u[0] : u;
  }), r;
}, Jy = (e, t) => {
  const r = {};
  for (const [n, i] of e.entries()) {
    const o = `${t}.${n}`, a = r[o];
    a === void 0 ? r[o] = i : Array.isArray(a) ? a.push(i) : r[o] = [a, i];
  }
  return r;
}, Zy = /* @__PURE__ */ new Set([
  "accept",
  "accept-charset",
  "accept-encoding",
  "accept-language",
  "accept-ranges",
  "allow",
  "cache-control",
  "connection",
  "content-encoding",
  "content-language",
  "expect",
  "if-match",
  "if-none-match",
  "pragma",
  "proxy-authenticate",
  "te",
  "trailer",
  "transfer-encoding",
  "upgrade",
  "vary",
  "via",
  "warning",
  "www-authenticate",
  "access-control-allow-headers",
  "access-control-allow-methods",
  "access-control-expose-headers",
  "access-control-request-headers"
]), Qy = (e, t) => Zy.has(e) ? t.split(",").map((r) => r.trim()).filter((r) => r.length > 0) : [t], eg = (e, t, r, n) => {
  var a;
  e.setAttribute("http.response.body", r);
  const i = _r(
    (a = n.networkHeadersToRedact) != null ? a : [],
    t,
    n.headerKeysToRecord
  ), o = Yn(
    i,
    "http.response.header"
  );
  e.setAttributes(o);
}, Eo = (e, t) => {
  var f, d, h, _, p, v, y, m, w, A, R, C;
  const n = e.attributes, i = {}, o = {};
  for (const [I, P] of Object.entries(n))
    I.startsWith("http.request.header.") && (i[I.slice(20)] = String(P)), I.startsWith("http.response.header.") && (o[I.slice(21)] = String(P));
  let u = {
    request: {
      sessionSecureID: "",
      id: "",
      url: (d = (f = n[ye]) != null ? f : n[Ke]) != null ? d : "",
      verb: (_ = (h = n["http.request.method"]) != null ? h : n[Kd]) != null ? _ : "GET",
      headers: i,
      body: (p = n["http.request.body"]) != null ? p : ""
    },
    response: {
      status: Number(
        (y = (v = n[Ho]) != null ? v : n[Yd]) != null ? y : 0
      ),
      headers: o,
      body: (m = n["http.response.body"]) != null ? m : ""
    },
    urlBlocked: !1
  }, c = !0;
  try {
    u.request.body = JSON.parse(u.request.body);
  } catch (I) {
    c = !1;
  }
  let s = !0;
  try {
    u.response.body = JSON.parse(u.response.body);
  } catch (I) {
    s = !1;
  }
  let l;
  try {
    l = t(u);
  } catch (I) {
    return;
  }
  if (!l) {
    Object.assign(e.attributes, {
      [Ce]: !1
    });
    return;
  }
  c && ((w = l.request) != null && w.body) && (l.request.body = JSON.stringify(l.request.body)), s && ((A = l.response) != null && A.body) && (l.response.body = JSON.stringify(l.response.body)), Object.assign(e.attributes, {
    "http.request.body": (R = l.request.body) != null ? R : "",
    "http.response.body": (C = l.response.body) != null ? C : ""
  });
}, tg = (e, t, r, n) => n != null && n.some(
  (o) => e.toLowerCase().includes(o)
) ? !1 : zn(
  e,
  t
), To = (e) => {
  var o, a, u;
  if (!e.events)
    return;
  const r = e.events, n = {
    unload: z("unloadEventStart", "unloadEventEnd", r),
    dom_interactive: z(
      "fetchStart",
      "domInteractive",
      r
    ),
    dom_content_loaded: z(
      "domContentLoadedEventStart",
      "domContentLoadedEventEnd",
      r
    ),
    dom_complete: z("fetchStart", "domComplete", r),
    load_event: z("loadEventStart", "loadEventEnd", r),
    document_load: z("fetchStart", "loadEventEnd", r),
    first_paint: z("fetchStart", "firstPaint", r),
    first_contentful_paint: z(
      "fetchStart",
      "firstContentfulPaint",
      r
    ),
    domain_lookup: z(
      "domainLookupStart",
      "domainLookupEnd",
      r
    ),
    connect: z("connectStart", "connectEnd", r),
    request: z("requestStart", "requestEnd", r),
    response: z("responseStart", "responseEnd", r)
  }, i = (a = (o = ae == null ? void 0 : ae.getIntegrations) == null ? void 0 : o.call(ae)) != null ? a : [];
  if (n.document_load !== void 0)
    for (const c of i)
      c.recordGauge((u = ae == null ? void 0 : ae.sessionSecureId) != null ? u : "", {
        name: Zs,
        value: n.document_load / 1e6
      });
  Object.entries(n).forEach(([c, s]) => {
    s !== void 0 && (e.setAttribute(`timings.${c}.ns`, s), e.setAttribute(
      `timings.${c}.readable`,
      ws(s)
    ));
  });
};
function z(e, t, r) {
  const n = r.find((u) => u.name === e), i = r.find((u) => u.name === t);
  if (!n || !i)
    return;
  const o = n.time[0] * 1e9 + n.time[1];
  return i.time[0] * 1e9 + i.time[1] - o;
}
const rg = (e, t) => {
  const r = {
    domain_lookup: (t.domainLookupEnd - t.domainLookupStart) * 1e6,
    connect: (t.connectEnd - t.connectStart) * 1e6,
    request: (t.responseEnd - t.requestStart) * 1e6,
    response: (t.responseEnd - t.responseStart) * 1e6
  };
  Object.entries(r).forEach(([n, i]) => {
    e.setAttribute(`timings.${n}.ns`, i), e.setAttribute(`timings.${n}.readable`, ws(i));
  });
}, ws = (e) => {
  if (e >= 36e11) {
    const a = e / 36e11;
    return `${Number(a.toFixed(1))}h`;
  } else if (e >= 6e10) {
    const a = e / 6e10;
    return `${Number(a.toFixed(1))}m`;
  } else if (e >= 1e9) {
    const a = e / 1e9;
    return `${Number(a.toFixed(1))}s`;
  } else if (e >= 1e6) {
    const a = e / 1e6;
    return `${Number(a.toFixed(1))}ms`;
  } else if (e >= 1e3) {
    const a = e / 1e3;
    return `${Number(a.toFixed(1))}µs`;
  } else
    return `${Number(e.toFixed(1))}ns`;
}, So = (e) => e === !0 ? [
  /localhost/,
  /^\//,
  Ia(window.location.host)
] : Array.isArray(e) ? e.map(
  (t) => typeof t == "string" ? new RegExp(t) : t
) : /^$/, As = (e) => e.attributes[ye] ? e.attributes[ye] : e.attributes[Ke], ng = 30, ig = () => new Promise(
  (e) => requestAnimationFrame(
    (t) => requestAnimationFrame((r) => e(r - t))
  )
), og = () => U(void 0, null, function* () {
  const e = [];
  for (let t = 0; t < ng; t++)
    e.push(yield ig());
  return e.reduce((t, r) => t + r, 0) / e.length;
}), ag = (e, t) => {
  let r = {}, n = 16.666666666666668;
  og().then((c) => n = c);
  const i = (c) => {
    var s;
    r != null && r.event || (r = {
      event: c,
      location: window.location.href,
      timerStart: (s = window.performance) == null ? void 0 : s.now()
    }, window.requestAnimationFrame(o));
  }, o = () => {
    if (!(r != null && r.timerStart)) return;
    const c = window.performance.now() - r.timerStart - n;
    a(c), r = {};
  }, a = (c) => {
    const s = ((/* @__PURE__ */ new Date()).getTime() - t) / 1e3;
    e({
      relativeTimestamp: s,
      jankAmount: c,
      querySelector: u(),
      newLocation: window.location.href != r.location ? window.location.href : void 0
    });
  }, u = () => {
    var c;
    return (c = r == null ? void 0 : r.event) != null && c.target ? eu(r.event.target) : "";
  };
  return window.addEventListener("click", i, !0), window.addEventListener("keydown", i, !0), () => {
    window.removeEventListener("keydown", i, !0), window.removeEventListener("click", i, !0);
  };
}, sg = typeof window != "undefined", bo = sg && "performance" in window && "memory" in performance ? performance : { memory: {} }, ug = (e, t) => {
  let r = 0, n = 0;
  const i = () => {
    const l = ((/* @__PURE__ */ new Date()).getTime() - t) / 1e3, f = bo.memory.jsHeapSizeLimit || 0, d = bo.memory.usedJSHeapSize || 0;
    e({
      jsHeapSizeLimit: f,
      usedJSHeapSize: d,
      relativeTimestamp: l,
      fps: r
    });
  };
  i();
  let o;
  o = setInterval(() => {
    i();
  }, 1e3);
  let a = 0, u = Date.now();
  const c = function() {
    var s = Date.now();
    a++, s > 1e3 + u && (r = Math.round(a * 1e3 / (s - u)), a = 0, u = s), n = requestAnimationFrame(c);
  };
  return c(), () => {
    clearInterval(o), cancelAnimationFrame(n);
  };
};
var ve, vt, Os, dr, In, et = function() {
  return window.performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
}, bt = function(e) {
  if (document.readyState === "loading") return "loading";
  var t = et();
  if (t) {
    if (e < t.domInteractive) return "loading";
    if (t.domContentLoadedEventStart === 0 || e < t.domContentLoadedEventStart) return "dom-interactive";
    if (t.domComplete === 0 || e < t.domComplete) return "dom-content-loaded";
  }
  return "complete";
}, cg = function(e) {
  var t = e.nodeName;
  return e.nodeType === 1 ? t.toLowerCase() : t.toUpperCase().replace(/^#/, "");
}, Tr = function(e, t) {
  var r = "";
  try {
    for (; e && e.nodeType !== 9; ) {
      var n = e, i = n.id ? "#" + n.id : cg(n) + (n.classList && n.classList.value && n.classList.value.trim() && n.classList.value.trim().length ? "." + n.classList.value.trim().replace(/\s+/g, ".") : "");
      if (r.length + i.length > 99) return r || i;
      if (r = r ? i + ">" + r : i, n.id) break;
      e = n.parentNode;
    }
  } catch (o) {
  }
  return r;
}, Rs = -1, Ls = function() {
  return Rs;
}, Ge = function(e) {
  addEventListener("pageshow", function(t) {
    t.persisted && (Rs = t.timeStamp, e(t));
  }, !0);
}, Sr = function() {
  var e = et();
  return e && e.activationStart || 0;
}, Y = function(e, t) {
  var r = et(), n = "navigate";
  return Ls() >= 0 ? n = "back-forward-cache" : r && (document.prerendering || Sr() > 0 ? n = "prerender" : document.wasDiscarded ? n = "restore" : r.type && (n = r.type.replace(/_/g, "-"))), { name: e, value: t === void 0 ? -1 : t, rating: "good", delta: 0, entries: [], id: "v3-".concat(Date.now(), "-").concat(Math.floor(8999999999999 * Math.random()) + 1e12), navigationType: n };
}, tt = function(e, t, r) {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(e)) {
      var n = new PerformanceObserver(function(i) {
        Promise.resolve().then(function() {
          t(i.getEntries());
        });
      });
      return n.observe(Object.assign({ type: e, buffered: !0 }, r || {})), n;
    }
  } catch (i) {
  }
}, J = function(e, t, r, n) {
  var i, o;
  return function(a) {
    t.value >= 0 && (a || n) && ((o = t.value - (i || 0)) || i === void 0) && (i = t.value, t.delta = o, t.rating = function(u, c) {
      return u > c[1] ? "poor" : u > c[0] ? "needs-improvement" : "good";
    }(t.value, r), e(t));
  };
}, Jn = function(e) {
  requestAnimationFrame(function() {
    return requestAnimationFrame(function() {
      return e();
    });
  });
}, br = function(e) {
  var t = function(r) {
    r.type !== "pagehide" && document.visibilityState !== "hidden" || e(r);
  };
  addEventListener("visibilitychange", t, !0), addEventListener("pagehide", t, !0);
}, Zn = function(e) {
  var t = !1;
  return function(r) {
    t || (e(r), t = !0);
  };
}, Xe = -1, wo = function() {
  return document.visibilityState !== "hidden" || document.prerendering ? 1 / 0 : 0;
}, pr = function(e) {
  document.visibilityState === "hidden" && Xe > -1 && (Xe = e.type === "visibilitychange" ? e.timeStamp : 0, lg());
}, Ao = function() {
  addEventListener("visibilitychange", pr, !0), addEventListener("prerenderingchange", pr, !0);
}, lg = function() {
  removeEventListener("visibilitychange", pr, !0), removeEventListener("prerenderingchange", pr, !0);
}, Qn = function() {
  return Xe < 0 && (Xe = wo(), Ao(), Ge(function() {
    setTimeout(function() {
      Xe = wo(), Ao();
    }, 0);
  })), { get firstHiddenTime() {
    return Xe;
  } };
}, Pt = function(e) {
  document.prerendering ? addEventListener("prerenderingchange", function() {
    return e();
  }, !0) : e();
}, Oo = [1800, 3e3], Ps = function(e, t) {
  t = t || {}, Pt(function() {
    var r, n = Qn(), i = Y("FCP"), o = tt("paint", function(a) {
      a.forEach(function(u) {
        u.name === "first-contentful-paint" && (o.disconnect(), u.startTime < n.firstHiddenTime && (i.value = Math.max(u.startTime - Sr(), 0), i.entries.push(u), r(!0)));
      });
    });
    o && (r = J(e, i, Oo, t.reportAllChanges), Ge(function(a) {
      i = Y("FCP"), r = J(e, i, Oo, t.reportAllChanges), Jn(function() {
        i.value = performance.now() - a.timeStamp, r(!0);
      });
    }));
  });
}, Ro = [0.1, 0.25], fg = function(e, t) {
  (function(r, n) {
    n = n || {}, Ps(Zn(function() {
      var i, o = Y("CLS", 0), a = 0, u = [], c = function(l) {
        l.forEach(function(f) {
          if (!f.hadRecentInput) {
            var d = u[0], h = u[u.length - 1];
            a && f.startTime - h.startTime < 1e3 && f.startTime - d.startTime < 5e3 ? (a += f.value, u.push(f)) : (a = f.value, u = [f]);
          }
        }), a > o.value && (o.value = a, o.entries = u, i());
      }, s = tt("layout-shift", c);
      s && (i = J(r, o, Ro, n.reportAllChanges), br(function() {
        c(s.takeRecords()), i(!0);
      }), Ge(function() {
        a = 0, o = Y("CLS", 0), i = J(r, o, Ro, n.reportAllChanges), Jn(function() {
          return i();
        });
      }), setTimeout(i, 0));
    }));
  })(function(r) {
    (function(n) {
      if (n.entries.length) {
        var i = n.entries.reduce(function(u, c) {
          return u && u.value > c.value ? u : c;
        });
        if (i && i.sources && i.sources.length) {
          var o = (a = i.sources).find(function(u) {
            return u.node && u.node.nodeType === 1;
          }) || a[0];
          if (o) return void (n.attribution = { largestShiftTarget: Tr(o.node), largestShiftTime: i.startTime, largestShiftValue: i.value, largestShiftSource: o, largestShiftEntry: i, loadState: bt(i.startTime) });
        }
      }
      var a;
      n.attribution = {};
    })(r), e(r);
  }, t);
}, dg = function(e, t) {
  Ps(function(r) {
    (function(n) {
      if (n.entries.length) {
        var i = et(), o = n.entries[n.entries.length - 1];
        if (i) {
          var a = i.activationStart || 0, u = Math.max(0, i.responseStart - a);
          return void (n.attribution = { timeToFirstByte: u, firstByteToFCP: n.value - u, loadState: bt(n.entries[0].startTime), navigationEntry: i, fcpEntry: o });
        }
      }
      n.attribution = { timeToFirstByte: 0, firstByteToFCP: n.value, loadState: bt(Ls()) };
    })(r), e(r);
  }, t);
}, ft = { passive: !0, capture: !0 }, pg = /* @__PURE__ */ new Date(), Lo = function(e, t) {
  ve || (ve = t, vt = e, Os = /* @__PURE__ */ new Date(), Cs(removeEventListener), Ns());
}, Ns = function() {
  if (vt >= 0 && vt < Os - pg) {
    var e = { entryType: "first-input", name: ve.type, target: ve.target, cancelable: ve.cancelable, startTime: ve.timeStamp, processingStart: ve.timeStamp + vt };
    dr.forEach(function(t) {
      t(e);
    }), dr = [];
  }
}, hg = function(e) {
  if (e.cancelable) {
    var t = (e.timeStamp > 1e12 ? /* @__PURE__ */ new Date() : performance.now()) - e.timeStamp;
    e.type == "pointerdown" ? function(r, n) {
      var i = function() {
        Lo(r, n), a();
      }, o = function() {
        a();
      }, a = function() {
        removeEventListener("pointerup", i, ft), removeEventListener("pointercancel", o, ft);
      };
      addEventListener("pointerup", i, ft), addEventListener("pointercancel", o, ft);
    }(t, e) : Lo(t, e);
  }
}, Cs = function(e) {
  ["mousedown", "keydown", "touchstart", "pointerdown"].forEach(function(t) {
    return e(t, hg, ft);
  });
}, Po = [100, 300], _g = function(e, t) {
  t = t || {}, Pt(function() {
    var r, n = Qn(), i = Y("FID"), o = function(c) {
      c.startTime < n.firstHiddenTime && (i.value = c.processingStart - c.startTime, i.entries.push(c), r(!0));
    }, a = function(c) {
      c.forEach(o);
    }, u = tt("first-input", a);
    r = J(e, i, Po, t.reportAllChanges), u && br(Zn(function() {
      a(u.takeRecords()), u.disconnect();
    })), u && Ge(function() {
      var c;
      i = Y("FID"), r = J(e, i, Po, t.reportAllChanges), dr = [], vt = -1, ve = null, Cs(addEventListener), c = o, dr.push(c), Ns();
    });
  });
}, vg = function(e, t) {
  _g(function(r) {
    (function(n) {
      var i = n.entries[0];
      n.attribution = { eventTarget: Tr(i.target), eventType: i.name, eventTime: i.startTime, eventEntry: i, loadState: bt(i.startTime) };
    })(r), e(r);
  }, t);
}, Ms = 0, sn = 1 / 0, $t = 0, yg = function(e) {
  e.forEach(function(t) {
    t.interactionId && (sn = Math.min(sn, t.interactionId), $t = Math.max($t, t.interactionId), Ms = $t ? ($t - sn) / 7 + 1 : 0);
  });
}, Is = function() {
  return In ? Ms : performance.interactionCount || 0;
}, gg = function() {
  "interactionCount" in performance || In || (In = tt("event", yg, { type: "event", buffered: !0, durationThreshold: 0 }));
}, No = [200, 500], xs = 0, Co = function() {
  return Is() - xs;
}, re = [], un = {}, Mo = function(e) {
  var t = re[re.length - 1], r = un[e.interactionId];
  if (r || re.length < 10 || e.duration > t.latency) {
    if (r) r.entries.push(e), r.latency = Math.max(r.latency, e.duration);
    else {
      var n = { id: e.interactionId, latency: e.duration, entries: [e] };
      un[n.id] = n, re.push(n);
    }
    re.sort(function(i, o) {
      return o.latency - i.latency;
    }), re.splice(10).forEach(function(i) {
      delete un[i.id];
    });
  }
}, mg = function(e, t) {
  t = t || {}, Pt(function() {
    var r;
    gg();
    var n, i = Y("INP"), o = function(u) {
      u.forEach(function(l) {
        l.interactionId && Mo(l), l.entryType === "first-input" && !re.some(function(f) {
          return f.entries.some(function(d) {
            return l.duration === d.duration && l.startTime === d.startTime;
          });
        }) && Mo(l);
      });
      var c, s = (c = Math.min(re.length - 1, Math.floor(Co() / 50)), re[c]);
      s && s.latency !== i.value && (i.value = s.latency, i.entries = s.entries, n());
    }, a = tt("event", o, { durationThreshold: (r = t.durationThreshold) !== null && r !== void 0 ? r : 40 });
    n = J(e, i, No, t.reportAllChanges), a && ("interactionId" in PerformanceEventTiming.prototype && a.observe({ type: "first-input", buffered: !0 }), br(function() {
      o(a.takeRecords()), i.value < 0 && Co() > 0 && (i.value = 0, i.entries = []), n(!0);
    }), Ge(function() {
      re = [], xs = Is(), i = Y("INP"), n = J(e, i, No, t.reportAllChanges);
    }));
  });
}, Eg = function(e, t) {
  mg(function(r) {
    (function(n) {
      if (n.entries.length) {
        var i = n.entries.sort(function(o, a) {
          return a.duration - o.duration || a.processingEnd - a.processingStart - (o.processingEnd - o.processingStart);
        })[0];
        n.attribution = { eventTarget: Tr(i.target), eventType: i.name, eventTime: i.startTime, eventEntry: i, loadState: bt(i.startTime) };
      } else n.attribution = {};
    })(r), e(r);
  }, t);
}, Io = [2500, 4e3], cn = {}, Tg = function(e, t) {
  (function(r, n) {
    n = n || {}, Pt(function() {
      var i, o = Qn(), a = Y("LCP"), u = function(l) {
        var f = l[l.length - 1];
        f && f.startTime < o.firstHiddenTime && (a.value = Math.max(f.startTime - Sr(), 0), a.entries = [f], i());
      }, c = tt("largest-contentful-paint", u);
      if (c) {
        i = J(r, a, Io, n.reportAllChanges);
        var s = Zn(function() {
          cn[a.id] || (u(c.takeRecords()), c.disconnect(), cn[a.id] = !0, i(!0));
        });
        ["keydown", "click"].forEach(function(l) {
          addEventListener(l, function() {
            return setTimeout(s, 0);
          }, !0);
        }), br(s), Ge(function(l) {
          a = Y("LCP"), i = J(r, a, Io, n.reportAllChanges), Jn(function() {
            a.value = performance.now() - l.timeStamp, cn[a.id] = !0, i(!0);
          });
        });
      }
    });
  })(function(r) {
    (function(n) {
      if (n.entries.length) {
        var i = et();
        if (i) {
          var o = i.activationStart || 0, a = n.entries[n.entries.length - 1], u = a.url && performance.getEntriesByType("resource").filter(function(h) {
            return h.name === a.url;
          })[0], c = Math.max(0, i.responseStart - o), s = Math.max(c, u ? (u.requestStart || u.startTime) - o : 0), l = Math.max(s, u ? u.responseEnd - o : 0), f = Math.max(l, a ? a.startTime - o : 0), d = { element: Tr(a.element), timeToFirstByte: c, resourceLoadDelay: s - c, resourceLoadTime: l - s, elementRenderDelay: f - l, navigationEntry: i, lcpEntry: a };
          return a.url && (d.url = a.url), u && (d.lcpResourceEntry = u), void (n.attribution = d);
        }
      }
      n.attribution = { timeToFirstByte: 0, resourceLoadDelay: 0, resourceLoadTime: 0, elementRenderDelay: n.value };
    })(r), e(r);
  }, t);
}, xo = [800, 1800], Sg = function e(t) {
  document.prerendering ? Pt(function() {
    return e(t);
  }) : document.readyState !== "complete" ? addEventListener("load", function() {
    return e(t);
  }, !0) : setTimeout(t, 0);
}, bg = function(e, t) {
  t = t || {};
  var r = Y("TTFB"), n = J(e, r, xo, t.reportAllChanges);
  Sg(function() {
    var i = et();
    if (i) {
      var o = i.responseStart;
      if (o <= 0 || o > performance.now()) return;
      r.value = Math.max(o - Sr(), 0), r.entries = [i], n(!0), Ge(function() {
        r = Y("TTFB", 0), (n = J(e, r, xo, t.reportAllChanges))(!0);
      });
    }
  });
}, wg = function(e, t) {
  bg(function(r) {
    (function(n) {
      if (n.entries.length) {
        var i = n.entries[0], o = i.activationStart || 0, a = Math.max(i.domainLookupStart - o, 0), u = Math.max(i.connectStart - o, 0), c = Math.max(i.requestStart - o, 0);
        n.attribution = { waitingTime: a, dnsTime: u - a, connectionTime: c - u, requestTime: n.value - c, navigationEntry: i };
      } else n.attribution = { waitingTime: 0, dnsTime: 0, connectionTime: 0, requestTime: 0 };
    })(r), e(r);
  }, t);
};
const Ag = (e) => (fg(e), dg(e), vg(e), Tg(e), wg(e), Eg(e), () => {
}), ze = typeof navigator != "undefined" && "connection" in navigator ? navigator.connection : {}, Og = (e, t) => {
  const r = () => {
    const o = ((/* @__PURE__ */ new Date()).getTime() - t) / 1e3;
    e({
      relativeTimestamp: o,
      downlink: ze.downlink,
      downlinkMax: ze.downlinkMax,
      effectiveType: ze.effectiveType,
      rtt: ze.rtt,
      saveData: ze.saveData,
      type: ze.type
    });
  };
  r();
  let n;
  return n = setInterval(() => {
    r();
  }, 1e3), () => {
    clearInterval(n);
  };
}, Rg = () => {
  if (!("performance" in window && "memory" in performance))
    return {
      getDeviceDetails: void 0,
      getCurrentDeviceDetails: void 0
    };
  const e = window.performance;
  return {
    getDeviceDetails: () => ({
      deviceMemory: Lg(
        navigator.deviceMemory || 0
      )
    }),
    getCurrentDeviceDetails: () => {
      const n = ln(
        e.memory.jsHeapSizeLimit
      ), i = ln(
        e.memory.totalJSHeapSize
      ), o = ln(
        e.memory.usedJSHeapSize
      );
      return {
        jsHeapSizeLimit: n,
        totalJSHeapSize: i,
        usedJSHeapSize: o
      };
    }
  };
}, ln = (e) => e / Math.pow(1e3, 2), Lg = (e) => 1024 * e, Pg = {
  TTFB: "ms",
  FCP: "ms",
  LCP: "ms",
  INP: "ms",
  FID: "ms",
  Jank: "ms",
  CLS: "1",
  usedJSHeapSize: "By",
  jsHeapSizeLimit: "By",
  totalJSHeapSize: "By",
  fps: "{frames}/s",
  [$.ViewportHeight]: "{px}",
  [$.ViewportWidth]: "{px}",
  [$.ScreenHeight]: "{px}",
  [$.ScreenWidth]: "{px}",
  [$.ViewportArea]: "{px2}",
  // Value is 1024 * navigator.deviceMemory (GiB → MiB), not decimal megabytes.
  [$.DeviceMemory]: "MiBy",
  downlink: "Mbit/s",
  downlinkMax: "Mbit/s",
  rtt: "ms",
  "long_task.duration": "ms"
};
function zt(e, t) {
  const r = t != null ? t : Pg[e];
  return r ? { unit: r } : void 0;
}
function Ng(e) {
  return "regexValue" in e;
}
function Cg(e) {
  return "matchValue" in e;
}
function Mg(e) {
  const t = Math.trunc(e);
  return t === 1 ? !0 : t === 0 ? !1 : Math.floor(Math.random() * t) === 0;
}
class Ig {
  /**
   * @param config The sampling configuration.
   * @param sampler The sampler to use. This is intended to be used for testing purposes.
   */
  constructor(t = Mg) {
    b(this, "regexCache", /* @__PURE__ */ new Map());
    b(this, "config");
    this.sampler = t;
  }
  setConfig(t) {
    this.config = t;
  }
  isSamplingEnabled() {
    var t, r, n, i;
    return !!((r = (t = this.config) == null ? void 0 : t.logs) != null && r.length || (i = (n = this.config) == null ? void 0 : n.spans) != null && i.length);
  }
  shouldSample(t) {
    var r, n;
    return t.name === ms ? this.sampleLog((r = this.config) == null ? void 0 : r.logs, t) : this.sampleSpan((n = this.config) == null ? void 0 : n.spans, t);
  }
  /**
   * Check if a value matches a match config.
   */
  matchesValue(t, r) {
    if (!t)
      return !1;
    if (Cg(t))
      return t.matchValue === r;
    if (Ng(t)) {
      const n = t.regexValue;
      if (n === null)
        return !1;
      this.regexCache.has(n) || this.regexCache.set(n, new RegExp(n));
      const i = this.regexCache.get(n);
      if (typeof r == "string")
        return i.test(r);
    }
    return !1;
  }
  /**
   * Check if the attributes match the attribute configs.
   */
  matchesAttributes(t, r) {
    if (t)
      for (const n of t) {
        let i = !1;
        for (const o of Object.keys(r))
          if (this.matchesValue(n.key, o)) {
            const a = r[o];
            if (this.matchesValue(
              n.attribute,
              a
            )) {
              i = !0;
              break;
            }
          }
        if (!i)
          return !1;
      }
    return !0;
  }
  matchEvent(t, r) {
    return !(t.name && !this.matchesValue(t.name, r.name) || t.attributes && (!r.attributes || !this.matchesAttributes(
      t.attributes,
      r.attributes
    )));
  }
  matchesEvents(t, r) {
    if (t)
      for (const n of t) {
        let i = !1;
        for (const o of r)
          if (this.matchEvent(n, o)) {
            i = !0;
            break;
          }
        if (!i)
          return !1;
      }
    return !0;
  }
  /**
   * Attempts to match the span to the config. The span will match only if all defined conditions are met.
   *
   * @param config The config to match against.
   * @param name The name of the span to match.
   * @param attributes The attributes of the span to match.
   * @returns True if the span matches the config, false otherwise.
   */
  matchesSpanConfig(t, r) {
    return !(t.name && !this.matchesValue(t.name, r.name) || !this.matchesAttributes(t.attributes, r.attributes) || !this.matchesEvents(t.events, r.events));
  }
  matchesLogConfig(t, r) {
    if (t.severityText) {
      const n = r[Es];
      if (!this.matchesValue(t.severityText, n))
        return !1;
    }
    if (t.message) {
      const n = r[Ts];
      if (!this.matchesValue(t.message, n))
        return !1;
    }
    return !!this.matchesAttributes(t.attributes, r);
  }
  /**
   * Sample a span based on the sampling configuration.
   *
   * @param configs The sampling configuration.
   * @param name The name of the span to sample.
   * @param attributes The attributes of the span to sample.
   * @returns The sampling result.
   */
  sampleSpan(t, r) {
    if (t) {
      for (const n of t)
        if (this.matchesSpanConfig(n, r))
          return {
            sample: this.sampler(n.samplingRatio),
            attributes: {
              [yo]: n.samplingRatio
            }
          };
    }
    return {
      sample: !0
    };
  }
  /**
   * Sample a log based on the sampling configuration.
   *
   * @param configs The sampling configuration.
   * @param attributes The attributes of the log to sample.
   * @returns The sampling result.
   */
  sampleLog(t, r) {
    if (t) {
      for (const n of t)
        if (this.matchesLogConfig(n, r.attributes))
          return {
            sample: this.sampler(n.samplingRatio),
            attributes: {
              [yo]: n.samplingRatio
            }
          };
    }
    return {
      sample: !0
    };
  }
}
const xg = () => {
  if (typeof window == "undefined" || typeof PerformanceObserver == "undefined") return !1;
  const e = PerformanceObserver.supportedEntryTypes;
  return Array.isArray(e) && e.includes("longtask");
}, Dg = (e) => {
  if (!xg()) return () => {
  };
  let t;
  try {
    t = new PerformanceObserver((r) => {
      var n;
      for (const i of r.getEntries()) {
        const o = (n = i.attribution) == null ? void 0 : n[0];
        e({
          duration: i.duration,
          name: i.name,
          startTime: i.startTime,
          containerType: o == null ? void 0 : o.containerType,
          containerSrc: o == null ? void 0 : o.containerSrc,
          containerId: o == null ? void 0 : o.containerId,
          containerName: o == null ? void 0 : o.containerName
        });
      }
    }), t.observe({ type: "longtask", buffered: !0 });
  } catch (r) {
    return () => {
    };
  }
  return () => {
    try {
      t.disconnect();
    } catch (r) {
    }
  };
}, kg = /* @__PURE__ */ new Set(["string", "number", "boolean"]), Ug = () => typeof window != "undefined" && typeof window.ReportingObserver != "undefined", Bg = (e) => {
  const t = {};
  if (!e || typeof e != "object") return t;
  for (const [r, n] of Object.entries(
    e
  ))
    if (n != null)
      if (kg.has(typeof n))
        t[`report.body.${r}`] = n;
      else
        try {
          t[`report.body.${r}`] = JSON.stringify(n);
        } catch (i) {
        }
  return t;
}, Hg = (e) => {
  var n;
  const t = (n = e.body) != null ? n : {}, r = t.message || t.reason || t.id || e.type;
  return typeof r == "string" ? r : e.type;
}, Gg = (e, t) => {
  if (!Ug()) return () => {
  };
  const r = [
    "deprecation",
    "intervention",
    "csp-violation"
  ], n = window.ReportingObserver;
  let i;
  try {
    i = new n(
      (o) => {
        var a, u;
        for (const c of o) {
          const s = (a = c.type) != null ? a : "unknown", l = (u = c.body) != null ? u : {}, f = E({
            "report.type": s,
            "report.url": c.url
          }, Bg(l)), d = Hg({ type: s, body: l });
          e(s === "deprecation" ? {
            kind: "log",
            level: "warn",
            type: s,
            message: d,
            url: c.url,
            attributes: f
          } : {
            kind: "error",
            type: s,
            message: d,
            url: c.url,
            attributes: f
          });
        }
      },
      { buffered: !0, types: r }
    ), i.observe();
  } catch (o) {
    return () => {
    };
  }
  return () => {
    try {
      i.disconnect();
    } catch (o) {
    }
  };
}, Fg = "exception", jg = function(e, t, r) {
  if (!e)
    return;
  const n = E({}, r);
  typeof t == "string" ? n[Lr] = t : t && (t.code ? n[Rr] = t.code.toString() : t.name && (n[Rr] = t.name), t.message && (n[Lr] = t.message), t.stack && (n[tu] = t.stack)), n[Rr] || n[Lr] ? e.addEvent(Fg, n) : Lu(
    "otel",
    "recordException",
    "warn",
    `Failed to record an exception ${t}`
  );
};
var wt;
class Vg {
  constructor(t) {
    /** Verbose project ID that is exposed to users. Legacy users may still be using ints. */
    b(this, "organizationID");
    b(this, "_options");
    b(this, "_integrations", []);
    b(this, "_gauges", /* @__PURE__ */ new Map());
    b(this, "_counters", /* @__PURE__ */ new Map());
    b(this, "_histograms", /* @__PURE__ */ new Map());
    b(this, "_up_down_counters", /* @__PURE__ */ new Map());
    b(this, "sampler", new Ig());
    b(this, "_started", !1);
    b(this, "_ldContextKeys");
    // ECMAScript-private (#) so the internal GraphQL SDK type — which
    // references graphql-request / graphql — does not leak into the published
    // declaration file and break consumer type-checking.
    pi(this, wt);
    this._options = t, this.organizationID = t.projectId, t.debug && Pu(!0);
  }
  _productAnalyticsEvents() {
    var n;
    const t = (n = this._options) == null ? void 0 : n.productAnalytics;
    if (t === !1)
      return {};
    const r = {
      clicks: !0,
      pageViews: !0,
      trackEvents: !0
    };
    if (t === void 0 || t === !0)
      return r;
    for (const i of Object.keys(t))
      t[i] === !1 && (r[i] = !1);
    return r;
  }
  setLDContextKeyAttributes(t) {
    t && (this._ldContextKeys = Object.fromEntries(
      Object.entries(t).map(([r, n]) => [
        `${ru}.${r}`,
        n
      ])
    ));
  }
  getLDContextKeyAttributes() {
    return this._ldContextKeys;
  }
  start() {
    return U(this, null, function* () {
      var r, n, i, o, a, u, c, s, l, f, d, h, _, p, v;
      if (this._started)
        return;
      this._started = !0, Vy(
        {
          backendUrl: (n = (r = this._options) == null ? void 0 : r.backendUrl) != null ? n : "https://pub.observability.app.launchdarkly.com",
          otlpEndpoint: (a = (o = (i = this._options) == null ? void 0 : i.otel) == null ? void 0 : o.otlpEndpoint) != null ? a : "https://otel.observability.app.launchdarkly.com",
          projectId: this._options.projectId,
          sessionSecureId: this._options.sessionSecureId,
          environment: (c = (u = this._options) == null ? void 0 : u.environment) != null ? c : "production",
          networkRecordingOptions: typeof ((s = this._options) == null ? void 0 : s.networkRecording) == "object" ? this._options.networkRecording : void 0,
          tracingOrigins: (l = this._options) == null ? void 0 : l.tracingOrigins,
          serviceName: (d = (f = this._options) == null ? void 0 : f.serviceName) != null ? d : "browser",
          serviceVersion: (h = this._options) == null ? void 0 : h.version,
          instrumentations: (p = (_ = this._options) == null ? void 0 : _.otel) == null ? void 0 : p.instrumentations,
          productAnalyticsEvents: this._productAnalyticsEvents(),
          getLDContextKeyAttributes: () => this.getLDContextKeyAttributes(),
          getIntegrations: () => this._integrations
        },
        this.sampler
      ), this._gauges.clear(), this._counters.clear(), this._histograms.clear(), this._up_down_counters.clear();
      const t = new ou(
        (v = this._options.backendUrl) != null ? v : "https://pub.observability.app.launchdarkly.com",
        {
          headers: {}
        }
      );
      hi(this, wt, nu(t, iu())), yield this.configureSampling(), this.setupListeners();
    });
  }
  stop() {
    return U(this, null, function* () {
      this._started && (this._started = !1, yield Wy());
    });
  }
  configureSampling() {
    return U(this, null, function* () {
      try {
        const t = yield di(this, wt).GetSamplingConfig({
          organization_verbose_id: `${this.organizationID}`
        });
        this.sampler.setConfig(t.sampling);
      } catch (t) {
        Go(
          "sampling",
          "warn",
          `LaunchDarkly Observability: Failed to configure sampling: ${t}`
        );
      }
    });
  }
  _recordLog(t, r, n, i) {
    this.startSpan(ms, (o) => {
      var c, s, l, f, d;
      const a = Qt(
        typeof t == "string" ? t : Ye(t)
      ), u = i ? i.map((h) => h.toString()).join(`
`) : void 0;
      if (o == null || o.addEvent("log", E(E({
        [Es]: r,
        [Ts]: a,
        "code.stacktrace": u
      }, (c = this._ldContextKeys) != null ? c : {}), n)), this._options.reportConsoleErrors && r === "error") {
        const h = new Error(a);
        o == null || o.recordException(h), o == null || o.setStatus({
          code: tr.ERROR,
          message: a
        }), i ? this._recordErrorMessage({
          error: h,
          event: h.message,
          type: "custom",
          url: window.location.href,
          source: "frontend",
          lineNumber: (l = (s = i[0]) == null ? void 0 : s.lineNumber) != null ? l : 0,
          columnNumber: (d = (f = i[0]) == null ? void 0 : f.columnNumber) != null ? d : 0,
          stackTrace: i,
          timestamp: (/* @__PURE__ */ new Date()).toISOString(),
          id: pn()
        }) : this.recordError(h);
      }
    });
  }
  _recordErrorMessage(t, r) {
    try {
      t.payload && (r = E(E({}, JSON.parse(t.payload)), r || {}));
    } catch (a) {
    }
    this.startSpan("highlight.exception", (a) => {
      var u;
      jg(a, (u = t.error) != null ? u : new Error(t.event), {
        [jy]: t.id
      }), a == null || a.setAttributes(E({
        event: t.event,
        type: t.type,
        url: t.url,
        source: t.source,
        lineNumber: t.lineNumber,
        columnNumber: t.columnNumber
      }, r));
    });
    const o = t, { payload: n } = o, i = Ar(o, ["payload"]);
    for (const a of this._integrations)
      a.error(he(), x(E({}, i), {
        payload: JSON.stringify(r)
      }));
  }
  recordError(t, r, n, i, o) {
    var s, l, f, d;
    t = t || new Error("Unknown error"), t instanceof Error && t.cause && (n = x(E({}, n), {
      "exception.cause": JSON.stringify(t.cause)
    }));
    let a = r ? r + ":" + t.message : t.message;
    o === "React.ErrorBoundary" && (a = "ErrorBoundary: " + a);
    const u = hr(t), c = {
      error: t,
      event: a,
      type: o != null ? o : "custom",
      url: window.location.href,
      source: i != null ? i : "frontend",
      lineNumber: (s = u[0]) != null && s.lineNumber ? (l = u[0]) == null ? void 0 : l.lineNumber : 0,
      columnNumber: (f = u[0]) != null && f.columnNumber ? (d = u[0]) == null ? void 0 : d.columnNumber : 0,
      stackTrace: u,
      timestamp: (/* @__PURE__ */ new Date()).toISOString(),
      id: pn()
    };
    this._recordErrorMessage(c, n);
  }
  recordCount(t) {
    var n, i;
    let r = this._counters.get(t.name);
    if (!r) {
      if (r = (n = Vt()) == null ? void 0 : n.createCounter(
        t.name,
        zt(t.name, t.unit)
      ), !r) return;
      this._counters.set(t.name, r);
    }
    r.add(t.value, x(E(E({}, (i = this._ldContextKeys) != null ? i : {}), t.attributes), {
      "highlight.session_id": he()
    }));
  }
  recordGauge(t) {
    var o, a, u;
    let r = this._gauges.get(t.name);
    if (!r) {
      if (r = (o = Vt()) == null ? void 0 : o.createGauge(
        t.name,
        zt(t.name, t.unit)
      ), !r) return;
      this._gauges.set(t.name, r);
    }
    const n = E(E({}, (a = this._ldContextKeys) != null ? a : {}), t.attributes);
    r.record(t.value, x(E({}, n), {
      "highlight.session_id": he()
    }));
    const i = {
      name: t.name,
      value: t.value,
      unit: t.unit,
      category: n.category,
      group: (u = n.group) == null ? void 0 : u.toString(),
      tags: Object.entries(n).map(([c, s]) => {
        var l;
        return {
          name: c != null ? c : "",
          value: (l = s == null ? void 0 : s.toString()) != null ? l : ""
        };
      })
    };
    for (const c of this._integrations)
      c.recordGauge(
        he(),
        i
      );
  }
  recordIncr(t) {
    this.recordCount(x(E({}, t), { value: 1 }));
  }
  recordHistogram(t) {
    var n, i;
    let r = this._histograms.get(t.name);
    if (!r) {
      if (r = (n = Vt()) == null ? void 0 : n.createHistogram(
        t.name,
        zt(t.name, t.unit)
      ), !r) return;
      this._histograms.set(t.name, r);
    }
    r.record(t.value, x(E(E({}, (i = this._ldContextKeys) != null ? i : {}), t.attributes), {
      "highlight.session_id": he()
    }));
  }
  recordUpDownCounter(t) {
    var n, i;
    let r = this._up_down_counters.get(t.name);
    if (!r) {
      if (r = (n = Vt()) == null ? void 0 : n.createUpDownCounter(
        t.name,
        zt(t.name, t.unit)
      ), !r) return;
      this._up_down_counters.set(t.name, r);
    }
    r.add(t.value, x(E(E({}, (i = this._ldContextKeys) != null ? i : {}), t.attributes), {
      "highlight.session_id": he()
    }));
  }
  startSpan(t, r, n, i) {
    const o = go();
    if (!o) {
      const u = yi();
      return i === void 0 && n === void 0 ? r(u) : i === void 0 ? n(u) : i(u);
    }
    const a = (u, c) => {
      this._ldContextKeys && u.setAttributes(this._ldContextKeys);
      const s = c(u);
      return s instanceof Promise ? s.finally(() => u.end()) : (u.end(), s);
    };
    return i === void 0 && n === void 0 ? o.startActiveSpan(
      t,
      (u) => a(u, r)
    ) : i === void 0 ? o.startActiveSpan(
      t,
      r,
      (u) => a(u, n)
    ) : o.startActiveSpan(
      t,
      r,
      n,
      (u) => a(u, i)
    );
  }
  startManualSpan(t, r, n, i) {
    const o = go();
    if (!o) {
      const a = yi();
      return i === void 0 && n === void 0 ? r(a) : i === void 0 ? n(a) : i(a);
    }
    return i === void 0 && n === void 0 ? o.startActiveSpan(t, r) : i === void 0 ? o.startActiveSpan(
      t,
      r,
      n
    ) : o.startActiveSpan(
      t,
      r,
      n,
      i
    );
  }
  register(t, r) {
    this._integrations.push(new au(t, r));
  }
  getHooks(t) {
    return this._integrations.flatMap((r) => {
      var n, i;
      return (i = (n = r.getHooks) == null ? void 0 : n.call(r, t)) != null ? i : [];
    });
  }
  submitViewportMetrics({
    height: t,
    width: r,
    availHeight: n,
    availWidth: i
  }) {
    this.recordGauge({
      name: $.ViewportHeight,
      value: t,
      attributes: {
        category: X.Device,
        group: window.location.href
      }
    }), this.recordGauge({
      name: $.ViewportWidth,
      value: r,
      attributes: {
        category: X.Device,
        group: window.location.href
      }
    }), this.recordGauge({
      name: $.ScreenHeight,
      value: n,
      attributes: {
        category: X.Device,
        group: window.location.href
      }
    }), this.recordGauge({
      name: $.ScreenWidth,
      value: i,
      attributes: {
        category: X.Device,
        group: window.location.href
      }
    }), this.recordGauge({
      name: $.ViewportArea,
      value: t * r,
      attributes: {
        category: X.Device,
        group: window.location.href
      }
    });
  }
  setupListeners() {
    var r;
    this._options.disableConsoleRecording || Fu(
      (n) => {
        var i;
        this._recordLog(
          (i = n.value) == null ? void 0 : i.join(" "),
          n.type,
          n.attributes ? JSON.parse(n.attributes) : {},
          n.trace
        );
      },
      {
        level: (r = this._options.consoleMethodsToRecord) != null ? r : [
          ...Fo
        ],
        logger: "console",
        recordLaunchDarklySdkLogs: this._options.recordLaunchDarklySdkLogs,
        stringifyOptions: {
          depthOfLimit: 10,
          numOfKeysLimit: 100,
          stringLengthLimit: 1e3
        }
      }
    ), this._options.enablePerformanceRecording !== !1 && (ug((n) => {
      Object.entries(n).filter(([i]) => i !== "relativeTimestamp").forEach(
        ([i, o]) => o && this.recordGauge({
          name: i,
          value: o,
          attributes: {
            category: X.Performance,
            group: window.location.href
          }
        })
      );
    }, 0), ag((n) => {
      this.recordGauge({
        name: "Jank",
        value: n.jankAmount,
        attributes: {
          category: X.WebVital,
          group: n.querySelector
        }
      });
    }, 0)), Yu(
      (n) => {
        var a;
        if (Zu.includes(n.event) || Qu.some(
          (u) => n.event.includes(u)
        ))
          return;
        const i = new Error(n.event);
        i.stack = Ye(n.stackTrace.map((u) => u.toString()));
        let o = {};
        try {
          n.payload && (o = JSON.parse(n.payload));
        } catch (u) {
        }
        this._recordErrorMessage(
          x(E({}, n), { error: (a = n.error) != null ? a : i }),
          o
        );
      },
      { enablePromisePatch: !!this._options.enablePromisePatch }
    ), Ag((n) => {
      const { name: i, value: o } = n, { hostname: a, pathname: u, href: c } = window.location, s = {
        group: window.location.pathname,
        category: X.WebVital,
        [ye]: dn(c),
        [Xt]: u,
        [cu]: a
      };
      switch (n.name) {
        case "LCP": {
          const l = n.attribution;
          l.element && (s["web_vital.element"] = l.element), l.url && (s["web_vital.attribution.url"] = dn(
            l.url
          ));
          break;
        }
        case "CLS": {
          const l = n.attribution;
          l.largestShiftTarget && (s["web_vital.element"] = l.largestShiftTarget), l.loadState && (s["web_vital.load_state"] = l.loadState);
          break;
        }
        case "INP": {
          const l = n.attribution;
          l.eventTarget && (s["web_vital.element"] = l.eventTarget), l.eventType && (s["web_vital.event_type"] = l.eventType), l.loadState && (s["web_vital.load_state"] = l.loadState);
          break;
        }
        case "FID": {
          const l = n.attribution;
          l.eventTarget && (s["web_vital.element"] = l.eventTarget), l.eventType && (s["web_vital.event_type"] = l.eventType);
          break;
        }
        case "FCP": {
          const l = n.attribution;
          l.loadState && (s["web_vital.load_state"] = l.loadState);
          break;
        }
      }
      this.recordGauge({
        name: i,
        value: o,
        attributes: s
      });
    }), su((n) => {
      this.submitViewportMetrics(n);
    }), Og((n) => {
      const i = {
        category: X.Performance,
        group: window.location.href
      };
      n.saveData !== void 0 && (i.saveData = n.saveData.toString()), n.effectiveType !== void 0 && (i.effectiveType = n.effectiveType.toString()), n.type !== void 0 && (i.type = n.type.toString()), Object.entries(n).filter(([o]) => o !== "relativeTimestamp").forEach(([o, a]) => {
        uu(a) && this.recordGauge({
          name: o,
          value: a,
          attributes: i
        });
      });
    }, (/* @__PURE__ */ new Date()).getTime());
    const { getDeviceDetails: t } = Rg();
    t && this.recordGauge({
      name: $.DeviceMemory,
      value: t().deviceMemory,
      attributes: {
        category: X.Device,
        group: window.location.href
      }
    }), this._options.enableLongtaskRecording !== !1 && Dg((n) => {
      const i = {
        category: X.Performance,
        name: n.name,
        [Xt]: window.location.pathname
      };
      n.containerType && (i.container_type = n.containerType), n.containerSrc && (i.container_src = n.containerSrc), n.containerId && (i.container_id = n.containerId), n.containerName && (i.container_name = n.containerName), this.recordHistogram({
        name: "long_task.duration",
        value: n.duration,
        attributes: i
      });
    }), this._options.enableReportingObserver !== !1 && Gg((n) => {
      var o;
      const i = x(E({}, n.attributes), {
        [Xt]: window.location.pathname
      });
      if (n.kind === "log")
        this._recordLog(
          n.message,
          (o = n.level) != null ? o : "warn",
          i
        );
      else {
        const a = new Error(n.message);
        this.recordError(
          a,
          void 0,
          Object.fromEntries(
            Object.entries(i).map(([u, c]) => [
              u,
              c === void 0 ? "" : String(c)
            ])
          ),
          "reporting-observer",
          "custom"
        );
      }
    });
  }
  recordLog(t, r, n) {
    return this._recordLog(t, r, n);
  }
}
wt = new WeakMap();
class em extends lu {
  constructor(r) {
    super(r);
    b(this, "observe");
    b(this, "options");
    b(this, "exposureDeduper");
    this.options = r, this.exposureDeduper = new ih(
      r == null ? void 0 : r.flagExposureDedupeWindowMillis,
      r == null ? void 0 : r.flagExposureDedupeMaxSize
    );
  }
  initialize(r, n) {
    try {
      if (typeof window == "undefined" || typeof document == "undefined") {
        j(
          "warn",
          "@launchdarkly/observability is not initializing because it is not supported in this environment."
        );
        return;
      }
      if (!r) {
        j(
          "warn",
          "@launchdarkly/observability is not initializing because the SDK credential is undefined."
        );
        return;
      }
      this.configureSession(r, n), this.observe = new Vg(x(E({}, n), {
        projectId: r,
        sessionSecureId: this.sessionSecureID
      })), n != null && n.manualStart || this.observe.start(), Nu.load(this.observe);
    } catch (i) {
      Go(
        "Error initializing @launchdarkly/observability SDK",
        "error",
        i
      );
    }
  }
  getMetadata() {
    return {
      name: "@launchdarkly/observability"
    };
  }
  register(r, n) {
    var i;
    (i = this.observe) == null || i.register(r, n);
  }
  getHooks(r) {
    var i, o, a, u;
    const n = E(E({
      [Eu]: r.sdk.name,
      [mu]: r.sdk.version,
      [gu]: r.clientSideId,
      [yu]: "LaunchDarkly"
    }, (i = r.application) != null && i.id ? { [vu]: r.application.id } : {}), (o = r.application) != null && o.version ? {
      [_u]: r.application.version
    } : {});
    return this.initialize(
      (u = (a = r.sdkKey) != null ? a : r.mobileKey) != null ? u : r.clientSideId,
      this.options
    ), [
      {
        getMetadata: () => ({
          name: "@launchdarkly/observability/hooks"
        }),
        afterIdentify: (c, s, l) => {
          var d, h, _, p, v, y, m, w, A;
          for (const R of (_ = (h = (d = this.observe) == null ? void 0 : d.getHooks) == null ? void 0 : h.call(d, r)) != null ? _ : [])
            (p = R.afterIdentify) == null || p.call(R, c, s, l);
          const f = _i(c.context);
          if ((v = this.observe) == null || v.setLDContextKeyAttributes(f), l.status === "completed") {
            this.exposureDeduper.reset();
            const R = x(E({}, f), {
              key: (w = (m = (y = this.options) == null ? void 0 : y.contextFriendlyName) == null ? void 0 : m.call(
                y,
                c.context
              )) != null ? w : Pr(c.context),
              timeout: c.timeout,
              canonicalKey: Pr(c.context),
              [Au]: l.status
            });
            (A = this.observe) == null || A.recordLog("LD.identify", "info", E(E({}, n), R));
          }
          return s;
        },
        afterEvaluation: (c, s, l) => {
          var p, v, y, m, w, A, R, C, I;
          for (const P of (y = (v = (p = this.observe) == null ? void 0 : p.getHooks) == null ? void 0 : v.call(p, r)) != null ? y : [])
            (m = P.afterEvaluation) == null || m.call(P, c, s, l);
          const f = E({
            [Su]: c.flagKey,
            [du]: JSON.stringify(l.value)
          }, l.variationIndex !== void 0 && l.variationIndex !== null ? {
            [Tu]: l.variationIndex
          } : {});
          if (l.reason)
            for (const P in vi) {
              const V = P, Q = l.reason[V];
              Q != null && (f[vi[V]] = Q);
            }
          const d = c.context ? Pr(c.context) : void 0;
          c.context && (f[bu] = JSON.stringify(_i(c.context)), f[wu] = d);
          const h = [
            c.flagKey,
            JSON.stringify(l.value),
            (w = l.variationIndex) != null ? w : "",
            (R = (A = l.reason) == null ? void 0 : A.kind) != null ? R : "",
            (I = (C = l.reason) == null ? void 0 : C.ruleId) != null ? I : "",
            d != null ? d : ""
          ].join("|");
          if (!this.observe || !this.exposureDeduper.shouldRecord(h))
            return s;
          const _ = E(E({}, n), f);
          return this.observe.startSpan(pu, (P) => {
            P != null && P.isRecording() && (P.addEvent(hu, _), this.exposureDeduper.markRecorded(h));
          }), s;
        },
        afterTrack: (c) => {
          var f, d, h, _, p, v, y, m, w;
          for (const A of (h = (d = (f = this.observe) == null ? void 0 : f.getHooks) == null ? void 0 : d.call(f, r)) != null ? h : [])
            (_ = A.afterTrack) == null || _.call(A, c);
          if (!(((p = this.options) == null ? void 0 : p.productAnalytics) !== !1 && (typeof ((v = this.options) == null ? void 0 : v.productAnalytics) != "object" || this.options.productAnalytics.trackEvents !== !1)))
            return;
          const l = E(x(E(E({
            [ye]: window.location.href
          }, (m = (y = this.observe) == null ? void 0 : y.getLDContextKeyAttributes()) != null ? m : {}), n), {
            key: c.key,
            value: c.metricValue
          }), typeof c.data == "object" ? c.data : {});
          (w = this.observe) == null || w.startSpan(fu, (A) => {
            A && A.setAttributes(l);
          });
        }
      }
    ];
  }
}
export {
  Fo as A,
  Fu as C,
  xu as D,
  Yu as E,
  Qg as F,
  ag as J,
  X as M,
  Og as N,
  em as O,
  ug as P,
  Ag as W,
  Zg as X,
  zn as a,
  Zu as b,
  Qu as c,
  Kg as d,
  ju as e,
  Vy as f,
  Ig as g,
  $ as h,
  Vt as i,
  zt as j,
  Rg as k,
  dn as l,
  Jg as m,
  xa as n,
  go as o,
  hr as p,
  pn as r,
  Wy as s
};
//# sourceMappingURL=observe-D78YYNE1.js.map
